//latest
import React, { useState, useRef, useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import { Icon } from "@iconify/react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import {
  billTypeHeaderSelectStyles,
  billTypeHeaderSelectWrapStyle,
  createdByHeaderSelectStyles,
  createdByHeaderSelectWrapStyle,
} from "../utils/billTypeHeaderSelectStyles";
import "../assets/css/theme-table-header.css";
import toast, { Toaster } from "react-hot-toast";
import {
  setupPortalContainers,
  teardownPortalContainers,
} from "../utils/portalContainers";
import { getUserData, node_imageBaseUrl } from "./const";
import { useIndiaStateCity } from "../utils/useIndiaStateCity";
import {
  sanitizeMobileInput,
  mobileInputFieldProps,
} from "../utils/mobileInput";
import {
  listBankAccounts,
  listBillTypes,
  showSale,
  updateSale,
  listCustomerUsers,
  showCustomerUser,
  createCustomerUser,
  listProducts,
  showProducts,
  isErpApiSuccess,
  getErpAuthState,
} from "../erpClient";
import { useHrmsEmployees } from "../hooks/useHrmsEmployees";
import {
  getLegacySaleDetailsFromShowResponse,
  isSalesApiSuccess,
  createSalesIdempotencyKey,
  mapItemRateOn,
  mapLbrTypeForApi,
  resolveSaleByUserId,
  resolveSaleByUserName,
} from "../utils/salesErpAdapter";
import {
  readPaymentIdempotencyKeyFromApi,
  resolvePaymentLineIdempotencyKey,
} from "../utils/paymentIdempotency";
import {
  buildStandardPaymentLines,
  mapApiPaymentToUiRow,
  parseApiPaymentAmount,
  ensurePaymentRowInList,
  applyUrdLinkToPaymentRows,
} from "../utils/paymentLinesErpAdapter";
import {
  createSaleDraftKey,
  loadSaleDraft,
  saveSaleDraft,
  clearSaleDraft,
} from "../utils/saleDraftSession";

import { getActiveItems } from "../utils/statusUtils";
import { useLocation, useNavigate } from "react-router-dom";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";
import OtherAmountModal from "../components/OtherAmountModal";
import {
  calculateOtherAmountAmount as calculateAmount,
  calculateOtherAmountLessWeight as calculateLessWeight,
  sumOtherAmountEntries,
  mapApiChargesToOtherAmountEntries,
  mapOtherAmountEntriesForUpdate,
} from "../utils/otherAmountCalculations";
import { handleRoundOffInputChange } from "../utils/roundOffInput";
import { roundLineTotalAmount } from "../utils/autoRoundOff";
import {
  mergeProductGroupOptions,
  searchProductGroupSelectOptions,
  fetchProductGroupOptionById,
  productGroupOptionDisplayName,
} from "../utils/productGroupOptions";
import { numPool } from "../utils/productGroupPool";
import ProductGroupPoolBalance from "../components/ProductGroupPoolBalance";
import PaymentSection, {
  PAYMENT_METHOD_LABELS,
} from "../components/PaymentSection";
import OldPurchaseModal from "../components/OldPurchaseModal";

const EDIT_INVOICE_FETCH_DEDUPE_MS = 2000;

let billTypesFetchPromise = null;
let billTypesFetchCache = null;
let billTypesFetchCacheAt = 0;

let saleShowFetchPromise = null;
let saleShowFetchCache = null;
let saleShowFetchCacheId = null;
let saleShowFetchCacheAt = 0;

async function requestBillTypesForEdit({ force = false } = {}) {
  const now = Date.now();

  if (!force) {
    if (billTypesFetchPromise) return billTypesFetchPromise;
    if (
      billTypesFetchCache &&
      now - billTypesFetchCacheAt < EDIT_INVOICE_FETCH_DEDUPE_MS
    ) {
      return billTypesFetchCache;
    }
  } else {
    billTypesFetchPromise = null;
    billTypesFetchCache = null;
    billTypesFetchCacheAt = 0;
  }

  billTypesFetchPromise = listBillTypes()
    .then((res) => {
      if (isErpApiSuccess(res)) {
        billTypesFetchCache = res;
        billTypesFetchCacheAt = Date.now();
      }
      return res;
    })
    .finally(() => {
      billTypesFetchPromise = null;
    });

  return billTypesFetchPromise;
}

async function requestSaleShowForEdit(saleId, { force = false } = {}) {
  const id = String(saleId);
  const now = Date.now();

  if (!force) {
    if (saleShowFetchPromise) return saleShowFetchPromise;
    if (
      saleShowFetchCache &&
      saleShowFetchCacheId === id &&
      now - saleShowFetchCacheAt < EDIT_INVOICE_FETCH_DEDUPE_MS
    ) {
      return saleShowFetchCache;
    }
  } else {
    saleShowFetchPromise = null;
    saleShowFetchCache = null;
    saleShowFetchCacheId = null;
    saleShowFetchCacheAt = 0;
  }

  saleShowFetchPromise = showSale({ id: saleId })
    .then((res) => {
      if (isSalesApiSuccess(res)) {
        saleShowFetchCache = res;
        saleShowFetchCacheId = id;
        saleShowFetchCacheAt = Date.now();
      }
      return res;
    })
    .finally(() => {
      saleShowFetchPromise = null;
    });

  return saleShowFetchPromise;
}

const EditInvoice = ({ masterGoldRate, masterSilverRate, showLiveRate = false }) => {
  const navigate = useNavigate();
  const { buttonClass, tableClass, cardClass, buttonTableStyle } =
    useButtonTableStyle();
  const location = useLocation();
  const saleDraftKeyRef = useRef(null);
  const productGroupOptionsCacheRef = useRef([]);
  const productGroupUserSearchRef = useRef(false);

  useEffect(() => {
    const urdPayment = location.state?.urdPayment;
    if (!urdPayment?.urd_document_id) return;

    const draftKey = location.state?.saleDraftKey;
    let draftPaymentRows = null;
    if (draftKey) {
      const draft = loadSaleDraft(draftKey);
      if (draft) {
        draftPaymentRows = draft.paymentRows;
        if (draft.tableData) setTableData(draft.tableData);
        if (draft.selecteduserssId != null) {
          setSelecteduserssId(draft.selecteduserssId);
        }
        saleDraftKeyRef.current = draftKey;
      }
      clearSaleDraft(draftKey);
    }

    const returnedCustomerId = Number(
      urdPayment.customer_id ?? urdPayment.customerId,
    );
    if (Number.isFinite(returnedCustomerId) && returnedCustomerId > 0) {
      setSelecteduserssId(returnedCustomerId);
      setusersss((prev) => {
        const list = Array.isArray(prev) ? prev : [];
        const withoutTemp = list.filter(
          (u) => !String(u?.id ?? "").startsWith("TEMP_"),
        );
        const idx = withoutTemp.findIndex(
          (u) => String(u.id) === String(returnedCustomerId),
        );
        const entry = {
          id: returnedCustomerId,
          fullName: userssName || userssNameSearchText || "",
          name: userssName || userssNameSearchText || "",
          mobile: userssMobile || userssMobileSearchText || "",
        };
        if (idx >= 0) {
          const updated = [...withoutTemp];
          updated[idx] = { ...updated[idx], ...entry };
          return updated;
        }
        return [...withoutTemp, entry];
      });
    }

    setPaymentRows((prev) =>
      applyUrdLinkToPaymentRows(draftPaymentRows ?? prev, urdPayment),
    );

    toast.success("URD linked to sale payment");
    navigate(location.pathname, { replace: true, state: {} });
  }, [location.state?.urdPayment, location.pathname, navigate]);

  const { selectedItemIds, selectedInvoices } = location.state || {};

  // Add new state variables
  const [followUpDate, setFollowUpDate] = useState("");
  const [finalAmount, setFinalAmount] = useState("0.00");
  const [grandTotal, setGrandTotal] = useState("0.00");
  const [remainingAmount, setRemainingAmount] = useState("0.00");
  const [discountAmount, setDiscountAmount] = useState("0.00");
  const [gstAmount, setGstAmount] = useState("0.00");
  const savedGstAmountRef = useRef(null);
  const savedGstKeyRef = useRef(null);
  const [sgstAmount, setSgstAmount] = useState("0.00");
  const [cgstAmount, setCgstAmount] = useState("0.00");
  const [igstAmount, setIgstAmount] = useState("0.00");
  const [saleId, setSaleId] = useState(selectedItemIds?.[0] || "");
  const [saleStatus, setSaleStatus] = useState("Pending");
  const [gstAmts, setGstAmts] = useState({
    total: 0,
    sgst: 0,
    cgst: 0,
    igst: 0,
  });
  const userData = getUserData();
  // Helper function to convert ISO datetime string to yyyy-MM-dd format for date inputs
  const formatDateForInput = (dateValue) => {
    if (!dateValue) return "";

    // If already in yyyy-MM-dd format, return as is
    if (
      typeof dateValue === "string" &&
      /^\d{4}-\d{2}-\d{2}$/.test(dateValue)
    ) {
      return dateValue;
    }

    // Try to parse as Date and format
    try {
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return "";

      // Format as yyyy-MM-dd
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    } catch (error) {
      console.warn("Error formatting date:", dateValue, error);
      return "";
    }
  };

  // Load sale by id only (lists may be empty on first paint; we hydrate from the sale payload).
  const inferMetalFromProductGroupLabel = (label) => {
    const s = String(label || "").toLowerCase();
    if (s.includes("gold")) return "Gold";
    if (s.includes("silver")) return "Silver";
    if (s.includes("platinum")) return "Platinum";
    return "";
  };

  /** Seed product-group cache from showSale items (no list/show API on load). */
  const seedProductGroupsFromSaleItems = (sales) => {
    if (!Array.isArray(sales) || sales.length === 0) return;
    const byId = new Map();
    sales.forEach((sale) => {
      const rawPid = sale.product_group_id ?? sale.product_group;
      const pid =
        rawPid != null &&
        rawPid !== "" &&
        Number.isFinite(Number(rawPid)) &&
        Number(rawPid) > 0
          ? rawPid
          : null;
      if (pid == null) return;
      const id = Number(pid);
      if (!Number.isFinite(id) || id <= 0) return;
      if (byId.has(id)) return;
      const name = String(sale.product_group_name || "").trim();
      const label = name || String(id);
      byId.set(id, {
        value: id,
        label,
        short_code: sale.short_code || "",
        purity: "",
        metal: inferMetalFromProductGroupLabel(label),
      });
    });
    const list = Array.from(byId.values());
    if (list.length === 0) return;

    productGroupOptionsCacheRef.current = mergeProductGroupOptions(
      productGroupOptionsCacheRef.current,
      list,
    );
  };

  const fetchInvoiceById = async () => {
    const saleId = selectedItemIds?.[0];
    if (saleId == null || saleId === "") {
      return;
    }

    productGroupUserSearchRef.current = false;
    setLastSearchedProductGroupPrefix("");
    setProductGroupApiCalled(false);
    setProductGroupPoolHeader(null);
    setDropdownData((prev) => ({ ...prev, productGroup: [] }));

    try {
      const productGroupsToUse = dropdownData.productGroup || [];
      const usersssToUse = usersss || [];

      const response = await requestSaleShowForEdit(saleId);

      // console.log("Sales Invoice Details Response:", response);

      if (isSalesApiSuccess(response)) {
        const saleDetails = getLegacySaleDetailsFromShowResponse(response);
        if (!saleDetails) {
          toast.error("Invalid sale details response");
          return;
        }

        // Set date - format it properly for date input
        setBillDate(formatDateForInput(saleDetails.date));

        // Created By (employee who created the sale)
        {
          const byUserId = resolveSaleByUserId(saleDetails);
          if (byUserId) {
            const resolvedName = resolveSaleByUserName(saleDetails);
            const byName =
              resolvedName !== "N/A" ? resolvedName : `User #${byUserId}`;
            setCreatedBy({ value: byUserId, label: byName });
          } else {
            setCreatedBy(null);
          }
        }

        // Set userss details - First check if userss object exists, otherwise use user_id
        if (saleDetails.userss) {
          // userss object exists in response
          setuserssMobile(saleDetails.userss.mobile);
          setuserssMobileSearchText(saleDetails.userss.mobile);
          setuserssName(saleDetails.userss.fullName);
          setuserssNameSearchText(saleDetails.userss.fullName);
          setuserssAddress(saleDetails.userss.address);
          setuserssArea(saleDetails.userss.area || "");
          setuserssCity(saleDetails.userss.city);
          setSelecteduserssId(saleDetails.userss.id);

          // Set userss details with balance information
          setuserssDetails({
            email: saleDetails.userss.email || "",
            birthDate: formatDateForInput(saleDetails.userss.birth_date) || "",
            anniversaryDate:
              formatDateForInput(saleDetails.userss.anniversary_date) || "",
            companyName: saleDetails.userss.company_name || "",
            companyAddress: saleDetails.userss.company_address || "",
            gstNumber: saleDetails.userss.GST_number || "",
            aadharNo: saleDetails.userss.aadhar_no || "",
            panNo: saleDetails.userss.pan_no || "",
            maritalStatus: saleDetails.userss.marital_status || "",
            balance: saleDetails.userss.users_balance ?? saleDetails.userss.balance ?? "",
            finalBalance: saleDetails.userss.final_balance || "",
            saleBalance: saleDetails.userss.sale_balance || "",
            reference: saleDetails.userss.reference || "",
            state: saleDetails.userss.state || "",
          });
        } else if (saleDetails.user_id && usersssToUse.length > 0) {
          // Find userss by user_id
          const userssId = saleDetails.user_id;
          const matcheduserss = usersssToUse.find(
            (userss) => userss.id == userssId,
          );

          if (matcheduserss) {
            setuserssMobile(matcheduserss.mobile);
            setuserssMobileSearchText(matcheduserss.mobile);
            setuserssName(matcheduserss.fullName);
            setuserssNameSearchText(matcheduserss.fullName);
            setuserssAddress(matcheduserss.address);
            setuserssArea(matcheduserss.area || "");
            setuserssCity(matcheduserss.city);
            setSelecteduserssId(matcheduserss.id);

            // Set userss details with balance information
            setuserssDetails({
              email: matcheduserss.email || "",
              birthDate: formatDateForInput(matcheduserss.birthDate) || "",
              anniversaryDate:
                formatDateForInput(matcheduserss.anniversaryDate) || "",
              companyName: matcheduserss.companyName || "",
              companyAddress: matcheduserss.companyAddress || "",
              gstNumber: matcheduserss.gstNumber || "",
              aadharNo: matcheduserss.aadharNo || "",
              panNo: matcheduserss.panNo || "",
              maritalStatus: matcheduserss.maritalStatus || "",
              balance: matcheduserss.balance || "",
              finalBalance: matcheduserss.finalBalance || "",
              saleBalance: matcheduserss.saleBalance || "",
              reference: matcheduserss.reference || "",
              state: matcheduserss.state || "",
            });
          } else {
            console.warn(
              `userss with ID ${userssId} not found in usersss array`,
            );
            // Clear userss fields if no match found
            setuserssMobile("");
            setuserssMobileSearchText("");
            setuserssName("");
            setuserssNameSearchText("");
            setuserssAddress("");
            setuserssArea("");
            setuserssCity("");
            setSelecteduserssId("");

            // Clear userss details
            setuserssDetails({
              email: "",
              birthDate: "",
              anniversaryDate: "",
              companyName: "",
              companyAddress: "",
              gstNumber: "",
              aadharNo: "",
              panNo: "",
              maritalStatus: "",
              balance: "",
              finalBalance: "",
              saleBalance: "",
              reference: "",
              state: "",
            });
          }
        } else {
          // No userss data available
          setuserssMobile("");
          setuserssMobileSearchText("");
          setuserssName("");
          setuserssNameSearchText("");
          setuserssAddress("");
          setuserssArea("");
          setuserssCity("");
          setSelecteduserssId("");

          // Clear userss details
          setuserssDetails({
            email: "",
            birthDate: "",
            anniversaryDate: "",
            companyName: "",
            companyAddress: "",
            gstNumber: "",
            aadharNo: "",
            panNo: "",
            maritalStatus: "",
            balance: "",
            finalBalance: "",
            saleBalance: "",
            reference: "",
            state: "",
          });
        }

        const customerId =
          saleDetails.customer_id ??
          saleDetails.userss?.id ??
          saleDetails.user_id ??
          null;
        const billedToId = saleDetails.billed_to_id;
        const sameBilledCustomer =
          billedToId == null ||
          billedToId === "" ||
          String(billedToId) === String(customerId);
        setBilledTo(sameBilledCustomer);
        if (sameBilledCustomer) {
          setBilledMobile("");
          setBilledName("");
          setBilledAddress("");
          setBilledArea("");
        } else {
          const person = saleDetails.billedTo || {};
          setBilledMobile(person.mobile || "");
          setBilledName(person.name || "");
          setBilledAddress(person.address || "");
          setBilledArea(person.area || "");
          if (!person.mobile && !person.name) {
            showCustomerUser({ id: billedToId })
              .then((response) => {
                const customer =
                  response?.data?.customer ??
                  response?.data?.customer_user ??
                  response?.data;
                if (!customer) return;
                setBilledMobile(customer.mobile || "");
                setBilledName(customer.name || customer.fullName || "");
                setBilledAddress(customer.address || "");
                setBilledArea(customer.area || "");
              })
              .catch((error) => {
                console.error("Error loading billed to customer:", error);
              });
          }
        }

        // Set other form fields
        setDiscountValue(saleDetails.discount);
        const saleBillTypeId =
          saleDetails.bill_type_id ??
          saleDetails.bill_type ??
          saleDetails.billTypeId ??
          null;
        const saleBillTypeName = String(
          saleDetails.bill_type_name ??
            saleDetails.bill_type_label ??
            saleDetails.billTypeName ??
            "",
        ).trim();
        const saleEstimate =
          saleDetails.estimate ??
          saleDetails.is_estimate ??
          saleDetails.estimate_flag ??
          null;
        const selectedFromApi =
          billTypes.find(
            (item) =>
              (saleBillTypeId != null &&
                String(item.id) === String(saleBillTypeId)) ||
              (saleBillTypeName &&
                item.name.toLowerCase() === saleBillTypeName.toLowerCase()),
          ) || null;
        if (selectedFromApi) {
          selectedBillTypeIdRef.current = String(selectedFromApi.id);
          setSelectedBillTypeId(String(selectedFromApi.id));
          setSelectedBillTypeName(selectedFromApi.name || "GST");
          setEstimateValue(
            saleEstimate != null
              ? Number(saleEstimate) || 0
              : selectedFromApi.name.toLowerCase() === "quotation"
                ? 1
                : 0,
          );
        } else if (saleBillTypeId != null || saleBillTypeName) {
          selectedBillTypeIdRef.current =
            saleBillTypeId != null ? String(saleBillTypeId) : "";
          setSelectedBillTypeId(
            saleBillTypeId != null ? String(saleBillTypeId) : "",
          );
          setSelectedBillTypeName(saleBillTypeName || "GST");
          setEstimateValue(
            saleEstimate != null
              ? Number(saleEstimate) || 0
              : saleBillTypeName.toLowerCase() === "quotation"
                ? 1
                : 0,
          );
        } else if (saleEstimate != null) {
          setEstimateValue(Number(saleEstimate) || 0);
        }
        const effectiveBillTypeName = (
          selectedFromApi?.name ||
          saleBillTypeName ||
          "GST"
        ).toLowerCase();
        setGstPercentage(
          effectiveBillTypeName === "quotation"
            ? "0"
            : String(saleDetails.gst_percent ?? "3"),
        );
        setRoundOffAmount(saleDetails.round_off);
        setNote(saleDetails.note ?? saleDetails.notes ?? "");
        setFollowUpDate(formatDateForInput(saleDetails.followup_date));

        // Set sale ID and status
        setSaleId(saleDetails.id);
        setSaleStatus(saleDetails.status || "Pending");

        // Set GST amounts
        setGstAmts({
          total: Number(saleDetails.gst_amount) || 0,
          sgst: Number(saleDetails.sgst) || 0,
          cgst: Number(saleDetails.cgst) || 0,
          igst: Number(saleDetails.igst) || 0,
        });

        // Set table data with product group name lookup AND INCLUDE IDs
        if (saleDetails.sales && saleDetails.sales.length > 0) {
          const newTableData = saleDetails.sales.map((sale, index) => ({
            id: index + 1,
            data: COLUMNS.map((col) => {
              let value = "";
              switch (col.id) {
                case "no":
                  value = index + 1; // Serial number
                  break;
                case "tagNo":
                  value = sale.tag_no || "";
                  break;
                case "productGroup":
                  // Find the product group name by ID
                  const productGroupId = sale.product_group;
                  const matchedProductGroup = productGroupsToUse.find(
                    (pg) => pg.value == productGroupId,
                  );
                  if (matchedProductGroup) {
                    value = matchedProductGroup.label;
                  } else {
                    const pgName = String(sale.product_group_name ?? "").trim();
                    value =
                      pgName ||
                      (productGroupId != null ? String(productGroupId) : "");
                  }
                  break;
                case "design":
                  value = sale.design || "";
                  break;
                case "size":
                  value = sale.size || "";
                  break;
                case "pcs":
                  value = sale.pcs || "";
                  break;
                case "grWt":
                  value = parseFloat(sale.gwt || 0).toFixed(2);
                  break;
                case "lsWt":
                  value = parseFloat(sale.lwt || 0).toFixed(2);
                  break;
                case "netWt":
                  value = parseFloat(sale.nwt || 0).toFixed(2);
                  break;
                case "itRateOn":
                  value = sale.itrateon || "";
                  break;
                case "itRate":
                  value = parseFloat(sale.itrate || 0).toFixed(2);
                  break;
                case "itAmt":
                  value = parseFloat(sale.itamt || 0).toFixed(2);
                  break;
                case "lType":
                  value = sale.lbr_type || "";
                  break;
                case "lbrPercentage":
                  value = parseFloat(sale.lbr_percent || 0).toFixed(2);
                  break;
                case "lbrRate":
                  value = parseFloat(sale.lbr_rate || 0).toFixed(2);
                  break;
                case "lbrAmt":
                  value = parseFloat(sale.lbr_amt || 0).toFixed(2);
                  break;
                case "othAmt":
                  value = parseFloat(sale.othamt || 0).toFixed(2);
                  break;
                case "mrp":
                  value = parseFloat(sale.mrp || 0).toFixed(2);
                  break;
                case "image":
                  value = sale.image || "";
                  break;
                case "totalAmt":
                  value = roundLineTotalAmount(sale.totalamt || 0);
                  break;
                // CRITICAL: Store the sales item ID
                case "saleItemId":
                  value = sale.id || ""; // This is the sales item ID (441, 440, etc.)
                  break;
                default:
                  value = sale[col.id.toLowerCase()] || "";
                  break;
              }

              const currentImagePreview =
                col.id === "image"
                  ? sale.image
                    ? `${node_imageBaseUrl}/${sale.image}`
                    : null
                  : null;

              // Base cell object
              const cellData = {
                id: col.id,
                value: value.toString(),
              };

              // Add image-specific properties
              if (col.id === "image") {
                cellData.imageFile = null;
                cellData.imagePreview = currentImagePreview;
              }

              // Preserve ERP product group id for submit when dropdown list is empty (show-sale-only load)
              if (col.id === "productGroup") {
                const rawPgId =
                  sale.product_group_id != null && sale.product_group_id !== ""
                    ? sale.product_group_id
                    : null;
                const pg = sale.product_group;
                const numericFromPg =
                  pg != null &&
                  String(pg).trim() !== "" &&
                  /^-?\d+(\.\d+)?$/.test(String(pg).trim()) &&
                  Number.isFinite(Number(pg))
                    ? Number(pg)
                    : null;
                const resolvedId =
                  rawPgId != null && rawPgId !== ""
                    ? Number(rawPgId)
                    : numericFromPg;
                if (
                  resolvedId != null &&
                  !Number.isNaN(resolvedId) &&
                  resolvedId > 0
                ) {
                  cellData.productGroupId = resolvedId;
                }
              }

              // CRITICAL: Add sales item ID to ALL cells for easy access
              if (col.id !== "saleItemId") {
                cellData.saleItemId = sale.id; // Store the sales item ID in each cell
              }

              // Add other amount entries with charge IDs
              if (col.id === "othAmt") {
                cellData.otherAmountEntries = mapApiChargesToOtherAmountEntries(
                  sale.charges,
                );
              }

              return cellData;
            }),
          }));

          setTableData(newTableData);
          seedProductGroupsFromSaleItems(saleDetails.sales);
        }

        const oldList = Array.isArray(saleDetails.old_purchase)
          ? saleDetails.old_purchase
          : Array.isArray(saleDetails.old_purchase_details)
            ? saleDetails.old_purchase_details
            : Array.isArray(saleDetails.old_metal_details)
              ? saleDetails.old_metal_details
              : [];
        if (oldList.length > 0) {
          setOldPurchases(oldList);
        }

        // Set payment rows from standard API payment contract
        if (saleDetails.payments && saleDetails.payments.length > 0) {
          const newPaymentRows = saleDetails.payments.map((payment, index) => {
            const rowData = mapApiPaymentToUiRow(payment, index, {
              paymentTypes,
              formatAmountFixed2: true,
            });

            const paymentDate = rowData.date
              ? formatDateForInput(rowData.date)
              : billDate || new Date().toISOString().split("T")[0];

            const amountNum = parseApiPaymentAmount(payment);
            const amountDisplay =
              amountNum !== "" ? Number(amountNum).toFixed(2) : "";

            const matchedOldPurchase = oldList.find((op) => {
              const opId = Number(op.id ?? op.urd_document_id ?? op.old_metal_purchase_document_id);
              const pUrdId = Number(payment.urd_document_id ?? payment.urdDocumentId);
              if (opId > 0 && pUrdId > 0 && opId === pUrdId) return true;
              return false;
            });

            return {
              ...rowData,
              id: payment.id ?? rowData.id,
              date: paymentDate,
              isExistingPayment: !!payment.id,
              amount: amountDisplay || rowData.amount,
              urd_data: matchedOldPurchase || undefined,
            };
          });

          setPaymentRows(newPaymentRows);
        }

        const apiPayables = Array.isArray(saleDetails.sale_payable)
          ? saleDetails.sale_payable
          : [];
        if (apiPayables.length > 0) {
          const mappedPayables = apiPayables.map((payable, index) => {
            const rowData = mapApiPaymentToUiRow(payable, index, {
              paymentTypes,
              formatAmountFixed2: true,
            });
            const amountNum = parseApiPaymentAmount(payable);
            const amountDisplay =
              amountNum !== "" ? Number(amountNum).toFixed(2) : "";
            return {
              ...rowData,
              id: payable.id ?? rowData.id,
              isExistingPayment: !!payable.id,
              amount: amountDisplay || rowData.amount,
            };
          });
          setPayableRows(mappedPayables);
        }

        // Set final amounts
        setFinalAmount(saleDetails.final_amount);
        setGrandTotal(saleDetails.grand_total);
        setRemainingAmount(saleDetails.remaining_amount);
        setDiscountAmount(saleDetails.discount_amount);
        const loadedGst = Number(saleDetails.gst_amount ?? saleDetails.tax_amount);
        savedGstAmountRef.current = Number.isFinite(loadedGst) ? loadedGst : null;
        savedGstKeyRef.current = null;
        setGstAmount(saleDetails.gst_amount);
        setSgstAmount(saleDetails.sgst);
        setCgstAmount(saleDetails.cgst);
        setIgstAmount(saleDetails.igst);
      } else {
        console.error("Failed to fetch invoice:", response?.message);
        toast.error(response?.message || "Failed to load invoice");
      }
    } catch (error) {
      console.error("Error fetching invoice:", error);
      toast.error("Failed to load invoice");
    }
  };

  // Function to fetch sales data from the new API endpoint
  // const fetchSalesData = async () => {
  //   try {
  //     const response = await axios.post(
  //       "https://api-syn.vedascodetech.in/api/sales",
  //       {
  //         type: "show",
  //         id: selectedItemIds[0],
  //       },
  //       {
  //         headers: {
  //           Authorization:
  //             "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJyb2xlIjoiQURNSU4iLCJpYXQiOjE3NjY5ODIyNDgsImV4cCI6MTc2Nzg0NjI0OH0.vKhw6HUx_EIhQLPexsXN-kiKyQrBXML5Ei3B_3bGGvM",
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     console.log("Sales node API Response:", response.data);
  //   } catch (error) {
  //     console.error("Error fetching sales data:", error);
  //     console.error("Error details:", error.response?.data || error.message);
  //   }
  // };

  // Listen for API URL changes - navigate back to table
  useEffect(() => {
    const handleApiUrlChange = (event) => {
      console.log(
        "API URL changed in EditInvoice, navigating back...",
        event.detail,
      );
      toast("Database switched. Returning to invoice table.");
      navigate("/invoice");
    };

    window.addEventListener("apiUrlChanged", handleApiUrlChange);

    return () => {
      window.removeEventListener("apiUrlChanged", handleApiUrlChange);
    };
  }, [navigate]);

  const saleIdForInitialLoad = selectedItemIds?.[0];
  useEffect(() => {
    if (saleIdForInitialLoad == null || saleIdForInitialLoad === "") {
      return;
    }
    void fetchInvoiceById();
  }, [saleIdForInitialLoad]);

  // useEffect to fetch sales data from the new API endpoint
  // useEffect(() => {
  //   fetchSalesData();
  // }, []);

  // Add new function to calculate per gram rate
  const calculatePerGramRate = (rate, metalType) => {
    return rate;
  };

  // Calculate rate based on purity
  const calculatePurityBasedRate = (purity, rate, metalType) => {
    // Extract the karat/purity value from string (e.g. "18K" -> 18 or "925" -> 925)
    const purityValue = parseFloat(purity);
    if (isNaN(purityValue)) return rate;

    if (metalType === "Gold") {
      return rate * (purityValue / 24);
    } else if (metalType === "Silver") {
      return (rate * purityValue) / 999;
    }

    return rate;
  };

  const COLUMNS = [
    { id: "no", label: "No.", width: "20px", value: (row) => row.no },
    {
      id: "tagNo",
      label: "Tag No",
      width: "100px",
      value: (row, onChange) => {
        const filtered = getFilteredItems(row.tagNo || "", "tagNo");
        const visibleItems = Math.min(filtered.length, 5);
        const dropdownHeight = visibleItems * 35;
        return (
          <div className="position-relative">
            <input
              type="text"
              value={row.tagNo}
              onChange={(e) => {
                const newTagNo = e.target.value;
                onChange(row.id, "tagNo", newTagNo);
              }}
              onFocus={(e) => {
                const rowIndex = tableData.findIndex((r) => r.id === row.id);
                const colIndex = tableData[rowIndex].data.findIndex(
                  (cell) => cell.id === "tagNo",
                );
                handleFocus(rowIndex, colIndex);
              }}
              className={`form-control ${buttonClass}`}
              placeholder="Enter tag number"
            />
            {activeDropdown.row ===
              tableData.findIndex((r) => r.id === row.id) &&
              activeDropdown.col ===
                tableData[
                  tableData.findIndex((r) => r.id === row.id)
                ].data.findIndex((cell) => cell.id === "tagNo") &&
              activeDropdown.type === "tagNo" && (
                <div
                  className="dropdown-menu show"
                  style={{
                    minWidth: "100px",
                    width: "max-content",
                    maxWidth: "min(90vw, 420px)",
                    maxHeight: `${dropdownHeight}px`,
                    height: `${dropdownHeight}px`,
                    overflowY: filtered.length > 5 ? "auto" : "hidden",
                    overflowX: "auto",
                  }}
                >
                  {filtered.length > 0 ? (
                    filtered.map((item, index) => (
                      <div
                        key={item.value}
                        className={`dropdown-item ${
                          index === highlightedIndex ? "active" : ""
                        }`}
                        onClick={() => {
                          onChange(row.id, "tagNo", item.label);
                          setActiveDropdown({
                            row: null,
                            col: null,
                            type: null,
                          });
                        }}
                        ref={(el) => (dropdownItemsRef.current[index] = el)}
                        title={item.label}
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "visible",
                          textOverflow: "clip",
                        }}
                      >
                        {item.label}
                      </div>
                    ))
                  ) : (
                    <div
                      className="dropdown-item text-muted"
                      style={{ cursor: "default" }}
                    >
                      No matching items
                    </div>
                  )}
                </div>
              )}
          </div>
        );
      },
    },

    {
      id: "productGroup",
      label: "Product Group",
      width: "160px",
      value: (row, onChange) => (
        <input
          type="text"
          value={row.productGroup}
          onChange={(e) => onChange(row.id, "productGroup", e.target.value)}
        />
      ),
    },
    {
      id: "design",
      label: "Design",
      width: "80px",
      value: (row, onChange) => (
        <input
          type="text"
          value={row.design}
          onChange={(e) => onChange(row.id, "design", e.target.value)}
        />
      ),
    },
    {
      id: "size",
      label: "Size",
      width: "40px",
      value: (row, onChange) => (
        <input
          type="text"
          value={row.size}
          onChange={(e) => onChange(row.id, "size", e.target.value)}
        />
      ),
    },
    {
      id: "pcs",
      label: "Pcs",
      width: "50px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.pcs}
          onChange={(e) => onChange(row.id, "pcs", e.target.value)}
        />
      ),
    },
    {
      id: "grWt",
      label: "Gr.Wt",
      width: "80px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.grWt}
          onChange={(e) => onChange(row.id, "grWt", e.target.value)}
        />
      ),
    },
    {
      id: "lsWt",
      label: "Ls.Wt",
      width: "80px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.lsWt}
          onChange={(e) => onChange(row.id, "lsWt", e.target.value)}
        />
      ),
    },
    {
      id: "netWt",
      label: "Net.Wt",
      width: "80px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.netWt}
          onChange={(e) => onChange(row.id, "netWt", e.target.value)}
        />
      ),
    },
    {
      id: "itRateOn",
      label: "RateOn",
      width: "80px",
      value: (row, onChange) => (
        <input
          type="text"
          value={row.itRateOn}
          onChange={(e) => onChange(row.id, "itRateOn", e.target.value)}
        />
      ),
    },
    {
      id: "itRate",
      label: "Rate",
      width: "90px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.itRate}
          onChange={(e) => onChange(row.id, "itRate", e.target.value)}
        />
      ),
    },
    {
      id: "itAmt",
      label: "Amount",
      width: "90px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.itAmt}
          onChange={(e) => onChange(row.id, "itAmt", e.target.value)}
        />
      ),
    },
    {
      id: "lType",
      label: "Lbr On",
      width: "40px",
      value: (row, onChange) => (
        <input
          type="text"
          value={row.lType}
          onChange={(e) => onChange(row.id, "lType", e.target.value)}
        />
      ),
    },
    {
      id: "lbrPercentage",
      label: "Lbr %",
      width: "70px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.lbrPercentage}
          onChange={(e) => onChange(row.id, "lbrPercentage", e.target.value)}
        />
      ),
    },
    {
      id: "lbrRate",
      label: "L.Rate",
      width: "90px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.lbrRate}
          onChange={(e) => onChange(row.id, "lbrRate", e.target.value)}
        />
      ),
    },
    {
      id: "lbrAmt",
      label: "L.Amount",
      width: "90px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.lbrAmt}
          onChange={(e) => onChange(row.id, "lbrAmt", e.target.value)}
        />
      ),
    },
    {
      id: "othAmt",
      label: "Other",
      width: "120px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.othAmt}
          onChange={(e) => onChange(row.id, "othAmt", e.target.value)}
        />
      ),
    },
    {
      id: "mrp",
      label: "MRP",
      width: "90px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.mrp}
          onChange={(e) => onChange(row.id, "mrp", e.target.value)}
        />
      ),
    },
    {
      id: "image",
      label: "Image",
      width: "80px",
      value: (row, onChange) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          {row.imagePreview && ( // Use imagePreview here
            <img
              src={row.imagePreview} // Direct use of imagePreview
              alt="Product"
              style={{
                width: "50px",
                height: "50px",
                objectFit: "cover",
                border: "1px solid #ddd",
                borderRadius: "4px",
              }}
              onError={(e) => {
                e.target.onerror = null; // Prevent infinite loop
                e.target.src =
                  "https://i.ibb.co/rKZrvh64/jewellery-showcase.png"; // Fallback image
              }}
            />
          )}
          <input
            type="text"
            value={row.image}
            onChange={(e) => onChange(row.id, "image", e.target.value)}
            style={{ fontSize: "12px" }}
          />
        </div>
      ),
    },
    {
      id: "totalAmt",
      label: "TotalAmt",
      width: "100px",
      value: (row, onChange) => (
        <input
          type="number"
          value={row.totalAmt}
          onChange={(e) => onChange(row.id, "totalAmt", e.target.value)}
        />
      ),
    },
  ];

  function persistSaleDraftForUrd(urdRow, rowsOverride) {
    const key = saleDraftKeyRef.current || createSaleDraftKey();
    saleDraftKeyRef.current = key;
    const mergedPaymentRows =
      rowsOverride ?? ensurePaymentRowInList(paymentRows, urdRow);
    saveSaleDraft(key, {
      paymentRows: mergedPaymentRows,
      tableData,
      selecteduserssId,
      saleId,
    });
    return key;
  }

  function openUrdFromPaymentRow(row) {
    const customerId = selecteduserssId;
    if (!customerId) {
      toast.error("Please select a customer before adding Old Gold/Silver URD");
      return;
    }
    const mergedPaymentRows = ensurePaymentRowInList(paymentRows, row);
    setPaymentRows(mergedPaymentRows);

    setUrdModalState({
      isOpen: true,
      payMode: row.pay_mode || "old_gold",
      row,
    });
  }

  const handleSaveUrdPurchase = (urdData) => {
    setPaymentRows((prev) => {
      return prev.map((r) => {
        if (
          (urdData.paymentRowId != null && r.id === urdData.paymentRowId) ||
          r.pay_mode === urdData.pay_mode
        ) {
          return {
            ...r,
            amount: Number(urdData.grand_total).toFixed(2),
            urd_data: urdData,
          };
        }
        return r;
      });
    });

    setOldPurchases((prev) => {
      const filtered = prev.filter(
        (p) =>
          p.paymentRowId !== urdData.paymentRowId &&
          p.pay_mode !== urdData.pay_mode,
      );
      return [...filtered, urdData];
    });

    setUrdModalState((prev) => ({ ...prev, isOpen: false }));
    toast.success("URD purchase details saved");
  };

  // Fetch usersss from API
  const fetchuserss = async () => {
    try {
      const response = await listCustomerUsers({ search: "" });
      const rows = Array.isArray(response?.data?.customers)
        ? response.data.customers
        : Array.isArray(response?.data?.items)
          ? response.data.items
          : Array.isArray(response?.data)
            ? response.data
            : [];

      if (isErpApiSuccess(response) && Array.isArray(rows)) {
        const fetchedusersss = rows.map((userss) => {
          return {
            id: userss.id,
            fullName: userss.name || "",
            mobile: userss.mobile || "",
            email: userss.email || "",
            city: userss.city || "",
            address: userss.address || "",
            area: userss.area || "",
            state: userss.state || "", // Add state field
            aadharNo: userss.aadhar_no || "",
            panNo: userss.pan_no || "",
            birthDate: userss.birth_date || "",
            maritalStatus: userss.marital_status || "",
            anniversaryDate: userss.anniversary_date || "",
            // openingBalance: userss.opening_balance || "",
            // pendingBalance: userss.pending_balance || "",
            balance: userss.users_balance ?? userss.balance ?? "",
            finalBalance: userss.final_balance || "",
            saleBalance: userss.sale_balance || "",
            companyName: userss.company_name || "",
            companyAddress: userss.company_address || "",
            gstNumber: userss.GST_number || "",
            reference: userss.reference || "",
            status: userss.status || "",
          };
        });

        // Sort fetched items by ID in ascending order (recently added at the bottom)
        fetchedusersss.sort((a, b) => a.id - b.id);

        setusersss(fetchedusersss);

        // Return the fetched usersss so they can be used in Promise.all
        return fetchedusersss;
      } else {
        console.error("Unexpected data format:", response);
        return [];
      }
    } catch (error) {
      console.error("Error fetching userss Details:", error);
      return []; // Return empty array on error
    }
  };

  const applyPoolHeaderFromGroup = (group) => {
    if (!group) {
      setProductGroupPoolHeader(null);
      return;
    }
    setProductGroupPoolHeader({
      pcs: numPool(group.pool_pcs),
      nwt: numPool(group.pool_nwt),
    });
  };

  const getProductGroupOptionsList = () =>
    mergeProductGroupOptions(
      productGroupOptionsCacheRef.current,
      dropdownData.productGroup,
    );

  const fetchProductGroupByPrefix = async (prefix = "") => {
    if (!productGroupUserSearchRef.current) {
      return [];
    }

    const trimmed = String(prefix || "").trim();
    if (trimmed.length < 3) {
      setDropdownData((prev) => ({ ...prev, productGroup: [] }));
      setProductGroupApiCalled(false);
      setProductGroupSearchLoading(false);
      return [];
    }

    if (lastSearchedProductGroupPrefix === trimmed) {
      setProductGroupApiCalled(true);
      return dropdownData.productGroup;
    }

    setProductGroupSearchLoading(true);
    try {
      const opts = await searchProductGroupSelectOptions(trimmed);
      productGroupOptionsCacheRef.current = mergeProductGroupOptions(
        productGroupOptionsCacheRef.current,
        opts,
      );
      setDropdownData((prev) => ({
        ...prev,
        productGroup: opts,
      }));
      setLastSearchedProductGroupPrefix(trimmed);
      setProductGroupApiCalled(true);
      if (opts.length > 0) {
        applyPoolHeaderFromGroup(opts[0]);
      }
      return opts;
    } catch (error) {
      console.error("Error searching product groups:", error);
      setDropdownData((prev) => ({ ...prev, productGroup: [] }));
      setProductGroupApiCalled(true);
      return [];
    } finally {
      setProductGroupSearchLoading(false);
    }
  };

  const resolveProductGroupOption = async (
    pgText,
    pgIdFromCell,
    tagNo = "",
  ) => {
    const list = getProductGroupOptionsList();
    const normalizedText = String(pgText || "").trim();
    const nl = normalizedText.toLowerCase();
    const stripPoolSuffix = (s) =>
      String(s)
        .replace(/\s*—\s*pool:.+$/i, "")
        .trim()
        .toLowerCase();

    const matchInList = (groups) => {
      if (!groups?.length || !normalizedText) return null;
      const exact = groups.find(
        (group) =>
          String(group.label || "").trim() === normalizedText ||
          String(group.label || "")
            .trim()
            .toLowerCase() === nl ||
          String(group.name || "").trim() === normalizedText ||
          String(group.name || "")
            .trim()
            .toLowerCase() === nl ||
          String(group.short_code || "").trim() === normalizedText ||
          String(group.short_code || "")
            .trim()
            .toLowerCase() === nl ||
          String(group.value) === normalizedText ||
          String(group.value) === String(Number(normalizedText)) ||
          stripPoolSuffix(group.label || "") === nl ||
          stripPoolSuffix(group.name || "") === nl,
      );
      if (exact) return exact;

      const prefixMatches = groups.filter((g) => {
        const label = stripPoolSuffix(g.label ?? "");
        const name = stripPoolSuffix(g.name ?? "");
        if (!label && !name) return false;
        return (
          (label && (label.startsWith(nl) || nl.startsWith(label))) ||
          (name && (name.startsWith(nl) || nl.startsWith(name)))
        );
      });
      if (prefixMatches.length === 1) return prefixMatches[0];
      return null;
    };

    let found = matchInList(list);
    if (found) return found;

    if (pgIdFromCell != null && pgIdFromCell > 0) {
      found = list.find((group) => Number(group.value) === pgIdFromCell);
      if (found) return found;

      const fetched = await fetchProductGroupOptionById(pgIdFromCell);
      if (fetched) {
        productGroupOptionsCacheRef.current = mergeProductGroupOptions(
          productGroupOptionsCacheRef.current,
          [fetched],
        );
        return fetched;
      }

      return {
        value: pgIdFromCell,
        label: normalizedText || String(pgIdFromCell),
        short_code: "",
        purity: "",
        metal: "",
      };
    }

    const tag = String(tagNo || "").trim();
    if (tag) {
      try {
        const tagRes = await showProducts({ tag_no: tag });
        const p =
          tagRes?.data?.product ?? tagRes?.data?.data?.product ?? null;
        if (isErpApiSuccess(tagRes) && p?.product_group != null) {
          const resolved = await fetchProductGroupOptionById(p.product_group);
          if (resolved) {
            productGroupOptionsCacheRef.current = mergeProductGroupOptions(
              productGroupOptionsCacheRef.current,
              [resolved],
            );
            return matchInList(getProductGroupOptionsList()) || resolved;
          }
          return {
            value: p.product_group,
            label: normalizedText || String(p.product_group),
            short_code: "",
            purity: "",
            metal: "",
          };
        }
      } catch (tagErr) {
        console.warn("Could not resolve product group for tag", tag, tagErr);
      }
    }

    // Untagged / new rows: search API by typed name when cache miss
    if (normalizedText.length >= 3) {
      try {
        const opts = await searchProductGroupSelectOptions(normalizedText);
        if (opts?.length) {
          productGroupOptionsCacheRef.current = mergeProductGroupOptions(
            productGroupOptionsCacheRef.current,
            opts,
          );
          found = matchInList(opts);
          if (found) return found;
        }
      } catch (searchErr) {
        console.warn(
          "Could not resolve product group via search",
          normalizedText,
          searchErr,
        );
      }
    }

    return null;
  };

  const fetchProduct = async () => {
    try {
      const response = await listProducts({
        page: 1,
        limit: 5000,
        search: "",
        stock_type: "",
      });
      const items = Array.isArray(response?.data?.items)
        ? response.data.items
        : [];

      if (response?.success && items.length >= 0) {
        const fetchedProducts = items.map((product) => {
          return {
            id: product.id,
            tagNo: product.tag_no, // Map tag_no to tagNo
            // ... other fields you need
          };
        });

        // Sort fetched items by ID in ascending order
        fetchedProducts.sort((a, b) => a.id - b.id);

        setProducts(fetchedProducts);

        // Extract unique tag numbers for dropdown
        const tagNos = [
          ...new Set(items.map((p) => p.tag_no).filter(Boolean)),
        ].map((tag) => ({ label: tag, value: tag }));
        setDropdownData((prev) => ({
          ...prev,
          tagNo: tagNos,
        }));
      } else {
        console.error("Unexpected data format:", response);
      }
    } catch (error) {
      console.error("Error fetching product Details:", error);
    }
  };

  // Function to send tag number to API
  const sendTagNoToApi = async (tagNo) => {
    try {
      const response = await showProducts({ tag_no: tagNo });
      if (isErpApiSuccess(response)) {
        const product =
          response.data?.product ?? response.data?.data?.product ?? null;
        if (!product) {
          return; // Unexpected shape; safely exit
        }

        const fieldMapping = {
          product_group: "productGroup",
          design: "design",
          size: "size",
          current_pcs: "pcs",
          current_gwt: "grWt",
          LWT: "lsWt",
          NWT: "netWt",
          LBR_type: "lType",
          LBR: "lbrPercentage",
          LBR_rate: "lbrRate",
          LBR_amt: "lbrAmt",
          othamt: "othAmt",
          MRP: "mrp",
          image: "image",
        };

        const matchingRows = tableData
          .map((row, index) => ({ row, index }))
          .filter(({ row }) => {
            const tagNoCell = row.data.find((cell) => cell.id === "tagNo");
            return tagNoCell && tagNoCell.value === tagNo;
          });

        if (matchingRows.length > 0) {
          setTableData((prevData) => {
            const newData = [...prevData];
            matchingRows.forEach(({ row, index: rowIndex }) => {
              // Update each field based on the mapping
              Object.entries(fieldMapping).forEach(([apiField, tableField]) => {
                const cellIndex = newData[rowIndex].data.findIndex(
                  (cell) => cell.id === tableField,
                );
                if (cellIndex !== -1) {
                  if (apiField === "product_group") {
                    // Convert product group ID to label
                    const pgId = product[apiField];
                    const pgObj = dropdownData.productGroup.find(
                      (pg) => pg.value === pgId,
                    );
                    const pgName = pgObj ? pgObj.label : pgId; // fallback to ID
                    newData[rowIndex].data[cellIndex].value = pgName;
                    if (pgId != null && pgId !== "") {
                      newData[rowIndex].data[cellIndex].productGroupId = pgId;
                    }

                    if (pgObj) {
                      let computedRate = 0;
                      if (
                        pgObj.metal === "Gold" &&
                        Array.isArray(masterGoldRate)
                      ) {
                        const purityStr = (pgObj.purity || "").toString();
                        const labelStr = (pgObj.label || "").toLowerCase();
                        const purityNum = parseFloat(purityStr);
                        let idx = 0;
                        if (labelStr.includes("rose")) {
                          idx = 3;
                        } else if (!isNaN(purityNum)) {
                          const p = Math.round(purityNum);
                          if (p === 22) idx = 1;
                          else if (p === 18) idx = 2;
                          else idx = 0;
                        }
                        computedRate = Number(masterGoldRate[idx] || 0);
                      } else {
                        const baseRate =
                          pgObj.metal === "Gold"
                            ? masterGoldRate
                            : masterSilverRate;
                        if (pgObj.purity) {
                          computedRate = calculatePurityBasedRate(
                            pgObj.purity,
                            baseRate,
                            pgObj.metal,
                          );
                        } else {
                          computedRate = calculatePerGramRate(
                            baseRate,
                            pgObj.metal,
                          );
                        }
                      }

                      const itRateIndex = newData[rowIndex].data.findIndex(
                        (cell) => cell.id === "itRate",
                      );
                      if (itRateIndex !== -1) {
                        newData[rowIndex].data[itRateIndex].value = Number(
                          computedRate || 0,
                        ).toFixed(2);
                      }
                    }
                  } else if (apiField === "image" && product[apiField]) {
                    // Prefer node_imageBaseUrl for uploads (fallback to legacy)
                    newData[rowIndex].data[cellIndex].value = product[apiField];
                    newData[rowIndex].data[cellIndex].imagePreview =
                      `${node_imageBaseUrl}/${product[apiField]}`;
                  } else {
                    newData[rowIndex].data[cellIndex].value =
                      product[apiField] || "";
                  }

                  // Store current_pcs value for validation
                  if (apiField === "current_pcs") {
                    const pcsCell = newData[rowIndex].data.find(
                      (cell) => cell.id === "pcs",
                    );
                    if (pcsCell) {
                      pcsCell.current_pcs = product[apiField] || "0";
                    }
                  }
                }
              });

              // Handle charges array for othAmt
              const othAmtIndex = newData[rowIndex].data.findIndex(
                (cell) => cell.id === "othAmt",
              );
              if (othAmtIndex !== -1) {
                newData[rowIndex].data[othAmtIndex].value =
                  product.othamt || "0.00";
                const chargesArray =
                  product.charges || product.data?.charges || [];
                newData[rowIndex].data[othAmtIndex].otherAmountEntries =
                  mapApiChargesToOtherAmountEntries(chargesArray);
              }

              // Calculate total amount
              const itAmtIndex = newData[rowIndex].data.findIndex(
                (cell) => cell.id === "itAmt",
              );
              const lbrAmtIndex = newData[rowIndex].data.findIndex(
                (cell) => cell.id === "lbrAmt",
              );
              const totalAmtIndex = newData[rowIndex].data.findIndex(
                (cell) => cell.id === "totalAmt",
              );

              const itAmt = parseFloat(
                newData[rowIndex].data[itAmtIndex]?.value || 0,
              );
              const lbrAmt = parseFloat(
                newData[rowIndex].data[lbrAmtIndex]?.value || 0,
              );
              const othAmt = parseFloat(
                newData[rowIndex].data[othAmtIndex]?.value || 0,
              );
              const totalAmt = itAmt + lbrAmt + othAmt;

              if (totalAmtIndex !== -1) {
                newData[rowIndex].data[totalAmtIndex].value =
                  roundLineTotalAmount(totalAmt);
              }
            });

            return newData;
          });

          // toast.success(`Product data loaded for tag ${tagNo}`);
        } else {
          console.warn("No matching rows found for tagNo:", tagNo);
        }
      } else {
        console.error("API returned non-success status:", response.data);
        // toast.error("Failed to fetch product data");
      }
    } catch (error) {
      console.error("Error in API call:", error);
      // toast.error("Error fetching product data");
    }
  };

  const fetchPaymentTypes = async () => {
    try {
      const response = await listBankAccounts();
      const rows = Array.isArray(response?.data?.bank_accounts)
        ? response.data.bank_accounts
        : [];

      if (response?.success && Array.isArray(rows)) {
        const fetchedBankDetails = rows.map((bank) => {
          return {
            id: bank.id,
            bankName: bank.bank_name || "",
            accountHolder: bank.holder_name || "",
            accountType: bank.account_type || "",
            ifscCode: bank.ifsc_code || bank.IFSC_code || "",
            accountNumber: bank.account_number || "",
            openingBalance: bank.opening_balance || "",
            balance: bank.opening_balance ? `₹${bank.opening_balance}` : "₹0",
            status: bank.status === 1 ? "Active" : "Inactive",
            statusClass:
              bank.status === 1
                ? "bg-success-subtle text-success"
                : "bg-danger-subtle text-danger",
            useForInvoice: bank.use_for_invoice === 1,
            useForPOS: bank.use_for_pos === 1,
          };
        });

        // Sort by ID in descending order (newest first)
        fetchedBankDetails.sort((a, b) => b.id - a.id);
        setBankAccounts(fetchedBankDetails);

        // Also populate paymentTypes for the dropdown
        const paymentOptions = fetchedBankDetails.map((bank) => ({
          value: String(bank.id),
          label: bank.accountNumber ? `${bank.bankName}` : bank.bankName,
        }));
        setPaymentTypes(paymentOptions);
        return paymentOptions;
      } else if (
        response.data &&
        response.data.message === "radha" &&
        (!response.data.data || response.data.data.length === 0)
      ) {
        // Handle empty data case
        setBankAccounts([]);
        setPaymentTypes([]);
        toast("No bank accounts found");
        return [];
      } else if (response.data && response.data.success === false) {
        // Handle error case
        console.error("Server returned error:", response.data.message);
        setBankAccounts([]);
        setPaymentTypes([]);
        toast.error(response.data.message || "Failed to fetch bank details");
        return [];
      } else {
        // Handle unexpected format
        console.error("Unexpected data format:", response.data);
        setBankAccounts([]);
        setPaymentTypes([]);
        toast.error("Unexpected response format from server");
        return [];
      }
    } catch (error) {
      console.error("Error fetching bank details:", error);
      setBankAccounts([]);
      setPaymentTypes([]);
      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch bank details",
      );
      return [];
    }
  };

  const [allProducts, setAllProducts] = useState([]);
  const [displayedProducts, setDisplayedProducts] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  // Demo data for dropdowns
  const [dropdownData, setDropdownData] = useState({
    productGroup: [],
    design: [],
    lType: ["NWt", "GWt", "Pcs", "Fixed"], // Keeping this as it is since it's not from API
    itRateOn: ["NWt", "GWt"], // Adding new options for ItRateOn
    tagNo: [],
  });

  // Columns that should have dropdown functionality
  const dropdownColumns = [
    "productGroup",
    "lType",
    "rateOn",
    "itRateOn",
    "tagNo",
  ];

  const initialRowData = COLUMNS.map((col) => ({
    id: col.id,
    value: "",
    // Add imageFile property for image column
    ...(col.id === "image" ? { imageFile: null, imagePreview: null } : {}),
  }));

  const [tableData, setTableData] = useState([{ id: 1, data: initialRowData }]);
  const [activeDropdown, setActiveDropdown] = useState({
    row: null,
    col: null,
    type: null,
  });
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
  });
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const [lastSearchedProductGroupPrefix, setLastSearchedProductGroupPrefix] =
    useState("");
  const [productGroupApiCalled, setProductGroupApiCalled] = useState(false);
  const [productGroupPoolHeader, setProductGroupPoolHeader] = useState(null);
  const [productGroupSearchLoading, setProductGroupSearchLoading] =
    useState(false);
  const dropdownRef = useRef(null);
  const inputRefs = useRef({});
  const dropdownItemsRef = useRef([]);
  const fileInputRefs = useRef({});
  const tooltipRefs = useRef({}); // Add refs for tooltips

  // Add state to track active tooltip
  const [activeTooltip, setActiveTooltip] = useState(null);
  const tooltipTimeoutRef = useRef(null);

  // State for image modal
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    imageUrl: null,
    zoomLevel: 1,
  });

  // Add state for other amount modal
  const [otherAmountModal, setOtherAmountModal] = useState({
    isOpen: false,
    rowIndex: null,
    entries: [],
    currentEntry: {
      chargeType: "",
      pcs: "",
      ct: "",
      wt: "",
      conPercentage: "",
      rateOn: "",
      rate: "",
      amount: "",
    },
    editingIndex: undefined,
  });

  // Add state to track last Enter keypress time
  const [lastEnterPress, setLastEnterPress] = useState({
    time: 0,
    rowIndex: null,
  });

  // Update the otherAmountColumnWidths state to use fixed widths
  const [otherAmountColumnWidths, setOtherAmountColumnWidths] = useState({
    no: "10px", // Added for No. column
    chargetype: "150px", // Changed from chargeType to match transformation
    pcs: "20px",
    ct: "50px",
    wt: "60px",
    con: "10px",
    rateon: "50px",
    rate: "68px",
    amount: "80px",
  });

  // Add rateOn options
  const rateOnOptions = ["FIXED", "PCS", "CT", "WT"];

  // const [billtype, setBillType] = useState("");
  const [billDate, setBillDate] = useState("");
  const [createdBy, setCreatedBy] = useState(null);

  const sessionBranchId = useMemo(() => {
    const u = getErpAuthState()?.user || {};
    const n = Number(u.branch_id ?? u.branchId);
    return Number.isFinite(n) && n > 0 ? n : null;
  }, []);
  const { selectOptions: employeeOptions, loading: employeesLoading } =
    useHrmsEmployees(sessionBranchId);

  // Refresh Created By label from employee list when it loads
  useEffect(() => {
    if (!createdBy?.value || employeeOptions.length === 0) return;
    const match = employeeOptions.find(
      (opt) => Number(opt.value) === Number(createdBy.value),
    );
    if (match && match.label !== createdBy.label) {
      setCreatedBy(match);
    }
  }, [employeeOptions, createdBy]);

  const [tagOptions, setTagOptions] = useState([]);

  // Add userss states
  const [userssMobile, setuserssMobile] = useState("");
  const [userssMobileSearchText, setuserssMobileSearchText] = useState("");
  const [selecteduserssId, setSelecteduserssId] = useState(null);

  // URD / Old Purchase Modal & payload states
  const [oldPurchases, setOldPurchases] = useState([]);
  const [urdModalState, setUrdModalState] = useState({
    isOpen: false,
    payMode: "old_gold",
    row: null,
  });
  const [userssMobileDropdownActive, setuserssMobileDropdownActive] =
    useState(false);
  const [userssMobileHighlightedIndex, setuserssMobileHighlightedIndex] =
    useState(0);
  const userssMobileDropdownRef = useRef(null);
  const userssMobileInputRef = useRef(null);
  const userssMobileItemsRef = useRef([]);

  const [userssName, setuserssName] = useState("");
  const [userssNameSearchText, setuserssNameSearchText] = useState("");
  const [userssNameDropdownActive, setuserssNameDropdownActive] =
    useState(false);
  const [userssNameHighlightedIndex, setuserssNameHighlightedIndex] =
    useState(0);
  const userssNameDropdownRef = useRef(null);
  const userssNameInputRef = useRef(null);
  const userssNameItemsRef = useRef([]);

  const [userssAddress, setuserssAddress] = useState("");
  const [userssArea, setuserssArea] = useState("");
  const [userssCity, setuserssCity] = useState("");
  const [billedTo, setBilledTo] = useState(true);
  const [billedMobile, setBilledMobile] = useState("");
  const [billedName, setBilledName] = useState("");
  const [billedAddress, setBilledAddress] = useState("");
  const [billedArea, setBilledArea] = useState("");

  // Add new state for userss details modal
  const [showuserssDetailsModal, setShowuserssDetailsModal] = useState(false);
  const [userssDetails, setuserssDetails] = useState({
    email: "",
    birthDate: "",
    anniversaryDate: "",
    companyName: "",
    companyAddress: "",
    gstNumber: "",
    aadharNo: "",
    panNo: "",
    maritalStatus: "",
    // openingBalance: "",
    // pendingBalance: "",
    balance: "",
    finalBalance: "",
    saleBalance: "",
    reference: "",
    state: "",
  });

  const { states, cities, selectedState, setSelectedState } =
    useIndiaStateCity();

  // Add new state for tracking if userss is being added manually
  const [isNewuserss, setIsNewuserss] = useState(false);
  const [savinguserss, setSavinguserss] = useState(false);
  const [userssSaveSuccess, setuserssSaveSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [usersss, setusersss] = useState([]);

  // Add userss Form States
  // const [fullName, setFullName] = useState("");
  // const [mobile, setMobile] = useState("");
  // const [email, setEmail] = useState("");
  // const [city, setCity] = useState("");
  // const [address, setAddress] = useState("");
  // const [birthDate, setBirthDate] = useState("");
  // const [maritalStatus, setMaritalStatus] = useState("");
  // const [anniversaryDate, setAnniversaryDate] = useState("");
  // const [openingBalance, setOpeningBalance] = useState("");
  // const [pendingBalance, setPendingBalance] = useState("");
  // const [companyName, setCompanyName] = useState("");
  // const [companyAddress, setCompanyAddress] = useState("");
  // const [gstNumber, setGstNumber] = useState("");
  // const [status, setStatus] = useState("active");
  // const [showAddModal, setShowAddModal] = useState(false);

  // Mock userss data - replace with real API data
  const userssS = usersss.map((userss) => ({
    id: userss.id,
    name: userss.fullName,
    fullName: userss.fullName,
    mobile: userss.mobile,
    email: userss.email,
    city: userss.city,
    address: userss.address,
    birthDate: userss.birthDate,
    maritalStatus: userss.maritalStatus,
    anniversaryDate: userss.anniversaryDate,
    // openingBalance: userss.openingBalance,
    // pendingBalance: userss.pendingBalance,
    balance: userss.balance,
    finalBalance: userss.finalBalance,
    saleBalance: userss.saleBalance,
    companyName: userss.companyName,
    companyAddress: userss.companyAddress,
    gstNumber: userss.gstNumber,
    aadharNo: userss.aadharNo,
    panNo: userss.panNo,
    reference: userss.reference,
    state: userss.state,
  }));

  const editSaleIdempotencyKeyRef = useRef(null);

  const [products, setProducts] = useState([]);

  const renderTotalAmountModal = () => {
    if (!totalAmountModal.isOpen) return null;

    return ReactDOM.createPortal(
      <Modal
        show={totalAmountModal.isOpen}
        onHide={() => closeTotalAmountModal(true)}
        centered
        size="sm"
      >
        <Modal.Header closeButton className="border-0 pb-0 align-items-center">
          <Modal.Title className="fw-semibold">GST Settlement</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3">
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold mb-2">GST (%)</Form.Label>
            <div className="d-flex gap-3 flex-wrap">
              {["3", "5", "12", "18"].map((value) => (
                <Form.Check
                  key={value}
                  type="radio"
                  name="total-amount-gst-selection"
                  id={`total-amount-gst-${value}`}
                  label={`${value}%`}
                  value={value}
                  checked={totalAmountModal.gst === value}
                  onChange={(e) =>
                    setTotalAmountModal((prev) => ({
                      ...prev,
                      gst: e.target.value,
                    }))
                  }
                />
              ))}
            </div>
          </Form.Group>
          <Form.Group controlId="totalAmountModal-amount">
            <div className="d-flex gap-2">
              <Form.Control
                ref={totalAmountInputRef}
                type="text"
                value={totalAmountModal.amount}
                placeholder="0.00"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || /^\d*\.?\d*$/.test(value)) {
                    setTotalAmountModal((prev) => ({
                      ...prev,
                      amount: value,
                    }));
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSaveTotalAmount();
                  }
                }}
                autoFocus
              />
              <Button variant="primary" onClick={handleSaveTotalAmount}>
                Save
              </Button>
            </div>
          </Form.Group>
        </Modal.Body>
      </Modal>,
      document.body,
    );
  };

  const handleDateChange = (e) => {
    setBillDate(e.target.value);
  };

  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(0);
  const suggestionTimeoutRef = useRef(null);
  const [billTypes, setBillTypes] = useState([]);
  const [selectedBillTypeId, setSelectedBillTypeId] = useState("");
  const [selectedBillTypeName, setSelectedBillTypeName] = useState("GST");
  const [estimateValue, setEstimateValue] = useState(0);
  const selectedBillTypeIdRef = useRef("");

  // Update the charge types data to include multiple codes
  const CHARGE_TYPES = [
    {
      name: "Hallmark Charges",
      codes: ["HC", "HM"],
    },
    {
      name: "Stone Charges",
      codes: ["SC"],
    },
    {
      name: "Diamond Charges",
      codes: ["DC"],
    },
    {
      name: "Jadtar Charges",
      codes: ["JC"],
    },
    {
      name: "Customization Charges",
      codes: ["CC"],
    },
    {
      name: "Engraving Charges",
      codes: ["EC"],
    },
    {
      name: "Polishing Charges",
      codes: ["PC"],
    },
    {
      name: "Electroplating Charges",
      codes: ["EPC"],
    },
    {
      name: "Antique/Oxidized Finish Charges",
      codes: ["AFC"],
    },
    {
      name: "Kadha/Hollow Jewellery Filling Charges",
      codes: ["KFC"],
    },
    {
      name: "Melting & Refining Charges",
      codes: ["MRC"],
    },
    {
      name: "Weighing & Testing Charges",
      codes: ["WTC"],
    },
    {
      name: "Laser Cutting Charges",
      codes: ["LCC"],
    },
    {
      name: "Handmade Labour Charges",
      codes: ["HLC"],
    },
    {
      name: "Antique Kundan Meena Charges",
      codes: ["AKMC"],
    },
    {
      name: "Threading & Bead Stringing Charges",
      codes: ["TBC"],
    },
    {
      name: "Enamel Meenakari Charges",
      codes: ["EMC"],
    },
    {
      name: "Embossing & Carving Charges",
      codes: ["ECC"],
    },
    {
      name: "Rhodium Charges",
      codes: ["RC"],
    },
  ];

  // Modify the getSuggestions function to handle multiple codes
  const getSuggestions = (query) => {
    if (!query || query.length < 1) {
      setSuggestions([]);
      return;
    }

    const searchQuery = query.toLowerCase();

    // First try to match by any code
    let matchedByCode = CHARGE_TYPES.filter((charge) =>
      charge.codes.some((code) => code.toLowerCase() === searchQuery),
    );

    // If no exact code match, then try partial matches on codes
    if (matchedByCode.length === 0) {
      matchedByCode = CHARGE_TYPES.filter((charge) =>
        charge.codes.some((code) => code.toLowerCase().startsWith(searchQuery)),
      );
    }

    // Get matches by name
    const matchedByName = CHARGE_TYPES.filter(
      (charge) =>
        charge.name.toLowerCase().includes(searchQuery) &&
        !matchedByCode.some((codeMatch) => codeMatch.name === charge.name),
    );

    // Combine results with code matches first
    const matchedSuggestions = [...matchedByCode, ...matchedByName].map(
      (charge) => `${charge.name} (${charge.codes[0]})`,
    );

    setSuggestions(matchedSuggestions);
    setShowSuggestions(true);
    setSelectedSuggestionIndex(0);
  };

  // Add function to handle suggestion selection
  const handleSuggestionSelect = (suggestion, rowIndex = null) => {
    // Extract just the name without the code in brackets
    const chargeName = suggestion.split(" (")[0];

    if (rowIndex !== null) {
      // For existing entries
      const newEntries = [...otherAmountModal.entries];
      newEntries[rowIndex].chargeType = chargeName;
      setOtherAmountModal((prev) => ({
        ...prev,
        entries: newEntries,
      }));
    } else {
      // For current entry
      setOtherAmountModal((prev) => ({
        ...prev,
        currentEntry: {
          ...prev.currentEntry,
          chargeType: chargeName,
        },
      }));
    }
    setShowSuggestions(false);
  };

  // Reset highlighted index when dropdown opens or filter changes
  useEffect(() => {
    if (activeDropdown.row !== null && activeDropdown.col !== null) {
      setHighlightedIndex(0);
      dropdownItemsRef.current = [];
    }
  }, [activeDropdown, tableData]);

  // Scroll highlighted item into view
  useEffect(() => {
    if (dropdownRef.current && dropdownItemsRef.current[highlightedIndex]) {
      dropdownItemsRef.current[highlightedIndex].scrollIntoView({
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    if (
      activeDropdown.type !== "productGroup" ||
      activeDropdown.row === null ||
      activeDropdown.col === null
    ) {
      return;
    }
    const cell = tableData[activeDropdown.row]?.data[activeDropdown.col];
    const filtered = getFilteredItems(cell?.value, "productGroup");
    if (filtered[highlightedIndex]) {
      applyPoolHeaderFromGroup(filtered[highlightedIndex]);
    }
  }, [highlightedIndex, activeDropdown, dropdownData.productGroup]);

  useEffect(() => {
    if (
      productGroupApiCalled &&
      activeDropdown.type === "productGroup" &&
      activeDropdown.row !== null &&
      activeDropdown.col !== null
    ) {
      setTimeout(() => {
        const inputElement =
          inputRefs.current[`${activeDropdown.row}-${activeDropdown.col}`];
        if (inputElement) {
          const rect = inputElement.getBoundingClientRect();
          setDropdownPosition({
            top: rect.bottom + window.scrollY,
            left: rect.left + window.scrollX,
            width: rect.width,
          });
        }
      }, 10);
    }
  }, [productGroupApiCalled, dropdownData.productGroup, activeDropdown]);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown({ row: null, col: null, type: null });
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedBillTypeId]);

  // Create portal container for dropdown
  useEffect(() => {
    setupPortalContainers();
    return teardownPortalContainers;
  }, []);

  // Add this function to calculate Net Weight
  const calculateNetWeight = (gw, lw) => {
    return gw - lw; // NWt = GWt - LWt
  };

  // Function to calculate Labor Amount using Lbr %
  const calculateLbrAmtWithPercentage = (
    baseWeight,
    lbrPercentage,
    masterRate,
    metalType,
  ) => {
    return (
      (lbrPercentage / 100) *
      baseWeight *
      calculatePerGramRate(masterRate, metalType)
    );
  };

  // Function to calculate Labor Amount using Lbr Rate
  const calculateLbrAmtWithRate = (baseWeight, lbrRate) => {
    return lbrRate * baseWeight;
  };

  // Update the handleInputChange function to calculate Lbr Amt
  const handleInputChange = (rowIndex, colIndex, value) => {
    const newTableData = [...tableData];
    const cell = newTableData[rowIndex].data[colIndex];
    const id = cell.id;

    // Store previous value to check if it has changed
    const previousValue = cell.value;

    // If the changed column is lbrType
    if (id === "lbrType") {
      cell.value = value;

      // If Fixed is selected, clear lbrPercentage and lbrRate
      if (value === "Fixed") {
        const lbrPercentageCell = newTableData[rowIndex].data.find(
          (cell) => cell.id === "lbrPercentage",
        );
        const lbrRateCell = newTableData[rowIndex].data.find(
          (cell) => cell.id === "lbrRate",
        );

        if (lbrPercentageCell) {
          lbrPercentageCell.value = "";
        }
        if (lbrRateCell) {
          lbrRateCell.value = "";
        }
      }

      setTableData(newTableData);
      return;
    }

    // Check if value matches the validation pattern for this column
    const validationPatterns = {
      design: /^[a-zA-Z0-9\s\-\_]*$/, // Allow alphanumeric, spaces, hyphens, underscores
      size: /^\d*$/, // Only numbers
      pcs: /^\d*$/, // Only numbers
      lbrPercentage: /^$|^\d*\.?\d*$/, // Empty or numbers with optional decimal point
      lbrRate: /^$|^\d*\.?\d*$/, // Empty or numbers with optional decimal point
      lbrAmt: /^$|^\d*\.?\d*$/, // Empty or numbers with optional decimal point
      othAmt: /^$|^\d*\.?\d*$/, // Empty or numbers with optional decimal point
      mrp: /^$|^\d*\.?\d*$/, // Empty or numbers with optional decimal point
      grWt: /^$|^\d*\.?\d*$/, // Empty or numbers with optional decimal point
      lsWt: /^$|^\d*\.?\d*$/, // Empty or numbers with optional decimal point
      netWt: /^$|^\d*\.?\d*$/, // Empty or numbers with optional decimal point
      itRate: /^$|^\d*\.?\d*$/, // Empty or numbers with optional decimal point
      itAmt: /^$|^\d*\.?\d*$/, // Empty or numbers with optional decimal point
      totalAmt: /^$|^\d*\.?\d*$/, // Empty or numbers with optional decimal point
    };

    // If pattern exists and value doesn't match, don't update
    if (validationPatterns[id] && !validationPatterns[id].test(value)) {
      return; // Don't update if validation fails
    }

    // Add validation for pcs field
    if (id === "pcs") {
      const tagNoCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "tagNo",
      );
      if (tagNoCell && tagNoCell.value) {
        // Find the current_pcs value from the API response
        const currentPcs = parseInt(cell.current_pcs) || 0;
        const enteredPcs = parseInt(value) || 0;

        if (enteredPcs > currentPcs) {
          toast.error(`Cannot enter more than ${currentPcs} pieces`);
          return; // Don't update if validation fails
        }
      }
    }

    if (id === "productGroup") {
      cell.value = value;
      // Typing invalidates a previously selected id until dropdown select
      if (cell.productGroupId != null) delete cell.productGroupId;
      setTableData(newTableData);

      if (value && value.length >= 3) {
        const knownOption = getProductGroupOptionsList().find(
          (pg) => pg.label === value || pg.name === value,
        );
        if (knownOption) {
          return;
        }
        if (!productGroupUserSearchRef.current) {
          return;
        }
        if (
          !lastSearchedProductGroupPrefix ||
          value !== lastSearchedProductGroupPrefix
        ) {
          setProductGroupApiCalled(false);
          fetchProductGroupByPrefix(value);
        }
      } else {
        setDropdownData((prev) => ({ ...prev, productGroup: [] }));
        setLastSearchedProductGroupPrefix("");
        setProductGroupApiCalled(false);
        setProductGroupPoolHeader(null);
      }
      return;
    }

    cell.value = value;

    // Handle calculations based on the changed field
    if (id === "grWt" || id === "lsWt") {
      // Calculate Net Weight when Gross Weight or Less Weight changes
      const gwCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "grWt",
      );
      const lwCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "lsWt",
      );

      if (gwCell && lwCell) {
        const grWt = parseFloat(gwCell.value) || 0;
        const lsWt = parseFloat(lwCell.value) || 0;
        const netWt = calculateNetWeight(grWt, lsWt);

        // Update the netWt cell
        const netWtCell = newTableData[rowIndex].data.find(
          (cell) => cell.id === "netWt",
        );
        if (netWtCell) {
          netWtCell.value = netWt.toString();

          // If itRate exists, recalculate itAmt based on itRateOn
          const itRateCell = newTableData[rowIndex].data.find(
            (cell) => cell.id === "itRate",
          );
          const itRateOnCell = newTableData[rowIndex].data.find(
            (cell) => cell.id === "itRateOn",
          );

          if (itRateCell && itRateCell.value) {
            const itRate = parseFloat(itRateCell.value) || 0;
            const itRateOn = itRateOnCell?.value; // No default value

            // Determine which weight to use based on itRateOn
            let baseWeight = 0; // Initialize to 0, no default
            if (itRateOn === "NWt") {
              baseWeight = netWt;
            } else if (itRateOn === "GWt") {
              baseWeight = grWt;
            }

            const itAmt = (baseWeight * itRate).toFixed(2);

            // Update the itAmt cell
            const itAmtCell = newTableData[rowIndex].data.find(
              (cell) => cell.id === "itAmt",
            );
            if (itAmtCell) {
              itAmtCell.value = itAmt.toString();

              // Recalculate totalAmt
              calculateTotalAmount(newTableData, rowIndex);
            }
          }
        }
      }
    } else if (
      id === "netWt" ||
      id === "itRate" ||
      id === "grWt" ||
      id === "itRateOn"
    ) {
      // Calculate Item Amount when Net Weight, Gross Weight, Item Rate, or Item Rate On changes
      const netWtCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "netWt",
      );
      const grWtCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "grWt",
      );
      const itRateCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "itRate",
      );
      const itRateOnCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "itRateOn",
      );

      if (netWtCell && itRateCell && itRateCell.value) {
        const netWt = parseFloat(netWtCell.value) || 0;
        const grWt = parseFloat(grWtCell?.value) || 0;
        const itRate = parseFloat(itRateCell.value) || 0;
        const itRateOn = itRateOnCell?.value || "NWt"; // Default to NWt if not specified

        // Determine which weight to use based on itRateOn
        let baseWeight = netWt; // Default to Net Weight
        if (itRateOn === "GWt") {
          baseWeight = grWt;
        }

        const itAmt = (baseWeight * itRate).toFixed(2);

        // Update the itAmt cell
        const itAmtCellNW = newTableData[rowIndex].data.find(
          (cell) => cell.id === "itAmt",
        );
        if (itAmtCellNW) {
          itAmtCellNW.value = itAmt.toString();

          // Recalculate totalAmt
          calculateTotalAmount(newTableData, rowIndex);
        }
      }
    } else if (id === "lType") {
      // Handle LBR type change
      const lTypeCell = newTableData[rowIndex].data.find(
        (cell) => cell.id === "lType",
      );
      if (lTypeCell) {
        lTypeCell.value = value;
      }
    } else if (id === "lbrAmt" || id === "othAmt" || id === "itAmt") {
      // Recalculate totalAmt when any of the amount fields change
      calculateTotalAmount(newTableData, rowIndex);
    }

    // Handle LBR percentage and rate calculations
    if (id === "lType" || id === "lbrPercentage" || id === "lbrRate") {
      // Track which labor field was last changed
      if (id === "lbrPercentage" || id === "lbrRate") {
        newTableData[rowIndex].lastChangedLaborField = id;
      }
      handleLaborCalculations(newTableData, rowIndex);
    }

    setTableData(newTableData);

    // REMOVED THE PROBLEMATIC CODE THAT WAS CALLING sendTagNoToApi ON EVERY KEYSTROKE
    // The API call should only happen when selecting from dropdown (handled in handleDropdownSelect)

    // If you need to handle barcode scanning, you might want to add a separate function
    // or detect when the input is coming from a barcode scanner vs manual typing
  };

  // Add this function to handle key events on input fields
  const handleKeyPress = (event, rowIndex, colIndex) => {
    // Check if this is a tag number field and Enter key is pressed
    const columnId = COLUMNS[colIndex]?.id;
    if (columnId === "tagNo" && event.key === "Enter") {
      const value = event.target.value;
      if (value) {
        // Prevent duplicate processing of the same tag number in quick succession
        const now = Date.now();
        if (
          lastProcessedTagNo.value !== value ||
          now - lastProcessedTagNo.timestamp > 1000
        ) {
          // Update last processed tag info
          lastProcessedTagNo = {
            value: value,
            timestamp: now,
          };

          // If we're at the last row, add a new row
          if (rowIndex === tableData.length - 1 && !window.isAddingRow) {
            setTimeout(() => {
              handleAddRow();
            }, 100);
          }
        }
      }
    }
  };

  // New function to calculate total amount
  const calculateTotalAmount = (tableData, rowIndex) => {
    const itAmtCell = tableData[rowIndex].data.find(
      (cell) => cell.id === "itAmt",
    );
    const lbrAmtCell = tableData[rowIndex].data.find(
      (cell) => cell.id === "lbrAmt",
    );
    const othAmtCell = tableData[rowIndex].data.find(
      (cell) => cell.id === "othAmt",
    );
    const mrpCell = tableData[rowIndex].data.find((cell) => cell.id === "mrp");

    const itAmt = parseFloat(itAmtCell?.value) || 0;
    const lbrAmt = parseFloat(lbrAmtCell?.value) || 0;
    const othAmt = parseFloat(othAmtCell?.value) || 0;
    const mrp = parseFloat(mrpCell?.value) || 0;

    let totalAmtValue = 0;
    if (mrp > 0) {
      totalAmtValue = mrp;
    } else {
      totalAmtValue = itAmt + lbrAmt + othAmt;
    }

    const totalAmt = roundLineTotalAmount(totalAmtValue);

    // Update the totalAmt cell
    const totalAmtCell = tableData[rowIndex].data.find(
      (cell) => cell.id === "totalAmt",
    );
    if (totalAmtCell) {
      if (!totalAmtCell.totalAmountDetails?.isManual) {
        totalAmtCell.value = totalAmt.toString();
        if (totalAmtCell.totalAmountDetails) {
          delete totalAmtCell.totalAmountDetails;
        }
      }
    }
  };

  // Handle image upload
  const handleImageUpload = async (field, rowIndex) => {
    // First create a preview of the image
    const fileReader = new FileReader();
    fileReader.onload = async (e) => {
      // Update the image preview in the table data
      setTableData((prevData) => {
        const updatedData = [...prevData];
        if (updatedData[rowIndex] && updatedData[rowIndex].data) {
          const imageCell = updatedData[rowIndex].data.find(
            (cell) => cell.id === "image",
          );
          if (imageCell) {
            imageCell.imagePreview = e.target.result;
            imageCell.imageFile = field;
          }
        }
        return updatedData;
      });

      // Image upload disabled — keep local file name as value

      // Update the image name in the table data
      setTableData((prevData) => {
        const updatedData = [...prevData];
        if (updatedData[rowIndex] && updatedData[rowIndex].data) {
          const imageCell = updatedData[rowIndex].data.find(
            (cell) => cell.id === "image",
          );
          if (imageCell) {
            imageCell.value = field?.name || "";
          }
        }
        return updatedData;
      });
    };
    fileReader.readAsDataURL(field);
  };

  // Open image modal
  const openImageModal = (imageUrl) => {
    // Clear any active tooltips when opening modal
    if (tooltipTimeoutRef.current) {
      clearTimeout(tooltipTimeoutRef.current);
      tooltipTimeoutRef.current = null;
    }
    setActiveTooltip(null);

    // Hide any visible tooltips
    Object.values(tooltipRefs.current).forEach((tooltip) => {
      if (tooltip) tooltip.style.display = "none";
    });

    setImageModal({
      isOpen: true,
      imageUrl,
      zoomLevel: 1,
    });
  };

  // Close image modal
  const closeImageModal = () => {
    setImageModal({
      isOpen: false,
      imageUrl: null,
      zoomLevel: 1,
    });
  };

  // Render image modal
  const renderImageModal = () => {
    if (!imageModal.isOpen) return null;

    return ReactDOM.createPortal(
      <Modal show={imageModal.isOpen} onHide={closeImageModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <img
              src={imageModal.imageUrl}
              alt="Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "400px",
                objectFit: "contain",
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center gap-2">
            <Button
              variant="primary"
              size="sm"
              onClick={() => {
                // Trigger file input to change the image
                const rowIndex = tableData.findIndex((row) =>
                  row.data.some(
                    (cell) =>
                      cell.id === "image" &&
                      cell.imagePreview === imageModal.imageUrl,
                  ),
                );

                if (rowIndex !== -1) {
                  const colIndex = tableData[rowIndex].data.findIndex(
                    (cell) => cell.id === "image",
                  );
                  if (colIndex !== -1) {
                    triggerFileInput(rowIndex, colIndex);
                    closeImageModal();
                  }
                }
              }}
              title="Change Image"
            >
              <Icon icon="solar:gallery-edit-bold" width="16" height="16" />
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={() => {
                // Find and remove the image
                const rowIndex = tableData.findIndex((row) =>
                  row.data.some(
                    (cell) =>
                      cell.id === "image" &&
                      cell.imagePreview === imageModal.imageUrl,
                  ),
                );

                if (rowIndex !== -1) {
                  const colIndex = tableData[rowIndex].data.findIndex(
                    (cell) => cell.id === "image",
                  );
                  if (colIndex !== -1) {
                    setTableData((prevData) => {
                      const updatedData = [...prevData];
                      const imageCell = updatedData[rowIndex].data.find(
                        (c) => c.id === "image",
                      );
                      if (imageCell) {
                        imageCell.value = "";
                        imageCell.imageFile = null;
                        imageCell.imagePreview = null;
                      }
                      return updatedData;
                    });
                    closeImageModal();
                  }
                }
              }}
              title="Delete Image"
            >
              <Icon icon="solar:trash-bin-trash-bold" width="16" height="16" />
            </Button>
          </div>
        </Modal.Footer>
      </Modal>,
      document.getElementById("modal-portal"),
    );
  };

  const handleAddRow = () => {
    // Flag to prevent multiple simultaneous calls
    if (window.isAddingRow) return;
    window.isAddingRow = true;

    // Get the current length before adding
    const newRowIndex = tableData.length;

    setTableData((prevData) => [
      ...prevData,
      {
        id: prevData.length + 1,
        data: COLUMNS.map((col) => ({
          id: col.id,
          value: "", // Remove default value for itRateOn
          // Add imageFile property for image column
          ...(col.id === "image"
            ? { imageFile: null, imagePreview: null }
            : {}),
        })),
      },
    ]);

    // Focus on the tagNo field of the newly added row
    setTimeout(() => {
      const tagNoColumnIndex = COLUMNS.findIndex((col) => col.id === "tagNo");
      if (tagNoColumnIndex !== -1) {
        const tagNoInput =
          inputRefs.current[`${newRowIndex}-${tagNoColumnIndex}`];
        if (tagNoInput) tagNoInput.focus();
      }
      // Reset the flag after the row is added and focus is set
      window.isAddingRow = false;
    }, 150); // Increased timeout to ensure DOM is updated
  };

  // Function to focus on the first cell of the next row
  const focusFirstCellOfNextRow = (currentRowIndex) => {
    setTimeout(() => {
      const nextRowIndex = currentRowIndex + 1;
      if (nextRowIndex < tableData.length) {
        const firstCellInput = inputRefs.current[`${nextRowIndex}-0`];
        if (firstCellInput) firstCellInput.focus();
      }
    }, 0);
  };

  const handleDropdownClick = (rowIndex, colIndex, columnType) => {
    // Get position of the input element for positioning the dropdown
    const inputElement = inputRefs.current[`${rowIndex}-${colIndex}`];
    if (inputElement) {
      const rect = inputElement.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }

    setActiveDropdown({ row: rowIndex, col: colIndex, type: columnType });
    setHighlightedIndex(0);

    if (columnType === "tagNo") {
      const tags = dropdownData.tagNo;
      if (!tags || tags.length === 0) void fetchProduct();
    }
  };

  const handleDropdownSelect = (rowIndex, colIndex, selectedItem) => {
    const columnId = COLUMNS[colIndex]?.id;
    const value =
      typeof selectedItem === "object"
        ? selectedItem.name || selectedItem.label || ""
        : selectedItem;

    if (columnId === "productGroup" && typeof selectedItem === "object") {
      productGroupOptionsCacheRef.current = mergeProductGroupOptions(
        productGroupOptionsCacheRef.current,
        [selectedItem],
      );
      applyPoolHeaderFromGroup(selectedItem);
      const selectedId = selectedItem.value ?? selectedItem.id;

      setTableData((prevData) => {
        const updated = prevData.map((row, idx) => {
          if (idx !== rowIndex) return row;
          const data = row.data.map((cell) =>
            cell.id === "productGroup"
              ? {
                  ...cell,
                  value,
                  ...(selectedId != null && selectedId !== ""
                    ? { productGroupId: selectedId }
                    : {}),
                }
              : cell,
          );
          return { ...row, data };
        });
        return updated;
      });

      // Calculate purity-based rate when product group is selected
      const selectedProductGroup = selectedItem;
      if (selectedProductGroup) {
        let computedRate = 0;
        if (
          selectedProductGroup.metal === "Gold" &&
          Array.isArray(masterGoldRate)
        ) {
          const purityStr = (selectedProductGroup.purity || "").toString();
          const labelStr = (selectedProductGroup.label || "").toLowerCase();
          const purityNum = parseFloat(purityStr);
          let idx = 0;
          if (labelStr.includes("rose")) {
            idx = 3;
          } else if (!isNaN(purityNum)) {
            const p = Math.round(purityNum);
            if (p === 22) idx = 1;
            else if (p === 18) idx = 2;
            else idx = 0;
          }
          computedRate = Number(masterGoldRate[idx] || 0);
        } else {
          const baseRate =
            selectedProductGroup.metal === "Gold"
              ? masterGoldRate
              : masterSilverRate;
          if (selectedProductGroup.purity) {
            computedRate = calculatePurityBasedRate(
              selectedProductGroup.purity,
              baseRate,
              selectedProductGroup.metal,
            );
          } else {
            computedRate = calculatePerGramRate(
              baseRate,
              selectedProductGroup.metal,
            );
          }
        }

        const itRateColIndex = COLUMNS.findIndex((col) => col.id === "itRate");
        if (itRateColIndex !== -1) {
          // Defer so productGroup cell update is applied first
          setTimeout(() => {
            handleInputChange(
              rowIndex,
              itRateColIndex,
              Number(computedRate || 0).toFixed(2),
            );
          }, 0);
        }
      }

      setActiveDropdown({ row: null, col: null, type: null });
      setTimeout(() => {
        const nextColIndex = colIndex + 1;
        if (nextColIndex < COLUMNS.length) {
          const nextInput = inputRefs.current[`${rowIndex}-${nextColIndex}`];
          if (nextInput) nextInput.focus();
        } else {
          focusFirstCellOfNextRow(rowIndex);
        }
      }, 0);
      return;
    }

    handleInputChange(rowIndex, colIndex, value);
    setActiveDropdown({ row: null, col: null, type: null });

    // Check if this is a tagNo field and add a new row if it is
    if (columnId === "tagNo" && value && selectedItem) {
      // Only trigger if selectedItem exists (meaning it was selected from dropdown)
      sendTagNoToApi(value);

      // Only add a new row if this is the last row and the value was selected from dropdown
      if (rowIndex === tableData.length - 1) {
        // Add a new row after a brief delay to ensure current row processing is complete
        setTimeout(() => {
          handleAddRow();
        }, 200);
      }

      return; // Skip the default focus behavior since we're adding a new row
    }

    // Focus on the next cell after selection
    setTimeout(() => {
      const nextColIndex = colIndex + 1;
      if (nextColIndex < COLUMNS.length) {
        const nextInput = inputRefs.current[`${rowIndex}-${nextColIndex}`];
        if (nextInput) nextInput.focus();
      } else {
        // If it's the last cell in the row, focus on the first cell of the next row
        focusFirstCellOfNextRow(rowIndex);
      }
    }, 0);
  };

  // Track the last processed tag number to prevent duplicate processing
  let lastProcessedTagNo = {
    value: null,
    timestamp: 0,
  };

  // Get filtered items based on input value and column type
  const getFilteredItems = (searchText, columnType) => {
    // console.log("Column Type:", columnType);
    // console.log("Dropdown Data:", dropdownData);
    // console.log("Search Text:", searchText);

    if (!dropdownData[columnType]) return [];

    // Normalize search text
    const normalizedSearchText = searchText
      ? String(searchText).toLowerCase()
      : "";

    // If no search, return all
    if (!normalizedSearchText) return dropdownData[columnType];

    // Special case: array of strings
    if (columnType === "lType" || columnType === "itRateOn") {
      return dropdownData[columnType].filter((item) =>
        item.toLowerCase().includes(normalizedSearchText),
      );
    }

    // Special case: productGroup — API search results (no client-side re-filter)
    if (columnType === "productGroup") {
      return dropdownData[columnType] || [];
    }

    // Special case: tagNo (search only label)
    if (columnType === "tagNo") {
      return dropdownData[columnType].filter(
        (item) =>
          item.label && item.label.toLowerCase().includes(normalizedSearchText),
      );
    }

    // Default handling
    return dropdownData[columnType].filter((item) => {
      if (typeof item === "object") {
        return item.label
          ? item.label.toLowerCase().includes(normalizedSearchText)
          : false;
      }
      return item.toLowerCase().includes(normalizedSearchText);
    });
  };

  // Add this function to get filtered items for Rate On dropdown
  const getFilteredRateOnItems = (searchText) => {
    if (!searchText) return rateOnOptions;
    return rateOnOptions.filter((item) =>
      item.toLowerCase().includes(searchText.toLowerCase()),
    );
  };

  const getFilteredTagNoOptions = (searchText) => {
    if (!searchText) return tagOptions;

    return tagOptions.filter(
      (item) =>
        item.label.toLowerCase().includes(searchText.toLowerCase()) ||
        item.short_code?.toLowerCase().includes(searchText.toLowerCase()),
    );
  };

  // Handle keyboard navigation
  const handleKeyDown = (e, rowIndex, colIndex, columnType) => {
    // Handle Tab key to move to next cell and potentially add a new row
    if (e.key === "Tab" && !e.shiftKey) {
      // If we're at the last column of the last row
      if (
        colIndex === COLUMNS.length - 1 &&
        rowIndex === tableData.length - 1
      ) {
        e.preventDefault();
        handleAddRow();
        // Focus will be set to the first cell of the new row after render
        setTimeout(() => {
          const newRowIndex = tableData.length;
          const firstCellInput = inputRefs.current[`${newRowIndex}-0`];
          if (firstCellInput) firstCellInput.focus();
        }, 0);
      }
    }

    // Handle dropdown keyboard navigation
    if (columnType === "rateOn" || dropdownColumns.includes(columnType)) {
      const cell = tableData[rowIndex]?.data[colIndex];
      if (!cell) return;

      const filtered =
        columnType === "rateOn"
          ? getFilteredRateOnItems(cell.value)
          : getFilteredItems(cell.value, columnType);

      if (filtered.length === 0) return;

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          setHighlightedIndex((prev) =>
            prev < filtered.length - 1 ? prev + 1 : prev,
          );
          break;
        case "ArrowUp":
          e.preventDefault();
          setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : 0));
          break;
        case "Enter":
          e.preventDefault();
          if (filtered[highlightedIndex]) {
            handleDropdownSelect(
              rowIndex,
              colIndex,
              filtered[highlightedIndex],
            );
          }
          break;
        case "Escape":
          e.preventDefault();
          setActiveDropdown({ row: null, col: null, type: null });
          break;
        case "Tab":
          setActiveDropdown({ row: null, col: null, type: null });
          break;
        default:
          break;
      }
    }
  };

  // Render dropdown through portal
  const renderDropdown = () => {
    if (
      activeDropdown.row === null ||
      activeDropdown.col === null ||
      !activeDropdown.type
    )
      return null;

    const cell = tableData[activeDropdown.row]?.data[activeDropdown.col];
    if (!cell) return null;

    const filtered = getFilteredItems(cell.value, activeDropdown.type);
    // Reset refs array
    dropdownItemsRef.current = [];

    // Special styling for productGroup dropdown - match AddGirvi.jsx pattern
    const isProductGroup = activeDropdown.type === "productGroup";
    const isTagNo = activeDropdown.type === "tagNo";
    // For productGroup: use 5 items with 40px height each (matching AddGirvi.jsx)
    // For others: use 5 items with 35px height each
    const VISIBLE_COUNT2 = isProductGroup ? 5 : 5;
    const ITEM_HEIGHT2 = isProductGroup ? 40 : 35;
    const visibleItems2 = Math.min(filtered.length, VISIBLE_COUNT2);
    const dropdownHeight2 = visibleItems2 * ITEM_HEIGHT2;

    // Calculate max width based on content (for non-productGroup, non-tagNo dropdowns)
    const maxContentWidth = Math.max(
      ...filtered.map((item) => {
        const tempSpan = document.createElement("span");
        tempSpan.style.fontSize = "0.85rem";
        tempSpan.style.visibility = "hidden";
        tempSpan.style.position = "absolute";
        tempSpan.style.whiteSpace = "nowrap";

        // Safely get the label
        const itemLabel = typeof item === "object" ? item.label || "" : item;
        tempSpan.textContent = itemLabel;

        document.body.appendChild(tempSpan);
        const width = tempSpan.offsetWidth;
        document.body.removeChild(tempSpan);
        return width;
      }),
      dropdownPosition.width, // minimum width is input width
    );

    // Calculate width for dropdowns - match Sales.jsx / AddGirvi.jsx pattern
    let adjustedWidth;
    if (isProductGroup) {
      adjustedWidth = Math.max(200, dropdownPosition.width);
    } else if (isTagNo) {
      // TagNo: wide enough for full tags (e.g. PRO@115103); prefer content width vs narrow column
      adjustedWidth = Math.max(
        100,
        maxContentWidth + 28,
        dropdownPosition.width,
      );
    } else {
      adjustedWidth = Math.max(maxContentWidth + 10, 100);
    }

    return ReactDOM.createPortal(
      <div
        ref={dropdownRef}
        className="dropdown-menu show shadow-sm"
        style={{
          position: "absolute",
          top: `${dropdownPosition.top}px`,
          left: `${dropdownPosition.left}px`,
          width: `${adjustedWidth}px`,
          maxHeight: isProductGroup
            ? `${dropdownHeight2 + 16}px`
            : `${dropdownHeight2}px`,
          height: isProductGroup
            ? `${dropdownHeight2 + 16}px`
            : `${dropdownHeight2}px`,
          overflow: "hidden",
          zIndex: 9999,
          border: "1px solid rgba(0,0,0,.15)",
          borderRadius: "0.25rem",
          backgroundColor: "#fff",
          boxSizing: "border-box",
          boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
        }}
      >
        <div
          style={{
            maxHeight: `${dropdownHeight2}px`,
            height: `${dropdownHeight2}px`,
            overflowY: filtered.length > VISIBLE_COUNT2 ? "auto" : "hidden",
            overflowX: isTagNo ? "auto" : "hidden",
          }}
        >
          {isProductGroup && productGroupSearchLoading ? (
            <div
              className="dropdown-item text-muted"
              style={{ cursor: "default", padding: "0.4rem 0.75rem" }}
            >
              Searching...
            </div>
          ) : filtered.length > 0 ? (
            filtered.map((item, idx) => {
              // Handle both object and string types
              const itemLabel =
                typeof item === "object"
                  ? isProductGroup
                    ? productGroupOptionDisplayName(item)
                    : item.name || item.label || ""
                  : item;
              const isSelected =
                typeof item === "object"
                  ? (item.label || "").toLowerCase() ===
                    (cell.value || "").toLowerCase()
                  : item.toLowerCase() === (cell.value || "").toLowerCase();

              return (
                <div
                  key={idx}
                  ref={(el) => (dropdownItemsRef.current[idx] = el)}
                  className={`dropdown-item ${
                    idx === highlightedIndex ? "active" : ""
                  }`}
                  title={itemLabel}
                  style={{
                    cursor: "pointer",
                    padding: "0.4rem 0.75rem",
                    fontSize: "0.85rem",
                    backgroundColor:
                      idx === highlightedIndex
                        ? "var(--theme-primary)"
                        : isSelected
                          ? "#f0f0f0"
                          : "transparent",
                    color: idx === highlightedIndex ? "#fff" : "inherit",
                    whiteSpace: isProductGroup ? "normal" : "nowrap",
                    wordWrap: isProductGroup ? "break-word" : "normal",
                    overflow: isProductGroup || isTagNo ? "visible" : "hidden",
                    textOverflow:
                      isProductGroup || isTagNo ? "clip" : "ellipsis",
                  }}
                  onMouseEnter={() => {
                    setHighlightedIndex(idx);
                    if (isProductGroup) applyPoolHeaderFromGroup(item);
                  }}
                  onMouseDown={() =>
                    handleDropdownSelect(
                      activeDropdown.row,
                      activeDropdown.col,
                      item,
                    )
                  }
                >
                  {itemLabel}
                </div>
              );
            })
          ) : isProductGroup && !productGroupApiCalled ? null : (
            <div
              className="dropdown-item disabled"
              style={{
                padding: "0.4rem 0.75rem",
                fontSize: "0.85rem",
                textAlign: "center",
              }}
            >
              No matching items
            </div>
          )}
        </div>
      </div>,
      document.getElementById("dropdown-portal"),
    );
  };

  // Check if a column should have dropdown functionality
  const isDropdownColumn = (columnId) => {
    return dropdownColumns.includes(columnId);
  };

  // Check if a column is the image column
  const isImageColumn = (columnId) => {
    return columnId === "image";
  };

  // Get column type from index
  const getColumnType = (colIndex) => {
    return COLUMNS[colIndex]?.id;
  };

  // Add a function to handle focus on the last column
  const handleFocus = (rowIndex, colIndex) => {
    // Change background color
    const inputElement = inputRefs.current[`${rowIndex}-${colIndex}`];
    if (inputElement) {
      inputElement.style.backgroundColor = "#fff";
    }

    // If this is the last column of the last row, add a new row
    if (colIndex === COLUMNS.length - 1 && rowIndex === tableData.length - 1) {
      handleAddRow();
    }

    // If this is a dropdown column, show the dropdown
    const columnType = getColumnType(colIndex);
    if (isDropdownColumn(columnType)) {
      if (columnType === "productGroup") {
        const productGroupCell = tableData[rowIndex]?.data?.find(
          (cell) => cell.id === "productGroup",
        );
        const productGroupValue = (productGroupCell?.value || "")
          .toString()
          .trim();
        const hasEnoughChars = productGroupValue.length >= 3;
        if (!hasEnoughChars && productGroupValue) {
          const selected = getProductGroupOptionsList().find(
            (pg) =>
              pg.name === productGroupValue || pg.label === productGroupValue,
          );
          applyPoolHeaderFromGroup(selected);
        }
        const hasResults =
          getFilteredItems(productGroupValue, "productGroup").length > 0;
        if (hasEnoughChars && (hasResults || productGroupApiCalled)) {
          handleDropdownClick(rowIndex, colIndex, columnType);
        }
      } else {
        handleDropdownClick(rowIndex, colIndex, columnType);
      }
    }
  };

  // Trigger file input click
  const triggerFileInput = (rowIndex, colIndex) => {
    const fileInput = fileInputRefs.current[`${rowIndex}-${colIndex}`];
    if (fileInput) {
      fileInput.click();
    }
  };

  // Modify the handleOtherAmountInteraction function
  const handleOtherAmountInteraction = (rowIndex, event) => {
    if (event.type === "dblclick") {
      event.preventDefault();
      openOtherAmountModal(rowIndex);
    } else if (event.type === "keydown" && event.key === "Enter") {
      const now = Date.now();
      if (
        lastEnterPress.rowIndex === rowIndex &&
        now - lastEnterPress.time < 500
      ) {
        // 500ms threshold for double-Enter
        event.preventDefault();
        openOtherAmountModal(rowIndex);
        setLastEnterPress({ time: 0, rowIndex: null });
      } else {
        setLastEnterPress({ time: now, rowIndex });
      }
    } else if (event.type === "click") {
      // Show tooltip for 4 seconds on click
      const tooltipId = `oth-amt-tooltip-${rowIndex}`;
      const tooltip = tooltipRefs.current[tooltipId];

      if (tooltip) {
        // Clear any existing timeout
        if (tooltipTimeoutRef.current) {
          clearTimeout(tooltipTimeoutRef.current);
        }

        // Check if tooltip is already visible
        if (tooltip.style.display === "block") {
          // Reset the timeout to keep it visible
          tooltipTimeoutRef.current = setTimeout(() => {
            tooltip.style.display = "none";
            setActiveTooltip(null);
          }, 4000);
          return; // Exit to prevent further actions
        }

        tooltip.style.display = "block"; // Show tooltip immediately
        setActiveTooltip(tooltipId); // Set active tooltip

        // Set timeout to hide after 4 seconds
        tooltipTimeoutRef.current = setTimeout(() => {
          tooltip.style.display = "none";
          setActiveTooltip(null);
        }, 4000);
      }
    }
  };

  // Add helper function to open modal
  const openOtherAmountModal = (rowIndex) => {
    const currentEntries =
      tableData[rowIndex].data.find((cell) => cell.id === "othAmt")
        .otherAmountEntries || [];
    const currentValue =
      tableData[rowIndex].data.find((cell) => cell.id === "othAmt").value || "";

    // If there's a direct value but no entries, create an initial entry
    const initialEntries =
      currentEntries.length > 0
        ? currentEntries.map((entry) => ({
            ...entry,
            rateOn: entry.rateOn || "", // Ensure rateOn is initialized
          }))
        : currentValue
          ? [
              {
                chargeType: "Direct Entry",
                pcs: "",
                ct: "",
                wt: "",
                conPercentage: "",
                rateOn: "",
                rate: "",
                amount: currentValue,
              },
            ]
          : [];

    setOtherAmountModal({
      isOpen: true,
      rowIndex,
      entries: [...initialEntries],
      currentEntry: {
        chargeType: "",
        pcs: "",
        ct: "",
        wt: "",
        conPercentage: "",
        rateOn: "",
        rate: "",
        amount: "",
      },
      editingIndex: undefined,
    });
  };

  // Add function to save other amount entries
  const handleSaveOtherAmountEntries = () => {
    const { rowIndex, entries, currentEntry } = otherAmountModal;

    // If there's data in the current entry, validate and add it to entries
    let finalEntries = [...entries];
    if (currentEntry.amount && currentEntry.chargeType) {
      if (isNaN(currentEntry.amount)) {
        alert("Please enter a valid amount");
        return;
      }
      finalEntries.push({ ...currentEntry });
    }

    // Calculate total amount
    const totalAmount = finalEntries.reduce(
      (sum, entry) => sum + (parseFloat(entry.amount) || 0),
      0,
    );

    // Calculate total less weight
    const totalLessWeight = finalEntries.reduce((sum, entry) => {
      const lessWeight = calculateLessWeight(entry);
      return sum + (isNaN(lessWeight) ? 0 : lessWeight);
    }, 0);

    // Update table data with both values
    setTableData((prev) => {
      const newData = [...prev];
      const row = newData[rowIndex];

      if (!row || !row.data) return prev;

      // Get all required values
      const grWtCell = row.data.find((cell) => cell.id === "grWt");
      const lTypeCell = row.data.find((cell) => cell.id === "lType");
      const lbrPercentageCell = row.data.find(
        (cell) => cell.id === "lbrPercentage",
      );
      const lbrRateCell = row.data.find((cell) => cell.id === "lbrRate");
      const itRateCell = row.data.find((cell) => cell.id === "itRate");
      const itRateOnCell = row.data.find((cell) => cell.id === "itRateOn");
      const productGroupCell = row.data.find(
        (cell) => cell.id === "productGroup",
      );

      const grWt = parseFloat(grWtCell?.value) || 0;
      const lType = lTypeCell?.value;
      const lbrPercentage = parseFloat(lbrPercentageCell?.value) || 0;
      const lbrRate = parseFloat(lbrRateCell?.value) || 0;
      const itRate = parseFloat(itRateCell?.value) || 0;
      const itRateOn = itRateOnCell?.value;

      // Get metal type from product group
      const selectedProductGroup = dropdownData.productGroup.find(
        (pg) => pg.label === productGroupCell?.value,
      );
      const metalType = selectedProductGroup?.metal || "Gold";

      // Update Other Amount
      const othAmtCell = row.data.find((cell) => cell.id === "othAmt");
      if (othAmtCell) {
        othAmtCell.value = formatAmount(totalAmount);
        othAmtCell.otherAmountEntries = finalEntries;
      }

      // Update Less Weight
      const lsWtCell = row.data.find((cell) => cell.id === "lsWt");
      if (lsWtCell) {
        lsWtCell.value = formatLessWeight(totalLessWeight);
      }

      // Calculate and update Net Weight
      const netWeight = calculateNetWeight(grWt, totalLessWeight);
      const netWtCell = row.data.find((cell) => cell.id === "netWt");
      if (netWtCell) {
        netWtCell.value = netWeight.toFixed(2);
      }

      // Calculate Item Amount based on ItRateOn
      const itAmtCell = row.data.find((cell) => cell.id === "itAmt");
      if (itRateCell && itRate && itAmtCell) {
        let baseWeight = 0;
        if (itRateOn === "NWt") {
          baseWeight = netWeight;
        } else if (itRateOn === "GWt") {
          baseWeight = grWt;
        }
        const itAmt = (baseWeight * itRate).toFixed(2);
        itAmtCell.value = itAmt;
      }

      // Calculate Labor Amount
      const lbrAmtCell = row.data.find((cell) => cell.id === "lbrAmt");
      if (lbrAmtCell) {
        let baseWeight = 0;
        if (lType === "NWt") {
          baseWeight = netWeight;
        } else if (lType === "GWt") {
          baseWeight = grWt;
        }

        let lbrAmt = 0;
        if (lbrPercentage > 0) {
          lbrAmt = calculateLbrAmtWithPercentage(
            baseWeight,
            lbrPercentage,
            itRate,
          );
        } else if (lbrRate > 0) {
          lbrAmt = calculateLbrAmtWithRate(baseWeight, lbrRate);
        }
        lbrAmtCell.value = lbrAmt.toFixed(2);
      }

      // Calculate Total Amount
      const itAmt = parseFloat(itAmtCell?.value) || 0;
      const lbrAmt = parseFloat(lbrAmtCell?.value) || 0;
      const othAmt = parseFloat(othAmtCell?.value) || 0;
      const mrpCell = row.data.find((cell) => cell.id === "mrp");
      const mrp = parseFloat(mrpCell?.value) || 0;

      let totalAmtValue = 0;
      if (mrp > 0) {
        totalAmtValue = mrp;
      } else {
        totalAmtValue = itAmt + lbrAmt + othAmt;
      }
      const totalAmt = roundLineTotalAmount(totalAmtValue);

      const totalAmtCell = row.data.find((cell) => cell.id === "totalAmt");
      if (totalAmtCell) {
        if (!totalAmtCell.totalAmountDetails?.isManual) {
          totalAmtCell.value = totalAmt;
          if (totalAmtCell.totalAmountDetails) {
            delete totalAmtCell.totalAmountDetails;
          }
        }
      }

      return newData;
    });

    // Close modal after saving
    setOtherAmountModal((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };

  // Add function to handle column width changes
  const handleOtherAmountColumnWidthChange = (column, newWidth) => {
    setOtherAmountColumnWidths((prev) => ({
      ...prev,
      [column]: `${newWidth}px`,
    }));
  };

  // Add this function right before the return statement in the Table component
  // Function to position tooltip based on screen size
  const positionTooltip = (targetElement, tooltip) => {
    const rect = targetElement.getBoundingClientRect();
    tooltip.style.display = "block";

    // Get arrow element
    const arrow = tooltip.querySelector(".tooltip-arrow");

    // Responsive positioning based on viewport
    const viewportWidth = window.innerWidth;

    if (viewportWidth < 576) {
      // Small screens (Bootstrap's sm breakpoint)
      // Position directly below the "i" button
      tooltip.style.left = `${rect.left + rect.width / 2 - 100}px`; // Center horizontally (tooltip width is 200px)
      tooltip.style.top = `${rect.bottom + 10}px`; // Position below the button
      tooltip.style.maxWidth = "calc(100vw - 20px)"; // 10px padding on each side

      // Position arrow at top center
      if (arrow) {
        arrow.style.top = "-6px"; // Adjusted for better alignment
        arrow.style.left = "50%";
        arrow.style.transform = "translateX(-50%) rotate(45deg)";
        arrow.style.borderRight = "none";
        arrow.style.borderBottom = "none";
        arrow.style.borderLeft = "1px solid rgba(0,0,0,0.1)";
        arrow.style.borderTop = "1px solid rgba(0,0,0,0.1)";
      }
    } else {
      // Position to the right on larger screens
      tooltip.style.left = `${rect.right + 10}px`;
      tooltip.style.top = `${rect.top - 5}px`;
      tooltip.style.maxWidth = "300px";

      // Position arrow at left middle
      if (arrow) {
        arrow.style.top = "15px";
        arrow.style.left = "-6px";
        arrow.style.transform = "rotate(45deg)";
        arrow.style.borderRight = "none";
        arrow.style.borderBottom = "none";
      }
    }
  };

  // Update the Rate On dropdown implementation
  const handleRateOnDropdown = (rowIndex, value, isCurrentEntry = false) => {
    if (isCurrentEntry) {
      setOtherAmountModal((prev) => {
        const updatedEntry = {
          ...prev.currentEntry,
          rateOn: value,
        };
        // Calculate amount when rate on changes
        if (updatedEntry.rate) {
          updatedEntry.amount = formatAmount(calculateAmount(updatedEntry));
        }
        return {
          ...prev,
          currentEntry: updatedEntry,
        };
      });
    } else {
      setOtherAmountModal((prev) => {
        const newEntries = [...prev.entries];
        const updatedEntry = {
          ...newEntries[rowIndex],
          rateOn: value,
        };
        // Calculate amount when rate on changes
        if (updatedEntry.rate) {
          updatedEntry.amount = formatAmount(calculateAmount(updatedEntry));
        }
        newEntries[rowIndex] = updatedEntry;
        return {
          ...prev,
          entries: newEntries,
        };
      });
    }

    // Hide the dropdown after selection
    const dropdowns = document.querySelectorAll(".dropdown-menu");
    dropdowns.forEach((dropdown) => {
      if (dropdown.style.display === "block") {
        dropdown.style.display = "none";
      }
    });
  };

  // Add keyboard navigation for Rate On dropdown
  const handleRateOnKeyDown = (e, rowIndex, isCurrentEntry = false) => {
    const currentValue = isCurrentEntry
      ? otherAmountModal.currentEntry.rateOn
      : otherAmountModal.entries[rowIndex].rateOn;

    const filtered = rateOnOptions.filter((option) =>
      option.toLowerCase().includes((currentValue || "").toLowerCase()),
    );

    if (filtered.length === 0) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setHighlightedIndex((prev) =>
          prev < filtered.length - 1 ? prev + 1 : prev,
        );
        break;
      case "ArrowUp":
        e.preventDefault();
        setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : 0));
        break;
      case "Enter":
        e.preventDefault();
        if (filtered[highlightedIndex]) {
          handleRateOnDropdown(
            rowIndex,
            filtered[highlightedIndex],
            isCurrentEntry,
          );
        }
        break;
      case "Escape":
        e.preventDefault();
        // Close dropdown
        const dropdown = e.target.nextElementSibling;
        if (dropdown) {
          dropdown.style.display = "none";
        }
        break;
      default:
        break;
    }
  };

  const getRowEffectiveAmount = (row) => {
    if (!row || !row.data) return 0;

    const mrpCell = row.data.find((cell) => cell.id === "mrp");
    const mrpValue = mrpCell ? parseFloat(mrpCell.value) : NaN;
    const hasMrp =
      mrpCell && mrpCell.value !== "" && !isNaN(mrpValue) && mrpValue > 0;

    if (hasMrp) {
      return Math.round(mrpValue);
    }

    const totalAmtCell = row.data.find((cell) => cell.id === "totalAmt");
    const totalAmtValue = totalAmtCell ? parseFloat(totalAmtCell.value) : NaN;

    return isNaN(totalAmtValue) ? 0 : Math.round(totalAmtValue);
  };

  const reverseCalculateLabor = (row, newTotalAmt) => {
    const itAmt =
      parseFloat(row.data.find((c) => c.id === "itAmt")?.value) || 0;
    const othAmt =
      parseFloat(row.data.find((c) => c.id === "othAmt")?.value) || 0;

    // 1. Calculate lbrAmt
    const lbrAmt = Math.max(newTotalAmt - itAmt - othAmt, 0);

    // Update lbrAmt cell
    const lbrAmtCell = row.data.find((c) => c.id === "lbrAmt");
    if (lbrAmtCell) {
      lbrAmtCell.value = lbrAmt.toFixed(2);
      if (lbrAmtCell.isManual) {
        delete lbrAmtCell.isManual;
      }
    }

    // 2. Get Base Weight
    const lTypeCell = row.data.find((c) => c.id === "lType");
    const lType = (lTypeCell?.value || "").toString().trim().toUpperCase();
    let baseWeight = 0;

    if (lType === "NWT") {
      baseWeight =
        parseFloat(row.data.find((c) => c.id === "netWt")?.value) || 0;
    } else if (lType === "GWT") {
      baseWeight =
        parseFloat(row.data.find((c) => c.id === "grWt")?.value) || 0;
    } else if (lType === "PCS") {
      baseWeight = parseFloat(row.data.find((c) => c.id === "pcs")?.value) || 0;
    }

    // 3. Calculate lbrRate
    let lbrRate = 0;
    if (baseWeight > 0) {
      lbrRate = lbrAmt / baseWeight;
    }

    // Update lbrRate cell
    const lbrRateCell = row.data.find((c) => c.id === "lbrRate");
    if (lbrRateCell) {
      lbrRateCell.value = lbrRate.toFixed(2);
    }

    // 4. Calculate lbrPercentage
    const itRateCell = row.data.find((c) => c.id === "itRate");
    const itRate = parseFloat(itRateCell?.value) || 0;
    let lbrPercentage = 0;

    // Calculate percentage based on rates if available
    if (itRate > 0) {
      lbrPercentage = (lbrRate / itRate) * 100;
    }
    // Fallback: try using amounts if rate is missing but amount exists
    else if (itAmt > 0 && baseWeight > 0) {
      const implicitRate = itAmt / baseWeight;
      if (implicitRate > 0) {
        lbrPercentage = (lbrRate / implicitRate) * 100;
      }
    }

    // Update lbrPercentage cell
    const lbrPercentageCell = row.data.find((c) => c.id === "lbrPercentage");
    if (lbrPercentageCell) {
      lbrPercentageCell.value = lbrPercentage.toFixed(2);
    }
  };

  const handleTotalAmountInteraction = (rowIndex, event) => {
    if (event.type === "dblclick") {
      event.preventDefault();
      openTotalAmountModal(rowIndex);
    } else if (event.type === "keydown" && event.key === "Enter") {
      const now = Date.now();
      if (
        totalAmountEnterPress.rowIndex === rowIndex &&
        now - totalAmountEnterPress.time < 500
      ) {
        event.preventDefault();
        openTotalAmountModal(rowIndex);
        setTotalAmountEnterPress({ time: 0, rowIndex: null });
      } else {
        setTotalAmountEnterPress({ time: now, rowIndex });
      }
    }
  };

  const openTotalAmountModal = (rowIndex) => {
    const row = tableData[rowIndex];
    if (!row) return;

    const totalAmtCell = row.data.find((cell) => cell.id === "totalAmt");
    const currentDetails = totalAmtCell?.totalAmountDetails;

    const currentAmount = currentDetails?.inclusiveAmount
      ? String(currentDetails.inclusiveAmount)
      : totalAmtCell &&
          totalAmtCell.value !== undefined &&
          totalAmtCell.value !== null
        ? String(totalAmtCell.value)
        : "";

    const currentGst = currentDetails?.gst ?? totalAmtCell?.gst ?? "3";

    setTotalAmountModal({
      isOpen: true,
      rowIndex,
      amount: currentAmount,
      gst: String(currentGst || "3"),
    });
  };

  const closeTotalAmountModal = (shouldRefocus = false) => {
    const { rowIndex } = totalAmountModal;

    setTotalAmountModal({
      isOpen: false,
      rowIndex: null,
      amount: "",
      gst: "3",
    });

    if (shouldRefocus && rowIndex !== null) {
      const totalAmtColIndex = COLUMNS.findIndex(
        (col) => col.id === "totalAmt",
      );
      if (totalAmtColIndex !== -1) {
        setTimeout(() => {
          const inputElement =
            inputRefs.current[`${rowIndex}-${totalAmtColIndex}`];
          if (inputElement) {
            inputElement.focus();
            inputElement.select();
          }
        }, 0);
      }
    }
  };

  const handleSaveTotalAmount = () => {
    const { rowIndex, amount, gst } = totalAmountModal;
    if (rowIndex === null) {
      closeTotalAmountModal();
      return;
    }

    const sanitizedAmount =
      typeof amount === "string" ? amount.trim() : String(amount || "");

    const gstPercentage = parseFloat(gst) || 0;
    const numericAmount = parseFloat(sanitizedAmount);
    const hasValidAmount = sanitizedAmount !== "" && !isNaN(numericAmount);

    const divisor = 1 + gstPercentage / 100;
    const baseAmount =
      hasValidAmount && divisor !== 0
        ? (numericAmount / divisor).toFixed(2)
        : "";
    const inclusiveFormatted = hasValidAmount ? numericAmount.toFixed(2) : "";

    setTableData((prevData) => {
      const newData = [...prevData];

      // Deep clone the row data to ensure we don't mutate state directly before returning
      const rowData = newData[rowIndex].data.map((cell) => ({ ...cell }));
      const newRow = { ...newData[rowIndex], data: rowData };

      const totalAmtCell = newRow.data.find((cell) => cell.id === "totalAmt");

      if (totalAmtCell) {
        if (!hasValidAmount) {
          totalAmtCell.value = "";
          if (totalAmtCell.totalAmountDetails) {
            delete totalAmtCell.totalAmountDetails;
          }
        } else {
          totalAmtCell.value = baseAmount;
          totalAmtCell.totalAmountDetails = {
            gst,
            inclusiveAmount: inclusiveFormatted,
            baseAmount,
            isManual: true,
          };
        }
      }

      // Reverse calculate labor if we have a valid amount
      if (hasValidAmount && baseAmount !== "") {
        reverseCalculateLabor(newRow, parseFloat(baseAmount));
      }

      newData[rowIndex] = newRow;
      return newData;
    });

    closeTotalAmountModal(true);
  };

  const calculateTotal = () => {
    if (!tableData) return 0;
    return tableData.reduce((sum, row) => {
      const effectiveAmount = getRowEffectiveAmount(row);
      return sum + effectiveAmount;
    }, 0);
  };

  // Add a helper function for number formatting
  const formatAmount = (value) => {
    if (!value || isNaN(value)) return "";
    // Convert to number and handle rounding based on decimal part
    const num = parseFloat(value);
    const decimalPart = num - Math.floor(num);
    // If decimal part is >= 0.5, round up, otherwise round down
    return decimalPart >= 0.5
      ? Math.ceil(num).toString()
      : Math.floor(num).toString();
  };

  // Update formatLessWeight to always return a value with 2 decimal places
  const formatLessWeight = (value) => {
    // Convert to number first
    const num = parseFloat(value);
    // Check if it's a valid number (including 0)
    if (isNaN(num)) return "0.00";
    // Always return with 2 decimal places
    return num.toFixed(2);
  };

  // Add this function to calculate Labor Amount
  const calculateLbrAmt = (baseWeight, lbrPercentage, lbrRate, metalType) => {
    let lbrAmt = 0;
    if (lbrPercentage > 0) {
      const masterRate =
        metalType === "Gold" ? masterGoldRate : masterSilverRate;
      lbrAmt = calculateLbrAmtWithPercentage(
        baseWeight,
        lbrPercentage,
        masterRate,
      );
    } else if (lbrRate > 0) {
      lbrAmt = calculateLbrAmtWithRate(baseWeight, lbrRate);
    }
    return lbrAmt;
  };

  // Calculate total discount amount based on discount type and value
  const calculateDiscountAmount = () => {
    const totalAmount = calculateTotal();
    if (!discountValue || isNaN(discountValue) || totalAmount <= 0) {
      return 0;
    }
    const discount = parseFloat(discountValue);
    if (discountType === "%") {
      return (totalAmount * discount) / 100;
    } else {
      return discount;
    }
  };

  // Calculate GST amount based on percentage
  const calculateGstAmount = () => {
    const totalAmount = calculateTotal();
    const discountAmt = calculateDiscountAmount();
    const taxableAmount = totalAmount - discountAmt;

    if (!gstPercentage || isNaN(gstPercentage)) {
      return {
        total: 0,
        sgst: 0,
        cgst: 0,
        igst: 0,
      };
    }

    const gstRate = parseFloat(gstPercentage);
    const taxableKey = `${taxableAmount}|${gstRate}`;
    if (
      savedGstKeyRef.current == null &&
      savedGstAmountRef.current != null &&
      taxableAmount > 0
    ) {
      savedGstKeyRef.current = taxableKey;
    }
    if (
      savedGstKeyRef.current === taxableKey &&
      savedGstAmountRef.current != null
    ) {
      const savedTotal = savedGstAmountRef.current;
      const customerStateVal = userssDetails.state || "";
      const isIntraState =
        customerStateVal.toLowerCase() === "gujarat" ||
        customerStateVal.toLowerCase() === "gj";
      return isIntraState
        ? {
            total: savedTotal,
            sgst: savedTotal / 2,
            cgst: savedTotal / 2,
            igst: 0,
          }
        : {
            total: savedTotal,
            sgst: 0,
            cgst: 0,
            igst: savedTotal,
          };
    }

    const totalGstAmount = (taxableAmount * gstRate) / 100;

    // Get the business state (you may need to replace this with your actual business state)
    const businessStateName = "Gujarat";

    // Debug logs
    // console.log("userss Details:", userssDetails);
    // console.log("userss State:", userssDetails.state);
    // console.log("Business State:", businessState);
    // console.log(
    //   "State Comparison:",
    //   userssDetails.state &&
    //     userssDetails.state.toLowerCase() === businessState.toLowerCase()
    // );

    // Check if userss state matches business state (case-insensitive comparison)
    const customerStateVal = userssDetails.state || "";
    const customerStateLower = customerStateVal.toLowerCase();
    const businessStateLower = businessStateName.toLowerCase();
    const businessStateIso2 = (
      states.find((s) => s.name.toLowerCase() === businessStateLower)?.iso2 ||
      ""
    ).toLowerCase();
    const isIntraStateTransaction =
      customerStateLower === businessStateLower ||
      (businessStateIso2 && customerStateLower === businessStateIso2);

    if (isIntraStateTransaction) {
      // For intra-state transactions, split GST into SGST and CGST
      // SGST = (Taxable Amount × X%) ÷ 2
      // CGST = (Taxable Amount × X%) ÷ 2
      const halfGstRate = gstRate / 2;
      const sgstAmount = (taxableAmount * halfGstRate) / 100;
      const cgstAmount = (taxableAmount * halfGstRate) / 100;

      // console.log("Intra-state transaction detected. Splitting GST:");
      // console.log("SGST Amount:", sgstAmount);
      // console.log("CGST Amount:", cgstAmount);

      return {
        total: totalGstAmount,
        sgst: sgstAmount,
        cgst: cgstAmount,
        igst: 0,
      };
    } else {
      // console.log(
      //   "Inter-state transaction detected. Using IGST:",
      //   totalGstAmount
      // );
      // For inter-state transactions, apply full GST as IGST
      return {
        total: totalGstAmount,
        sgst: 0,
        cgst: 0,
        igst: totalGstAmount,
      };
    }
  };

  // Calculate round-off amount
  const calculateRoundOff = (totalAmount, discountAmt, gstAmt) => {
    const amountBeforeRoundOff = totalAmount - discountAmt + gstAmt;
    // Calculate round-off (difference between rounded and actual amount)
    const roundedAmount = Math.round(amountBeforeRoundOff);
    return roundedAmount - amountBeforeRoundOff;
  };

  // Calculate grand total (total amount - discount + GST + round-off)
  const calculateGrandTotal = () => {
    const totalAmount = calculateTotal();
    const discountAmt = calculateDiscountAmount();
    const gstAmt = calculateGstAmount().total;
    const roundOff = parseFloat(roundOffAmount) || 0;

    return (totalAmount - discountAmt + gstAmt + roundOff).toFixed(2);
  };

  // Define product and setProductGroups using useState

  const [design, setDesign] = useState(""); // Initialize design state
  const [size, setSize] = useState(""); // Initialize size state
  const [pcs, setPcs] = useState(0); // Initialize pcs state
  const [grWt, setGrWt] = useState(0); // Initialize grWt state
  const [lsWt, setLsWt] = useState(0); // Initialize lsWt state
  const [netWt, setNetWt] = useState(0); // Initialize netWt state
  const [lType, setLType] = useState(""); // Initialize lType state
  const [lbrPercentage, setLbrPercentage] = useState(0); // Initialize lbrPercentage state
  const [lbrRate, setLbrRate] = useState(0); // Initialize lbrRate state
  const [lbrAmt, setLbrAmt] = useState(0); // Initialize lbramt state
  const [othamt, setOthAmt] = useState(0); // Initialize othAmt state
  const [mrp, setMrp] = useState(0); // Initialize mrp state
  const [image, setImage] = useState(null); // Initialize image state
  const [No, setNo] = useState(0); // Initialize No state (assuming it's a number)
  const [productGroup, setProductGroup] = useState(""); // Initialize productGroup state (assuming it's a string)
  const [showSuccessModal, setShowSuccessModal] = useState(false); // State for modal visibility
  const [discountType, setDiscountType] = useState("%"); // Discount type (% or ₹)
  const [discountValue, setDiscountValue] = useState(""); // Discount value
  const [gstPercentage, setGstPercentage] = useState("3"); // GST percentage
  const [totalAmountModal, setTotalAmountModal] = useState({
    isOpen: false,
    rowIndex: null,
    amount: "",
    gst: "3",
  });
  const [totalAmountEnterPress, setTotalAmountEnterPress] = useState({
    time: 0,
    rowIndex: null,
  });
  const totalAmountInputRef = useRef(null);
  const [roundOffAmount, setRoundOffAmount] = useState(""); // Change to string for input
  const [note, setNote] = useState(""); // Add note state

  useEffect(() => {
    selectedBillTypeIdRef.current = selectedBillTypeId;
  }, [selectedBillTypeId]);

  const applyBillTypeSelection = (billType) => {
    const id = billType?.id != null ? String(billType.id) : "";
    const name = String(billType?.name || "").trim();
    const isQuotation = name.toLowerCase() === "quotation";
    selectedBillTypeIdRef.current = id;
    setSelectedBillTypeId(id);
    setSelectedBillTypeName(name || "GST");
    setEstimateValue(isQuotation ? 1 : 0);
    setGstPercentage(isQuotation ? "0" : "3");
  };

  useEffect(() => {
    const fetchBillTypeOptions = async () => {
      try {
        const response = await requestBillTypesForEdit();
        const rows = Array.isArray(response?.data?.bill_types)
          ? response.data.bill_types
          : [];
        if (!isErpApiSuccess(response) || !Array.isArray(rows)) {
          return;
        }

        const mapped = rows.map((row) => ({
          id: row?.id,
          name: String(row?.name || "").trim(),
        }));
        setBillTypes(mapped);

        if (!selectedBillTypeIdRef.current) {
          const gstType =
            mapped.find((item) => item.name.toLowerCase() === "gst") ||
            mapped[0];
          if (gstType) {
            applyBillTypeSelection(gstType);
          }
        }
      } catch (error) {
        console.error("Error fetching bill types:", error);
      }
    };

    fetchBillTypeOptions();
  }, []);

  // Add resetForm function before handleSubmit
  const resetForm = () => {
    editSaleIdempotencyKeyRef.current = null;
    // Reset old purchase ID
    setBillDate(new Date().toISOString().split("T")[0]);
    setCreatedBy(null);

    // Reset userss fields
    setuserssMobile("");
    setuserssMobileSearchText("");
    setuserssName("");
    setuserssNameSearchText("");
    setuserssAddress("");
    setuserssArea("");
    setuserssCity("");
    setBilledTo(true);
    setBilledMobile("");
    setBilledName("");
    setBilledAddress("");
    setBilledArea("");
    setSelecteduserssId(null);
    setuserssDetails({
      email: "",
      birthDate: "",
      anniversaryDate: "",
      companyName: "",
      companyAddress: "",
      gstNumber: "",
      aadharNo: "",
      panNo: "",
      maritalStatus: "",
      // openingBalance: "",
      // pendingBalance: "",
      balance: "",
      finalBalance: "",
      saleBalance: "",
      reference: "",
      state: "",
    });

    setOldPurchases([]);

    // Reset table data
    setTableData([{ id: 1, data: initialRowData }]);

    // Reset payment rows
    setPaymentRows([
      {
        id: 1,
        method: "cash", // Pre-selected cash
        type: "",
        remarks: "",
        amount: "",
        date: billDate || new Date().toISOString().split("T")[0],
      },
      {
        id: 2,
        method: "cheque", // Pre-selected cheque
        type: "",
        remarks: "",
        amount: "",
        date: billDate || new Date().toISOString().split("T")[0],
      },
      {
        id: 3,
        method: "bank_transfer", // Pre-selected bank transfer
        type: "",
        remarks: "",
        amount: "",
        date: billDate || new Date().toISOString().split("T")[0],
      },
    ]);

    // Reset other fields
    setDiscountType("%");
    setDiscountValue("");
    const gstBillType =
      billTypes.find((item) => item.name.toLowerCase() === "gst") ||
      billTypes[0];
    if (gstBillType) {
      applyBillTypeSelection(gstBillType);
    } else {
      setSelectedBillTypeId("");
      setSelectedBillTypeName("GST");
      setGstPercentage("3");
    }
    setRoundOffAmount("");
    setNote("");
    setFollowUpDate("");
    setApplyDeliveryToday(true);
    setPerItemDeliveryToday({});
  };

  // Convert status string to integer for database compatibility
  const convertStatusToInteger = (status) => {
    if (status === undefined || status === null) return 1; // Default to active

    if (typeof status === "string") {
      switch (status.toLowerCase()) {
        case "active":
          return 1;
        case "pending":
          return 0;
        case "return":
          return 3;
        case "inactive":
          return 2;
        default:
          // If it's a numeric string, convert to integer
          if (!isNaN(parseInt(status))) {
            return parseInt(status);
          } else {
            return 1; // Default to active
          }
      }
    }

    // If it's already a number, return as is
    if (typeof status === "number") {
      return status;
    }

    return 1; // Default fallback
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prevent multiple submissions
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      // Validate required fields
      if (!userssMobile) {
        toast.error("Please select a userss");
        setIsSubmitting(false);
        return;
      }

      if (!createdBy?.value) {
        toast.error("Please select Created By");
        setIsSubmitting(false);
        return;
      }

      // Check if we have a sale ID for editing
      if (!saleId) {
        toast.error("Sale ID is required for editing");
        setIsSubmitting(false);
        return;
      }

      // Resolve customer: list may be empty on edit (show-sale only load); use id from loaded sale
      const mobileNorm = String(userssMobile || "").trim();
      let selecteduserss =
        usersss.find((c) => String(c.mobile || "").trim() === mobileNorm) ||
        null;
      if (
        !selecteduserss &&
        selecteduserssId != null &&
        selecteduserssId !== ""
      ) {
        selecteduserss =
          usersss.find((c) => String(c.id) === String(selecteduserssId)) ||
          null;
      }
      if (
        !selecteduserss &&
        selecteduserssId != null &&
        selecteduserssId !== "" &&
        mobileNorm
      ) {
        selecteduserss = {
          id: selecteduserssId,
          mobile: mobileNorm,
          fullName: userssName || userssNameSearchText || "",
        };
      }
      if (!selecteduserss) {
        toast.error("Invalid userss selected");
        setIsSubmitting(false);
        return;
      }

      // Helper to safely format date
      function getValidISODateString(dateValue) {
        if (!dateValue) return null;
        const date = new Date(dateValue);
        return isNaN(date.getTime()) ? null : date.toISOString().split("T")[0];
      }

      // Format dates safely
      const formattedDate =
        getValidISODateString(billDate) ||
        new Date().toISOString().split("T")[0];
      const formattedFollowupDate = getValidISODateString(followUpDate);

      // Process sales items - CORRECTED ID HANDLING
      const salesItems = [];
      for (let rowIndex = 0; rowIndex < tableData.length; rowIndex++) {
        const rowData = tableData[rowIndex].data.reduce((acc, cell) => {
          acc[cell.id] = cell.value;
          return acc;
        }, {});

        // CRITICAL FIX: Get sales item ID from the cell data, not rowData
        const salesItemIdCell = tableData[rowIndex].data.find(
          (cell) => cell.id === "saleItemId",
        );
        const salesItemId = salesItemIdCell?.value;

        // Alternative: Get it from any cell since you store it in all cells
        const anyCellWithId = tableData[rowIndex].data.find(
          (cell) => cell.saleItemId,
        );
        const backupSalesItemId = anyCellWithId?.saleItemId;

        const finalSalesItemId = salesItemId || backupSalesItemId;

        // Skip empty rows
        if (!rowData.productGroup && !rowData.design) {
          continue;
        }

        // Validate required fields for each row
        if (!rowData.productGroup || !rowData.grWt || !rowData.netWt) {
          throw new Error(`Row ${rowIndex + 1} is missing required fields`);
        }

        const pgCell = tableData[rowIndex].data.find(
          (c) => c.id === "productGroup",
        );
        const pgText = String(rowData.productGroup || "").trim();
        const pgIdFromCell =
          pgCell?.productGroupId != null &&
          !Number.isNaN(Number(pgCell.productGroupId))
            ? Number(pgCell.productGroupId)
            : null;
        const tagNoForResolve =
          (rowData.tagNo && rowData.tagNo.toString().trim()) || "";

        const selectedProductGroup = await resolveProductGroupOption(
          pgText,
          pgIdFromCell,
          tagNoForResolve,
        );

        if (!selectedProductGroup) {
          throw new Error(`Invalid product group in row ${rowIndex + 1}`);
        }

        // Process charges - Include charge IDs for update
        const otherAmtCell = tableData[rowIndex].data.find(
          (cell) => cell.id === "othAmt",
        );
        const charges = mapOtherAmountEntriesForUpdate(
          otherAmtCell?.otherAmountEntries || [],
        );

        // Determine delivery date for the item: item-level override > global flag > per-item checkbox > empty
        // Check if item has its own delivery date set
        const itemLevelDelivery =
          rowData.deliveryDate || rowData.delivery_date || "";
        // Only check per-item selection if tag number exists (since we only show items with tags in the UI)
        const tagNo = (rowData.tagNo && rowData.tagNo.toString().trim()) || "";
        const isPerItemSelected = tagNo ? !!perItemDeliveryToday[tagNo] : false;
        const todayDeliveryDate = new Date().toISOString().split("T")[0];
        const deliveryDateForItem = itemLevelDelivery
          ? itemLevelDelivery
          : applyDeliveryToday
            ? todayDeliveryDate
            : isPerItemSelected
              ? todayDeliveryDate
              : "";

        // Create sales item for UPDATE — align labor + rate fields with Sales.jsx create `items[]`
        const itRateNum = Number(rowData.itRate) || 0;
        const itAmtNum = Number(rowData.itAmt) || 0;
        const totalAmtNum = Number(rowData.totalAmt) || 0;
        const lbrPctNum = Number(rowData.lbrPercentage) || 0;
        const lbrRateNum = Number(rowData.lbrRate) || 0;
        const lbrAmtNum = Number(rowData.lbrAmt) || 0;

        const salesItem = {
          product_group_id: selectedProductGroup.value,
          design: rowData.design,
          tag_no: rowData.tagNo || "",
          size: rowData.size,
          pcs: Number(rowData.pcs),
          gwt: Number(rowData.grWt),
          lwt: Number(rowData.lsWt) || 0,
          nwt: Number(rowData.netWt),
          item_rate_on: mapItemRateOn(rowData.itRateOn),
          // ERP modular names (same as Sales.jsx POST /sales create line items)
          item_rate: itRateNum,
          item_amount: itAmtNum,
          lbr_type: mapLbrTypeForApi(rowData.lType),
          lbr_percent: lbrPctNum,
          lbr_rate: lbrRateNum,
          lbr_amt: lbrAmtNum,
          total_amount: totalAmtNum,
          // Legacy keys (some update handlers still read these)
          itrate: itRateNum,
          itamt: itAmtNum,
          totalamt: totalAmtNum,
          othamt: Number(rowData.othAmt) || 0,
          mrp: Number(rowData.mrp) || 0,
          image: rowData.image || "",
          status: 1, // Send as integer directly (1 = Active)
          charges: charges,
          ...(deliveryDateForItem ? { delivery_date: deliveryDateForItem } : {}),
        };

        // CRITICAL: Always include sales item ID for updates
        if (finalSalesItemId) {
          salesItem.id = finalSalesItemId;
        }

        salesItems.push(salesItem);
      }

      if (salesItems.length === 0) {
        toast.error("No valid product entries to submit");
        return;
      }

      // Process payments — match Sales.jsx create shape: bank_account_id + amount (ERP), plus legacy keys
      const parsePaymentAmount = (v) => {
        const n = parseFloat(
          v === "" || v === null || v === undefined ? NaN : v,
        );
        return Number.isFinite(n) ? n : 0;
      };

      const newPaymentRowIdempotencyKeys = [];
      const newPayableRowIdempotencyKeys = [];
      const needsBankLookup = [...paymentRows, ...payableRows].some((row) => {
        const t = String(row?.type || "").toLowerCase();
        return (
          t === "old_gold" ||
          t === "old_silver" ||
          t.startsWith("__acctname__:")
        );
      });
      let paymentTypesForSubmit = paymentTypes;
      if (needsBankLookup && paymentTypesForSubmit.length === 0) {
        const fetchedPaymentTypes = await fetchPaymentTypes();
        if (
          Array.isArray(fetchedPaymentTypes) &&
          fetchedPaymentTypes.length > 0
        ) {
          paymentTypesForSubmit = fetchedPaymentTypes;
        }
      }

      const validPayments = buildStandardPaymentLines(paymentRows, {
        isUpdate: true,
        paymentTypes: paymentTypesForSubmit,
        payModeLabels: PAYMENT_METHOD_LABELS,
        createKey: createSalesIdempotencyKey,
        persistKeys: newPaymentRowIdempotencyKeys,
      });

      // Process payable rows for `sale_payable[]` backend contract.
      const validPayables = payableRows
        .map((row, rowIndex) => ({ row, rowIndex }))
        .filter(({ row }) => {
          const amt = parsePaymentAmount(row.amount);
          return row.pay_mode && String(row.pay_mode).trim() !== "" && amt > 0;
        })
        .map(({ row, rowIndex }) => {
          let bankTypeValue = null;

          if (
            typeof row.type === "string" &&
            row.type.startsWith("__acctname__:") &&
            row.bankDisplayName &&
            paymentTypesForSubmit.length > 0
          ) {
            const match = paymentTypesForSubmit.find(
              (b) =>
                String(b.label).trim().toLowerCase() ===
                String(row.bankDisplayName).trim().toLowerCase(),
            );
            if (match) {
              bankTypeValue = Number(match.value);
            }
          }

          if (
            bankTypeValue == null &&
            row.type !== undefined &&
            row.type !== null &&
            row.type !== ""
          ) {
            const numericValue = Number(row.type);
            if (!isNaN(numericValue) && numericValue > 0) {
              bankTypeValue = numericValue;
            } else if (
              typeof row.type === "string" &&
              row.type.trim() !== "" &&
              !String(row.type).startsWith("__acctname__:")
            ) {
              bankTypeValue = row.type;
            }
          }

          const amountNum = parsePaymentAmount(row.amount);
          const bankAccountId =
            bankTypeValue != null &&
            bankTypeValue !== "" &&
            !Number.isNaN(Number(bankTypeValue)) &&
            Number(bankTypeValue) > 0
              ? Number(bankTypeValue)
              : undefined;

          const payableData = {
            bank_account_id: bankAccountId,
            amount: amountNum,
            payment_mode: String(
              PAYMENT_METHOD_LABELS[row.pay_mode] || row.pay_mode || "",
            )
              .trim()
              .toUpperCase()
              .replace(/\s+/g, "_"),
            remarks: row.remarks || "",
          };

          const hasExistingPayableLine =
            row.isExistingPayment &&
            row.id != null &&
            row.id !== "" &&
            row.id !== "new";

          if (hasExistingPayableLine) {
            payableData.id = row.id;
          }

          const { idempotency_key: payableIdempotencyKey, generatedKey } =
            resolvePaymentLineIdempotencyKey(
              row,
              hasExistingPayableLine,
              createSalesIdempotencyKey,
            );
          if (payableIdempotencyKey) {
            payableData.idempotency_key = payableIdempotencyKey;
          }
          if (generatedKey) {
            newPayableRowIdempotencyKeys.push({
              index: rowIndex,
              key: generatedKey,
            });
          }

          return payableData;
        });

      if (newPaymentRowIdempotencyKeys.length > 0) {
        setPaymentRows((prev) => {
          const next = [...prev];
          newPaymentRowIdempotencyKeys.forEach(({ rowId, key }) => {
            const idx = next.findIndex((r) => r.id === rowId);
            if (idx >= 0) {
              next[idx] = { ...next[idx], paymentIdempotencyKey: key };
            }
          });
          return next;
        });
      }
      if (newPayableRowIdempotencyKeys.length > 0) {
        setPayableRows((prev) => {
          const next = [...prev];
          newPayableRowIdempotencyKeys.forEach(({ index, key }) => {
            if (next[index]) {
              next[index] = { ...next[index], paymentIdempotencyKey: key };
            }
          });
          return next;
        });
      }

      // console.log("Processed sales items for UPDATE:", salesItems);
      // console.log("Processed payments for UPDATE:", validPayments);

      // Create the data object for UPDATE operation
      const requestData = [
        {
          id: saleId, // Main sale_details ID for updating the main record
          date: formattedDate,
          user_id: selecteduserss.id,
          by_user: Number(createdBy.value),
          final_amount: Number(calculateTotal()), // Use calculated total for final_amount
          bill_type_id: selectedBillTypeId ? Number(selectedBillTypeId) : null,
          bill_type_name: selectedBillTypeName || "",
          estimate: Number(estimateValue) || 0,
          discount: Number(discountValue) || 0,
          discount_amount: calculateDiscountAmount(),
          gst_percent: Number(gstPercentage) || 0,
          gst_amount: calculateGstAmount().total,
          sgst: calculateGstAmount().sgst,
          cgst: calculateGstAmount().cgst,
          igst: calculateGstAmount().igst,
          grand_total: calculateGrandTotal(),
          remaining_amount: calculateRemainingAmount(),
          payable_amount: Number(calculatePayableAmount()) || 0, // Add payable_amount
          followup_date: formattedFollowupDate,
          ...(applyDeliveryToday
            ? { delivery_date: new Date().toISOString().split("T")[0] }
            : {}),
          note: note || "", // Add note field
          round_off: Number(roundOffAmount) || 0, // Add round_off field
          status: 1, // Send as integer directly (1 = Active)
          sales: salesItems, // Each sales item includes its own ID for updating
          payments: validPayments,
        },
      ];
      if (oldPurchases.length > 0) {
        requestData[0].old_purchase = oldPurchases;
        requestData[0].old_metal_details = oldPurchases;
      }
      if (validPayables.length > 0) {
        requestData[0].sale_payable = validPayables;
      }

      // console.log(
      //   "Final UPDATE request data:",
      //   JSON.stringify(requestData, null, 2)
      // );

      // Validate that all items have IDs (optional but recommended)
      const itemsWithoutIds = salesItems.filter((item) => !item.id);
      const paymentsWithoutIds = validPayments.filter((payment) => !payment.id);
      const chargesWithoutIds = salesItems.flatMap((item) =>
        item.charges.filter((charge) => !charge.id),
      );

      if (itemsWithoutIds.length > 0) {
        console.warn(
          `${itemsWithoutIds.length} sales items missing IDs - will create new records`,
        );
      }
      if (paymentsWithoutIds.length > 0) {
        console.warn(
          `${paymentsWithoutIds.length} payments missing IDs - will create new records`,
        );
      }
      if (chargesWithoutIds.length > 0) {
        console.warn(
          `${chargesWithoutIds.length} charges missing IDs - will create new records`,
        );
      }
      // console.log(
      //   "Final UPDATE request data:",
      //   JSON.stringify(requestData, null, 2)
      // );
      const hasItemImages = tableData.some((row) =>
        row?.data?.some((cell) => cell?.id === "image" && cell?.imageFile),
      );
      if (hasItemImages) {
        toast(
          "Line images are not uploaded with the new sale update API; update images from Stock if needed.",
          { icon: "ℹ️" },
        );
      }

      if (!editSaleIdempotencyKeyRef.current) {
        editSaleIdempotencyKeyRef.current = createSalesIdempotencyKey();
      }

      const response = await updateSale({
        ...requestData[0],
        idempotency_key: editSaleIdempotencyKeyRef.current,
      });

      if (isSalesApiSuccess(response)) {
        editSaleIdempotencyKeyRef.current = null;
        toast.success("Sales updated successfully");
        setShowSuccessModal(true);
        setTimeout(() => {
          setShowSuccessModal(false);
          resetForm();
          navigate("/invoice"); // Navigate to /invoice page
        }, 800);
      } else {
        console.error("API Error:", response?.message || "Operation failed");
        toast.error(response?.message || "Operation failed");
      }
    } catch (error) {
      console.error("Error updating sale:", error);
      console.error("Error details:", error.response?.data || error.message);
      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to update the sale. Please try again.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // New function to handle labor calculations
  const handleLaborCalculations = (tableData, rowIndex) => {
    const lTypeCell = tableData[rowIndex].data.find(
      (cell) => cell.id === "lType",
    );
    const lbrPercentageCell = tableData[rowIndex].data.find(
      (cell) => cell.id === "lbrPercentage",
    );
    const lbrRateCell = tableData[rowIndex].data.find(
      (cell) => cell.id === "lbrRate",
    );
    const lbrAmtCell = tableData[rowIndex].data.find(
      (cell) => cell.id === "lbrAmt",
    );
    const productGroupCell = tableData[rowIndex].data.find(
      (cell) => cell.id === "productGroup",
    );

    const lType = lTypeCell?.value || "";
    const lbrPercentage = parseFloat(lbrPercentageCell?.value) || 0;
    const lbrRate = parseFloat(lbrRateCell?.value) || 0;
    const selectedProductGroup = dropdownData.productGroup.find(
      (pg) => pg.label === productGroupCell?.value,
    );
    const metalType = selectedProductGroup?.metal || "Gold"; // Default to Gold if not found
    const masterRate = metalType === "Gold" ? masterGoldRate : masterSilverRate;
    const perGramRate = calculatePerGramRate(masterRate, metalType);

    // If the labor type is Fixed, clear the percentage and rate fields
    if (lType === "Fixed") {
      if (lbrPercentageCell) lbrPercentageCell.value = "";
      if (lbrRateCell) lbrRateCell.value = "";
      return; // No need to calculate anything for Fixed type
    }

    // Determine the base weight based on labor type
    let baseWeight = 0;
    if (lType === "NWt") {
      const netWtCell = tableData[rowIndex].data.find(
        (cell) => cell.id === "netWt",
      );
      baseWeight = parseFloat(netWtCell?.value) || 0;
    } else if (lType === "GWt") {
      const grWtCell = tableData[rowIndex].data.find(
        (cell) => cell.id === "grWt",
      );
      baseWeight = parseFloat(grWtCell?.value) || 0;
    } else if (lType === "Pcs") {
      const pcsCell = tableData[rowIndex].data.find(
        (cell) => cell.id === "pcs",
      );
      baseWeight = parseFloat(pcsCell?.value) || 0;
    }

    // Calculate labor amount based on which field was last changed
    let lbrAmt = 0;
    const lastChangedField = tableData[rowIndex].lastChangedLaborField;

    if (lastChangedField === "lbrPercentage" && lbrPercentage > 0) {
      lbrAmt = calculateLbrAmtWithPercentage(
        baseWeight,
        lbrPercentage,
        masterRate,
        metalType,
      );
      // Update labor rate based on percentage
      if (lbrRateCell) {
        lbrRateCell.value = ((lbrPercentage / 100) * perGramRate).toFixed(2);
      }
    } else if (lastChangedField === "lbrRate" && lbrRate > 0) {
      lbrAmt = calculateLbrAmtWithRate(baseWeight, lbrRate);
      // Update labor percentage based on rate
      if (lbrPercentageCell) {
        lbrPercentageCell.value = ((lbrRate / perGramRate) * 100).toFixed(2);
      }
    } else if (!lastChangedField) {
      // If no field was changed yet (e.g., when changing lType), prefer percentage if available
      if (lbrPercentage > 0) {
        lbrAmt = calculateLbrAmtWithPercentage(
          baseWeight,
          lbrPercentage,
          masterRate,
          metalType,
        );
      } else if (lbrRate > 0) {
        lbrAmt = calculateLbrAmtWithRate(baseWeight, lbrRate);
      }
    }

    // Update the labor amount cell
    if (lbrAmtCell) {
      lbrAmtCell.value = Math.round(lbrAmt).toString();
      // Recalculate total amount
      calculateTotalAmount(tableData, rowIndex);
    }
  };

  // Handle userss mobile input change
  const handleuserssMobileChange = (e) => {
    const value = sanitizeMobileInput(e.target.value);
    setuserssMobileSearchText(value);
    setuserssMobile(value);
    setuserssMobileDropdownActive(true);
    setuserssMobileHighlightedIndex(0);
    setSelecteduserssId(null);
    setIsNewuserss(true);
  };

  // Get filtered usersss based on mobile number
  const getFilteredusersssByMobile = (searchText) => {
    if (!searchText) return usersss;
    const searchLower = searchText.toLowerCase();
    return usersss.filter((item) =>
      item.mobile.toLowerCase().includes(searchLower),
    );
  };

  // Function to handle userss mobile selection
  const handleuserssMobileSelect = (selectedItem) => {
    setuserssMobile(selectedItem.mobile);
    setuserssMobileSearchText(selectedItem.mobile);
    setuserssMobileDropdownActive(false);
    setSelecteduserssId(selectedItem.id);

    // Auto-fill other userss fields
    setuserssName(selectedItem.fullName);
    setuserssNameSearchText(selectedItem.fullName);
    setuserssAddress(selectedItem.address);
    setuserssArea(selectedItem.area);
    setuserssCity(selectedItem.city);

    // Set all userss details
    setuserssDetails({
      email: selectedItem.email || "",
      birthDate: selectedItem.birthDate || "",
      anniversaryDate: selectedItem.anniversaryDate || "",
      companyName: selectedItem.companyName || "",
      companyAddress: selectedItem.companyAddress || "",
      gstNumber: selectedItem.gstNumber || "",
      aadharNo: selectedItem.aadharNo || "",
      panNo: selectedItem.panNo || "",
      maritalStatus: selectedItem.maritalStatus || "",
      // openingBalance: selectedItem.openingBalance || "",
      // pendingBalance: selectedItem.pendingBalance || "",
      balance: selectedItem.balance || "",
      finalBalance: selectedItem.finalBalance || "",
      saleBalance: selectedItem.saleBalance || "",
      reference: selectedItem.reference || "",
      state: selectedItem.state || "",
    });

    setIsNewuserss(false);
  };

  // Handle key navigation in userss mobile dropdown
  const handleuserssMobileKeyDown = (e) => {
    const filtered = getFilteredusersssByMobile(userssMobileSearchText);

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setuserssMobileHighlightedIndex((prevIndex) => {
          const newIndex =
            prevIndex < filtered.length - 1 ? prevIndex + 1 : prevIndex;
          // Scroll the highlighted item into view
          if (userssMobileItemsRef.current[newIndex]) {
            userssMobileItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "ArrowUp":
        e.preventDefault();
        setuserssMobileHighlightedIndex((prevIndex) => {
          const newIndex = prevIndex > 0 ? prevIndex - 1 : 0;
          // Scroll the highlighted item into view
          if (userssMobileItemsRef.current[newIndex]) {
            userssMobileItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "Enter":
        e.preventDefault();
        if (filtered.length > 0 && userssMobileDropdownActive) {
          handleuserssMobileSelect(filtered[userssMobileHighlightedIndex]);
        }
        break;
      case "Escape":
        e.preventDefault();
        setuserssMobileDropdownActive(false);
        break;
      case "Tab":
        setuserssMobileDropdownActive(false);
        break;
      default:
        break;
    }
  };

  // Close userss mobile dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        userssMobileDropdownRef.current &&
        !userssMobileDropdownRef.current.contains(event.target) &&
        userssMobileInputRef.current &&
        !userssMobileInputRef.current.contains(event.target)
      ) {
        setuserssMobileDropdownActive(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Render userss mobile dropdown
  const renderuserssMobileDropdown = () => {
    if (!userssMobileDropdownActive) return null;

    const filtered = getFilteredusersssByMobile(userssMobileSearchText);

    // Reset refs array
    userssMobileItemsRef.current = [];

    // Calculate width based on input field
    const inputWidth = userssMobileInputRef.current
      ? userssMobileInputRef.current.offsetWidth
      : 150;
    const inputRect = userssMobileInputRef.current
      ? userssMobileInputRef.current.getBoundingClientRect()
      : null;

    if (!inputRect) return null;

    return ReactDOM.createPortal(
      <div
        ref={userssMobileDropdownRef}
        className="dropdown-menu show shadow-sm"
        style={{
          position: "absolute",
          top: `${inputRect.bottom}px`,
          left: `${inputRect.left}px`,
          width: `${inputWidth}px`,
          minWidth: `${inputWidth}px`,
          maxWidth: `${inputWidth}px`,
          maxHeight: "150px", // Reduced from 200px to show ~5 items
          overflowY: "auto",
          zIndex: 9999,
          border: "1px solid rgba(0,0,0,.15)",
          borderRadius: "0.25rem",
          padding: "0.5rem 0",
          backgroundColor: "#fff",
        }}
      >
        {filtered.length > 0 ? (
          filtered.map((item, idx) => {
            const isSelected =
              item.mobile.toLowerCase() ===
              userssMobileSearchText.toLowerCase();

            return (
              <div
                key={idx}
                ref={(el) => (userssMobileItemsRef.current[idx] = el)}
                className={`dropdown-item ${
                  idx === userssMobileHighlightedIndex ? "active" : ""
                }`}
                title={`${item.mobile} - ${item.fullName}`}
                style={{
                  cursor: "pointer",
                  padding: "0.25rem 1rem",
                  fontSize: "0.85rem",
                  backgroundColor:
                    idx === userssMobileHighlightedIndex
                      ? "var(--theme-primary)"
                      : isSelected
                        ? "#f0f0f0"
                        : "transparent",
                  color:
                    idx === userssMobileHighlightedIndex ? "#fff" : "inherit",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  transition: "background-color 0.2s, color 0.2s",
                }}
                onMouseEnter={() => setuserssMobileHighlightedIndex(idx)}
                onMouseDown={() => handleuserssMobileSelect(item)}
              >
                {item.mobile} - {item.fullName}
              </div>
            );
          })
        ) : (
          <div className="dropdown-item disabled">No matching usersss</div>
        )}
      </div>,
      document.getElementById("dropdown-portal"),
    );
  };

  // Handle userss name input change
  const handleuserssNameChange = (e) => {
    const value = e.target.value;
    setuserssNameSearchText(value);
    setuserssNameDropdownActive(true);
    setuserssNameHighlightedIndex(0);
    setSelecteduserssId(null);
    setIsNewuserss(true);
  };

  // Get filtered usersss based on name
  const getFilteredusersssByName = (searchText) => {
    if (!searchText) return userssS;
    const searchLower = searchText.toLowerCase();
    return userssS.filter((item) =>
      item.name.toLowerCase().includes(searchLower),
    );
  };
  // Function to handle userss name selection
  const handleuserssNameSelect = (selectedItem) => {
    setuserssName(selectedItem.name);
    setuserssNameSearchText(selectedItem.name);
    setuserssNameDropdownActive(false);
    setSelecteduserssId(selectedItem.id);

    // Auto-fill other userss fields
    setuserssMobile(selectedItem.mobile);
    setuserssMobileSearchText(selectedItem.mobile);
    setuserssAddress(selectedItem.address);
    setuserssArea(selectedItem.area);
    setuserssCity(selectedItem.city);

    // Set all userss details
    setuserssDetails({
      email: selectedItem.email || "",
      birthDate: selectedItem.birthDate || "",
      anniversaryDate: selectedItem.anniversaryDate || "",
      companyName: selectedItem.companyName || "",
      companyAddress: selectedItem.companyAddress || "",
      gstNumber: selectedItem.gstNumber || "",
      aadharNo: selectedItem.aadharNo || "",
      panNo: selectedItem.panNo || "",
      maritalStatus: selectedItem.maritalStatus || "",
      // openingBalance: selectedItem.openingBalance || "",
      // pendingBalance: selectedItem.pendingBalance || "",
      balance: selectedItem.balance || "",
      finalBalance: selectedItem.finalBalance || "",
      saleBalance: selectedItem.saleBalance || "",
      reference: selectedItem.reference || "",
      state: selectedItem.state || "",
    });

    setIsNewuserss(false);
  };

  // Handle key navigation in userss name dropdown
  const handleuserssNameKeyDown = (e) => {
    const filtered = getFilteredusersssByName(userssNameSearchText);

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setuserssNameHighlightedIndex((prevIndex) => {
          const newIndex =
            prevIndex < filtered.length - 1 ? prevIndex + 1 : prevIndex;
          // Scroll the highlighted item into view
          if (userssNameItemsRef.current[newIndex]) {
            userssNameItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "ArrowUp":
        e.preventDefault();
        setuserssNameHighlightedIndex((prevIndex) => {
          const newIndex = prevIndex > 0 ? prevIndex - 1 : 0;
          // Scroll the highlighted item into view
          if (userssNameItemsRef.current[newIndex]) {
            userssNameItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "Enter":
        e.preventDefault();
        if (filtered.length > 0 && userssNameDropdownActive) {
          handleuserssNameSelect(filtered[userssNameHighlightedIndex]);
        }
        break;
      case "Escape":
        e.preventDefault();
        setuserssNameDropdownActive(false);
        break;
      case "Tab":
        setuserssNameDropdownActive(false);
        break;
      default:
        break;
    }
  };

  // Close userss name dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        userssNameDropdownRef.current &&
        !userssNameDropdownRef.current.contains(event.target) &&
        userssNameInputRef.current &&
        !userssNameInputRef.current.contains(event.target)
      ) {
        setuserssNameDropdownActive(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Render userss name dropdown
  const renderuserssNameDropdown = () => {
    if (!userssNameDropdownActive) return null;

    const filtered = getFilteredusersssByName(userssNameSearchText);

    // Reset refs array
    userssNameItemsRef.current = [];

    // Calculate width based on input field
    const inputWidth = userssNameInputRef.current
      ? userssNameInputRef.current.offsetWidth
      : 150;
    const inputRect = userssNameInputRef.current
      ? userssNameInputRef.current.getBoundingClientRect()
      : null;

    if (!inputRect) return null;

    return ReactDOM.createPortal(
      <div
        ref={userssNameDropdownRef}
        className="dropdown-menu show shadow-sm"
        style={{
          position: "absolute",
          top: `${inputRect.bottom}px`,
          left: `${inputRect.left}px`,
          width: `${inputWidth}px`,
          minWidth: `${inputWidth}px`,
          maxWidth: `${inputWidth}px`,
          maxHeight: "150px", // Reduced from 200px to show ~5 items
          overflowY: "auto",
          zIndex: 9999,
          border: "1px solid rgba(0,0,0,.15)",
          borderRadius: "0.25rem",
          padding: "0.5rem 0",
          backgroundColor: "#fff",
        }}
      >
        {filtered.length > 0 ? (
          filtered.map((item, idx) => {
            const isSelected =
              item.name.toLowerCase() === userssNameSearchText.toLowerCase();

            return (
              <div
                key={idx}
                ref={(el) => (userssNameItemsRef.current[idx] = el)}
                className={`dropdown-item ${
                  idx === userssNameHighlightedIndex ? "active" : ""
                }`}
                title={`${item.name} - ${item.mobile}`}
                style={{
                  cursor: "pointer",
                  padding: "0.25rem 1rem",
                  fontSize: "0.85rem",
                  backgroundColor:
                    idx === userssNameHighlightedIndex
                      ? "var(--theme-primary)"
                      : isSelected
                        ? "#f0f0f0"
                        : "transparent",
                  color:
                    idx === userssNameHighlightedIndex ? "#fff" : "inherit",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  transition: "background-color 0.2s, color 0.2s",
                }}
                onMouseEnter={() => setuserssNameHighlightedIndex(idx)}
                onMouseDown={() => handleuserssNameSelect(item)}
              >
                {item.name} - {item.mobile}
              </div>
            );
          })
        ) : (
          <div className="dropdown-item disabled">No matching usersss</div>
        )}
      </div>,
      document.getElementById("dropdown-portal"),
    );
  };

  // Handle userss address change
  const handleuserssAddressChange = (e) => {
    setuserssAddress(e.target.value);
  };

  // Handle userss city change
  const handleuserssCityChange = (e) => {
    setuserssCity(e.target.value);
  };

  // Function to save a new userss
  const handleSaveuserss = async () => {
    if (!userssMobileSearchText || !userssNameSearchText) {
      toast.error("Mobile number and name are required");
      return;
    }

    try {
      const response = await createCustomerUser({
        mobile: userssMobileSearchText.trim(),
        name: userssNameSearchText.trim(),
        address: userssAddress || undefined,
        city: userssCity || undefined,
        state: userssDetails.state || undefined,
      });

      if (response?.success) {
        toast.success("Userss created successfully");

        setuserssMobile("");
        setuserssMobileSearchText("");
        setuserssName("");
        setuserssNameSearchText("");
        setuserssAddress("");
        setuserssArea("");
        setuserssCity("");
        setuserssDetails((prev) => ({ ...prev, state: "" }));

        setIsNewuserss(false);
        fetchuserss();
      } else {
        toast.error(response?.message || "Failed to save userss");
      }
    } catch (error) {
      console.error("Error saving userss:", error);
      toast.error("Error saving userss");
    }
  };

  const [paymentTypes, setPaymentTypes] = useState([]);

  const [isPaymentDropdownOpen, setIsPaymentDropdownOpen] = useState(false);
  const paymentDropdownRef = useRef(null);

  // Initialize payment rows state with three common payment methods
  const [paymentRows, setPaymentRows] = useState([
    {
      id: 1,
      pay_mode: "cash", // Pre-selected cash
      type: "",
      remarks: "",
      amount: "",
      date: new Date().toISOString().split("T")[0], // Default to today's date
    },
    {
      id: 2,
      pay_mode: "cheque", // Pre-selected cheque
      type: "",
      remarks: "",
      amount: "",
      date: new Date().toISOString().split("T")[0], // Default to today's date
    },
    {
      id: 3,
      pay_mode: "bank_transfer", // Pre-selected bank transfer
      type: "",
      remarks: "",
      amount: "",
      date: new Date().toISOString().split("T")[0], // Default to today's date
    },
  ]);

  // Initialize payable rows state
  const [payableRows, setPayableRows] = useState([
    {
      id: 1,
      pay_mode: "cash",
      type: "",
      remarks: "",
      amount: "",
    },
    {
      id: 2,
      pay_mode: "cheque",
      type: "",
      remarks: "",
      amount: "",
    },
    {
      id: 3,
      pay_mode: "bank_transfer",
      type: "",
      remarks: "",
      amount: "",
    },
  ]);

  // When bank accounts load, map __acctname__:* placeholders to real bank_account ids by label
  useEffect(() => {
    if (!Array.isArray(paymentTypes) || paymentTypes.length === 0) return;

    const upgrade = (rows) => {
      let changed = false;
      const next = rows.map((row) => {
        if (
          !row.bankDisplayName ||
          !row.type ||
          !String(row.type).startsWith("__acctname__:")
        ) {
          return row;
        }
        const match = paymentTypes.find(
          (b) =>
            String(b.label).trim().toLowerCase() ===
            String(row.bankDisplayName).trim().toLowerCase(),
        );
        if (match && String(match.value) !== String(row.type)) {
          changed = true;
          return { ...row, type: String(match.value) };
        }
        return row;
      });
      return changed ? next : rows;
    };

    setPaymentRows((prev) => upgrade(prev));
    setPayableRows((prev) => upgrade(prev));
  }, [paymentTypes]);

  // Initialize refund rows state (Red Table)
  const [refundRows, setRefundRows] = useState([
    {
      id: 1,
      pay_mode: "cash",
      type: "",
      remarks: "",
      amount: "",
      date: new Date().toISOString().split("T")[0],
    },
    {
      id: 2,
      pay_mode: "cheque",
      type: "",
      remarks: "",
      amount: "",
      date: new Date().toISOString().split("T")[0],
    },
    {
      id: 3,
      pay_mode: "bank_transfer",
      type: "",
      remarks: "",
      amount: "",
      date: new Date().toISOString().split("T")[0],
    },
  ]);

  const addRefundRow = () => {
    const newRow = {
      id: refundRows.length + 1,
      pay_mode: "",
      type: "",
      remarks: "",
      amount: "",
      date: billDate || new Date().toISOString().split("T")[0],
    };
    setRefundRows([...refundRows, newRow]);
  };

  // Helper function to parse numeric values
  const parseNumericValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return 0;
    }
    const numeric = parseFloat(value);
    return Number.isNaN(numeric) ? 0 : numeric;
  };

  // Function to add a new payment row
  // Auto-select type for existing payment rows when bank accounts are loaded
  useEffect(() => {
    if (bankAccounts.length > 0 && paymentRows.length > 0) {
      let hasChanges = false;
      const updatedRows = paymentRows.map((row) => {
        // Skip if type is already set and valid
        if (row.type && row.type !== "") return row;

        const mode = row.pay_mode;
        if (["cash", "wallet", "Wallet"].includes(mode)) {
          const findAccount = (keyword) =>
            bankAccounts.find(
              (b) =>
                (b.accountType &&
                  (b.accountType.toLowerCase() === keyword.toLowerCase() ||
                    b.accountType.toLowerCase() ===
                      keyword.toLowerCase().replace("_", " "))) ||
                (b.bankName &&
                  b.bankName
                    .toLowerCase()
                    .includes(keyword.toLowerCase().replace("_", " "))),
            );

          const account = findAccount(mode);
          if (account) {
            hasChanges = true;
            return { ...row, type: String(account.id) };
          }
        }
        return row;
      });

      if (hasChanges) {
        setPaymentRows(updatedRows);
      }
    }
  }, [bankAccounts, paymentRows.length]);

  // Auto-select type for existing payable rows when bank accounts are loaded
  useEffect(() => {
    if (bankAccounts.length > 0 && payableRows.length > 0) {
      let hasChanges = false;
      const updatedRows = payableRows.map((row) => {
        // Skip if type is already set and valid
        if (row.type && row.type !== "") return row;

        const mode = row.pay_mode;
        if (["cash", "wallet", "Wallet"].includes(mode)) {
          const findAccount = (keyword) =>
            bankAccounts.find(
              (b) =>
                (b.accountType &&
                  (b.accountType.toLowerCase() === keyword.toLowerCase() ||
                    b.accountType.toLowerCase() ===
                      keyword.toLowerCase().replace("_", " "))) ||
                (b.bankName &&
                  b.bankName
                    .toLowerCase()
                    .includes(keyword.toLowerCase().replace("_", " "))),
            );

          const account = findAccount(mode);
          if (account) {
            hasChanges = true;
            return { ...row, type: String(account.id) };
          }
        }
        return row;
      });

      if (hasChanges) {
        setPayableRows(updatedRows);
      }
    }
  }, [bankAccounts, payableRows.length]);

  // Function to handle refund row change (Red Table)
  const handleRefundRowChange = (rowId, field, value) => {
    const updatedRows = refundRows.map((row) =>
      row.id === rowId ? { ...row, [field]: value } : row,
    );
    setRefundRows(updatedRows);
  };

  // Function to handle focus on refund amount field
  const handleRefundAmountFieldFocus = (rowId) => {
    // Check if this is the last row in the list
    if (rowId === refundRows[refundRows.length - 1].id) {
      // Add a new row when the amount field of the last row is focused
      addRefundRow();
    }
  };

  const handlePaymentTypeChange = (type) => {
    setPaymentTypes({
      ...paymentTypes,
      [type]: !paymentTypes[type],
    });
  };

  // Close payment dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        paymentDropdownRef.current &&
        !paymentDropdownRef.current.contains(event.target)
      ) {
        setIsPaymentDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [paymentDropdownRef]);

  const getSelectedPaymentTypes = () => {
    const selected = Object.entries(paymentTypes)
      .filter(([_, isSelected]) => isSelected)
      .map(([type, _]) => {
        // Format the payment type label
        if (type === "bankTransfer") return "Bank Transfer";
        return type.charAt(0).toUpperCase() + type.slice(1);
      });

    return selected.length > 0 ? selected.join(", ") : "Select Payment Type";
  };

  // Payment details state
  const [paymentDetails, setPaymentDetails] = useState({
    cash: { amount: "" },
    card: { amount: "" },
    upi: { amount: "" },
    bankTransfer: { amount: "" },
    other: { kashar: "" },
  });

  const handlePaymentDetailChange = (type, field, value) => {
    setPaymentDetails({
      ...paymentDetails,
      [type]: {
        ...paymentDetails[type],
        [field]: value,
      },
    });
  };

  // Payment completion tracking state
  // const [followUpDate, setFollowUpDate] = useState("");
  const [paymentRemarks, setPaymentRemarks] = useState("");
  // Delivery date flag (applies to all items unless item-level override is provided)
  const [applyDeliveryToday, setApplyDeliveryToday] = useState(true);
  // Per-item delivery selection when global is OFF (keyed by tag or fallback key)
  const [perItemDeliveryToday, setPerItemDeliveryToday] = useState({});

  // Calculate total amount from payment rows
  const calculatePaymentTotal = () => {
    return paymentRows
      .reduce((sum, row) => {
        const amount = parseFloat(row.amount) || 0;
        return sum + amount;
      }, 0)
      .toFixed(2);
  };

  // Calculate remaining amount (Grand Total - Payment Total)
  const calculateRemainingAmount = () => {
    // Get grand total without the currency symbol
    const grandTotal = parseFloat(
      calculateGrandTotal().replace(/[^\d.-]/g, ""),
    );
    const paymentTotal = parseFloat(calculatePaymentTotal());

    const remaining = grandTotal - paymentTotal;
    // Return 0 if negative or very small number (accounting for floating point errors)
    return Math.max(0, remaining).toFixed(2);
  };

  // Calculate payable amount (excess received minus cash already paid out)
  const calculatePayableAmount = () => {
    const totalPaid = parseFloat(calculatePaymentTotal()) || 0;
    const grandTotal =
      parseFloat(calculateGrandTotal().replace(/[^\d.-]/g, "")) || 0;
    const paidOut = payableRows.reduce(
      (sum, row) => sum + (parseFloat(row.amount) || 0),
      0,
    );

    if (totalPaid > grandTotal) {
      return Math.max(0, totalPaid - grandTotal - paidOut).toFixed(2);
    }
    return "0.00";
  };

  // Add CSS to remove number input spinners
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      /* Remove number input spinners */
      input[type="number"]::-webkit-inner-spin-button,
      input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      input[type="number"] {
        -moz-appearance: textfield;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Handle userss state change
  const handleuserssStateChange = (e) => {
    setuserssDetails({
      ...userssDetails,
      state: e.target.value,
    });
  };

  // Handle round-off amount change
  const handleRoundOffChange = (e) => {
    handleRoundOffInputChange(e, setRoundOffAmount);
  };

  return (
    <div className={`body-wrapper ${cardClass}`}>
      <div className="container-fluid">
        <div className={`card shadow-sm ${cardClass}`}>
          <div className="px-4 py-3 border-bottom">
            <div className="d-flex align-items-center flex-wrap gap-3 w-100">
              <h4 className="card-title mb-0 text-nowrap">Edit Sales</h4>
              <div className="d-flex align-items-center flex-shrink-0">
                <div className="d-flex align-items-center">
                  <label
                    className="form-label me-2 mb-0 text-nowrap"
                    style={{
                      minWidth: "74px",
                      fontSize: "0.85rem",
                      fontWeight: "600",
                    }}
                  >
                    Bill Type:
                  </label>
                  <div style={billTypeHeaderSelectWrapStyle}>
                    <Select
                      styles={billTypeHeaderSelectStyles}
                      menuPlacement="bottom"
                      isSearchable={false}
                      options={billTypes
                        .filter(
                          (item) =>
                            String(item.id) !==
                            String(selectedBillTypeId || ""),
                        )
                        .map((item) => ({
                          value: String(item.id),
                          label: item.name,
                        }))}
                      value={(() => {
                        const selected =
                          billTypes.find(
                            (item) =>
                              String(item.id) === String(selectedBillTypeId),
                          ) ||
                          billTypes.find(
                            (item) => item.name.toLowerCase() === "gst",
                          ) ||
                          null;
                        return selected
                          ? {
                              value: String(selected.id),
                              label: selected.name,
                            }
                          : null;
                      })()}
                      onChange={(option) => {
                        const selected = billTypes.find(
                          (item) => String(item.id) === String(option?.value),
                        );
                        applyBillTypeSelection(selected);
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* Date Component */}
              <div className="d-flex align-items-center flex-shrink-0">
                <label
                  className="form-label me-2 mb-0 text-nowrap"
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: "600",
                  }}
                >
                  Date:
                </label>
                <input
                  type="date"
                  className={`form-control-date form-control-date-compact form-control-sm ${buttonClass}`}
                  value={billDate}
                  onChange={handleDateChange}
                  style={{ fontSize: "0.85rem" }}
                />
              </div>
              {/* Created By */}
              <div className="d-flex align-items-center flex-shrink-0">
                <label
                  className="form-label me-2 mb-0 text-nowrap"
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: "600",
                  }}
                >
                  Sale By:
                </label>
                <div style={createdByHeaderSelectWrapStyle}>
                  <Select
                    styles={createdByHeaderSelectStyles}
                    classNamePrefix="created-by-select"
                    menuPlacement="bottom"
                    menuPortalTarget={
                      typeof document !== "undefined" ? document.body : null
                    }
                    menuPosition="fixed"
                    isSearchable={true}
                    isClearable={false}
                    isLoading={employeesLoading}
                    options={employeeOptions}
                    value={createdBy}
                    onChange={setCreatedBy}
                    placeholder="Search employee"
                    noOptionsMessage={() => "No employee found"}
                  />
                </div>
              </div>
              {(selecteduserssId || productGroupPoolHeader) && (
                <div className="d-flex align-items-center flex-wrap gap-2 ms-auto">
                  {selecteduserssId && (
                    <>
                      <span
                        className={`badge ${
                          parseFloat(userssDetails.balance) >= 0
                            ? "bg-success-subtle text-success"
                            : "bg-danger-subtle text-danger"
                        }`}
                        style={{ fontSize: "0.85rem" }}
                      >
                        Balance: ₹
                        {parseFloat(userssDetails.balance || 0).toFixed(2)}
                      </span>
                      <span
                        className={`badge ${
                          parseFloat(userssDetails.saleBalance) > 0
                            ? "bg-danger-subtle text-danger"
                            : "bg-success-subtle text-success"
                        } ms-2`}
                        style={{ fontSize: "0.85rem" }}
                      >
                        Pending: ₹
                        {parseFloat(userssDetails.saleBalance || 0).toFixed(2)}
                      </span>
                    </>
                  )}
                  <ProductGroupPoolBalance
                    balance={productGroupPoolHeader}
                    className=""
                  />
                </div>
              )}
            </div>
          </div>
          <div className="card-body">
            <div className="d-flex align-items-center mb-2">
              <input
                id="edit-billed-to"
                type="checkbox"
                className="form-check-input mt-0"
                checked={billedTo}
                onChange={(e) => setBilledTo(e.target.checked)}
              />
              <label
                htmlFor="edit-billed-to"
                className="form-check-label ms-2 mb-0"
                style={{ fontSize: "0.85rem", fontWeight: 600 }}
              >
                Billed to
              </label>
            </div>
            {!billedTo && (
              <div className="row mb-1">
                <div className="col-lg-3 col-md-4 col-sm-6 mb-2">
                  <input
                    type="text"
                    readOnly
                    value={billedMobile}
                    className={`form-control form-control-sm ${buttonClass}`}
                    style={{ fontSize: "0.85rem", backgroundColor: "transparent" }}
                    placeholder="Enter mobile number"
                  />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 mb-2">
                  <input
                    type="text"
                    readOnly
                    value={billedName}
                    className={`form-control form-control-sm ${buttonClass}`}
                    style={{ fontSize: "0.85rem", backgroundColor: "transparent" }}
                    placeholder="Enter customer name"
                  />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 mb-2">
                  <input
                    type="text"
                    readOnly
                    value={billedAddress}
                    className={`form-control form-control-sm ${buttonClass}`}
                    style={{ fontSize: "0.85rem", backgroundColor: "transparent" }}
                    placeholder="Enter address"
                  />
                </div>
                <div className="col-lg-2 col-md-3 col-sm-6 mb-2">
                  <input
                    type="text"
                    readOnly
                    value={billedArea}
                    className={`form-control form-control-sm ${buttonClass}`}
                    style={{ fontSize: "0.85rem", backgroundColor: "transparent" }}
                    placeholder="Enter area"
                  />
                </div>
              </div>
            )}
            <div className="row mb-1">
              {/* userss Mobile */}
              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">
                <div className="d-flex align-items-center">
                  <label
                    className="form-label me-2 mb-0"
                    style={{
                      width: "80px",
                      fontSize: "0.85rem",
                      fontWeight: "600",
                    }}
                  >
                    Customer:
                  </label>
                  <div className="position-relative flex-grow-1">
                    <input
                      ref={userssMobileInputRef}
                      type="text"
                      readOnly
                      value={userssMobileSearchText}
                      onChange={handleuserssMobileChange}
                      onKeyDown={handleuserssMobileKeyDown}
                      onClick={() => setuserssMobileDropdownActive(true)}
                      className={`form-control form-control-sm ${buttonClass}`}
                      style={{
                        fontSize: "0.85rem",
                        backgroundColor: "transparent",
                        transition: "background-color 0.2s",
                      }}
                      onFocus={() => {
                        const inputElement = userssMobileInputRef.current;
                        if (inputElement) {
                          inputElement.style.backgroundColor = "#fff";
                        }
                        setuserssMobileDropdownActive(true);
                      }}
                      onBlur={(e) => {
                        e.target.style.backgroundColor = "transparent";
                      }}
                      autoComplete="off"
                      placeholder="Enter mobile number"
                    />

                    {renderuserssMobileDropdown()}
                  </div>
                </div>
              </div>

              {/* userss Name */}
              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">
                <div className="d-flex align-items-center">
                  <div className="position-relative flex-grow-1">
                    <div className="d-flex align-items-center">
                      <input
                        ref={userssNameInputRef}
                        type="text"
                        readOnly
                        value={userssNameSearchText}
                        onChange={(e) => {
                          setuserssNameSearchText(e.target.value);
                        }}
                        onKeyDown={handleuserssNameKeyDown}
                        onClick={() => setuserssNameDropdownActive(true)}
                        className={`form-control form-control-sm ${buttonClass}`}
                        style={{
                          fontSize: "0.85rem",
                          backgroundColor: "transparent",
                          transition: "background-color 0.2s",
                        }}
                        onFocus={() => {
                          const inputElement = userssNameInputRef.current;
                          if (inputElement) {
                            inputElement.style.backgroundColor = "#fff";
                          }
                          setuserssNameDropdownActive(true);
                        }}
                        onBlur={(e) => {
                          e.target.style.backgroundColor = "transparent";
                        }}
                        autoComplete="off"
                        placeholder="Enter customer name"
                      />
                    </div>
                  </div>
                </div>
                {renderuserssNameDropdown()}
              </div>

              {/* userss Details Modal */}

              {/* userss Address */}
              <div className="col-lg-2 col-md-3 col-sm-6 mb-2">
                <input
                  type="text"
                  readOnly
                  value={userssAddress}
                  className={`form-control form-control-sm ${buttonClass}`}
                  style={{
                    fontSize: "0.85rem",
                    backgroundColor: "transparent",
                    transition: "background-color 0.2s",
                  }}
                  placeholder="Address"
                />
              </div>

              {/* userss Area */}
              <div className="col-lg-2 col-md-3 col-sm-6 mb-2">
                <input
                  type="text"
                  readOnly
                  value={userssArea}
                  className={`form-control form-control-sm ${buttonClass}`}
                  style={{
                    fontSize: "0.85rem",
                    backgroundColor: "transparent",
                    transition: "background-color 0.2s",
                  }}
                  placeholder="Area"
                />
              </div>

              {/* City and Save Button Container - Adjust city visibility based on isNewuserss */}
              <div className="col-lg-2 col-md-3 col-sm-5 mb-2">
                <div className="d-flex align-items-center">
                  {/* Save Button */}
                </div>
              </div>
            </div>

            <div
              className={`table-responsive border ${
                buttonTableStyle === "square" ? "rounded-0" : "rounded-2"
              } mt-3 ${cardClass}`}
            >
              <table
                className={`table table-bordered table-hover table-sm mb-0 theme-header-table ${tableClass}`}
              >
                <thead>
                  <tr>
                    {COLUMNS.map((column) => (
                      <th
                        key={column.id}
                        className="px-2 py-2 text-center"
                        style={{
                          fontSize: "0.85rem",
                          width: column.width,
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {column.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, rowIndex) => (
                    <tr key={row.id} style={{ backgroundColor: "#ffffff" }}>
                      {row.data.map((cell, colIndex) => {
                        // Add special handling for serial number column
                        if (cell.id === "no") {
                          return (
                            <td
                              key={cell.id}
                              className="p-0"
                              style={{ width: COLUMNS[colIndex]?.width }}
                            >
                              <div
                                className="d-flex align-items-center justify-content-center"
                                style={{ height: "38px" }}
                              >
                                <span style={{ fontSize: "0.85rem" }}>
                                  {rowIndex + 1}
                                </span>
                              </div>
                            </td>
                          );
                        }

                        // Check if this is the LWt column and if there are Other Amount entries
                        const hasOtherAmountEntries =
                          row.data.find((c) => c.id === "othAmt")
                            ?.otherAmountEntries?.length > 0;

                        return (
                          <td
                            key={cell.id}
                            className="p-0"
                            style={{
                              width: COLUMNS[colIndex]?.width,
                              position: "relative",
                            }}
                          >
                            {isDropdownColumn(getColumnType(colIndex)) ? (
                              // Dropdown-enabled cell
                              <div className="position-relative">
                                <input
                                  ref={(el) =>
                                    (inputRefs.current[
                                      `${rowIndex}-${colIndex}`
                                    ] = el)
                                  }
                                  type="text"
                                  value={cell.value}
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    const columnType = getColumnType(colIndex);
                                    if (columnType === "productGroup") {
                                      productGroupUserSearchRef.current = true;
                                    }
                                    handleInputChange(
                                      rowIndex,
                                      colIndex,
                                      newValue,
                                    );
                                    if (columnType === "productGroup") {
                                      const hasEnoughChars =
                                        (newValue || "").trim().length >= 3;
                                      if (
                                        hasEnoughChars &&
                                        (getFilteredItems(
                                          newValue,
                                          "productGroup",
                                        ).length > 0 ||
                                          productGroupApiCalled)
                                      ) {
                                        if (
                                          activeDropdown.row === rowIndex &&
                                          activeDropdown.col === colIndex &&
                                          activeDropdown.type === columnType
                                        ) {
                                          handleDropdownClick(
                                            rowIndex,
                                            colIndex,
                                            columnType,
                                          );
                                        } else {
                                          setActiveDropdown({
                                            row: rowIndex,
                                            col: colIndex,
                                            type: columnType,
                                          });
                                        }
                                      } else {
                                        setActiveDropdown({
                                          row: null,
                                          col: null,
                                          type: null,
                                        });
                                      }
                                    } else if (
                                      activeDropdown.row === rowIndex &&
                                      activeDropdown.col === colIndex &&
                                      activeDropdown.type === columnType
                                    ) {
                                      handleDropdownClick(
                                        rowIndex,
                                        colIndex,
                                        columnType,
                                      );
                                    } else {
                                      setActiveDropdown({
                                        row: rowIndex,
                                        col: colIndex,
                                        type: columnType,
                                      });
                                    }
                                  }}
                                  onKeyDown={(e) =>
                                    handleKeyDown(
                                      e,
                                      rowIndex,
                                      colIndex,
                                      getColumnType(colIndex),
                                    )
                                  }
                                  onClick={() => {
                                    const columnType = getColumnType(colIndex);
                                    if (columnType === "productGroup") {
                                      const value = (cell.value || "")
                                        .toString()
                                        .trim();
                                      if (
                                        value.length >= 3 &&
                                        (getFilteredItems(value, "productGroup")
                                          .length > 0 ||
                                          productGroupApiCalled)
                                      ) {
                                        handleDropdownClick(
                                          rowIndex,
                                          colIndex,
                                          columnType,
                                        );
                                      }
                                    } else {
                                      handleDropdownClick(
                                        rowIndex,
                                        colIndex,
                                        columnType,
                                      );
                                    }
                                  }}
                                  className="form-control border-0 rounded-0"
                                  style={{
                                    fontSize: "0.85rem",
                                    padding: "0.4rem 0.5rem",
                                    backgroundColor: "transparent",
                                    width: "100%",
                                    transition: "background-color 0.2s",
                                  }}
                                  onFocus={() =>
                                    handleFocus(rowIndex, colIndex)
                                  }
                                  onBlur={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                  autoComplete="off"
                                />
                              </div>
                            ) : isImageColumn(getColumnType(colIndex)) ? (
                              <div
                                className="position-relative d-flex align-items-center justify-content-center"
                                style={{ height: "38px" }}
                              >
                                <input
                                  type="file"
                                  accept="image/*"
                                  ref={(el) =>
                                    (fileInputRefs.current[
                                      `${rowIndex}-${colIndex}`
                                    ] = el)
                                  }
                                  style={{ display: "none" }}
                                  onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (!file) return;

                                    // Check if file is an image
                                    if (!file.type.match("image.*")) {
                                      alert("Please select an image file");
                                      return;
                                    }

                                    // Check file size (limit to 5MB)
                                    if (file.size > 5 * 1024 * 1024) {
                                      alert("File size should not exceed 5MB");
                                      return;
                                    }

                                    handleImageUpload(file, rowIndex);
                                  }}
                                />
                                {cell.imagePreview ? (
                                  <div
                                    className="position-relative"
                                    style={{ height: "38px" }}
                                  >
                                    <div
                                      className="d-flex justify-content-center align-items-center h-100"
                                      onMouseEnter={(e) => {
                                        // Clear any existing timeout
                                        if (tooltipTimeoutRef.current) {
                                          clearTimeout(
                                            tooltipTimeoutRef.current,
                                          );
                                          tooltipTimeoutRef.current = null;
                                        }

                                        // Hide all tooltips first
                                        Object.values(
                                          tooltipRefs.current,
                                        ).forEach((tooltip) => {
                                          if (tooltip)
                                            tooltip.style.display = "none";
                                        });

                                        const tooltipId = `tooltip-${rowIndex}-${colIndex}`;
                                        const tooltip =
                                          tooltipRefs.current[tooltipId];

                                        if (tooltip) {
                                          // Get the position of the image
                                          const rect =
                                            e.currentTarget.getBoundingClientRect();

                                          // Position the tooltip centered below the image
                                          tooltip.style.position = "fixed";
                                          tooltip.style.left =
                                            rect.left +
                                            rect.width / 2 -
                                            100 +
                                            "px"; // Center horizontally (tooltip width is 200px)
                                          tooltip.style.top =
                                            rect.bottom + 10 + "px"; // Position below the image
                                          tooltip.style.display = "block";
                                          // Set this as the active tooltip
                                          setActiveTooltip(tooltipId);
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        // Set a timeout before hiding the tooltip
                                        tooltipTimeoutRef.current = setTimeout(
                                          () => {
                                            // Only hide if this is still the active tooltip
                                            const tooltipId = `tooltip-${rowIndex}-${colIndex}`;
                                            if (activeTooltip === tooltipId) {
                                              const tooltip =
                                                tooltipRefs.current[tooltipId];
                                              if (tooltip) {
                                                tooltip.style.display = "none";
                                              }
                                              setActiveTooltip(null);
                                            }
                                          },
                                          300,
                                        ); // Delay to allow moving to tooltip
                                      }}
                                    >
                                      <img
                                        src={cell.imagePreview}
                                        alt="Preview"
                                        className="img-thumbnail"
                                        style={{
                                          height: "30px",
                                          width: "30px",
                                          objectFit: "cover",
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openImageModal(cell.imagePreview);
                                        }}
                                      />
                                    </div>

                                    {/* Hover preview tooltip */}
                                    <div
                                      ref={(el) =>
                                        (tooltipRefs.current[
                                          `tooltip-${rowIndex}-${colIndex}`
                                        ] = el)
                                      }
                                      className="shadow rounded p-3 bg-white"
                                      style={{
                                        display: "none",
                                        width: "200px",
                                        zIndex: 9999,
                                        position: "fixed", // Use fixed positioning to escape table constraints
                                      }}
                                      onMouseEnter={(e) => {
                                        // Clear any existing timeout when entering the tooltip
                                        if (tooltipTimeoutRef.current) {
                                          clearTimeout(
                                            tooltipTimeoutRef.current,
                                          );
                                          tooltipTimeoutRef.current = null;
                                        }

                                        // Make sure this is the only visible tooltip
                                        const currentTooltipId = `tooltip-${rowIndex}-${colIndex}`;
                                        Object.entries(
                                          tooltipRefs.current,
                                        ).forEach(([id, tooltip]) => {
                                          if (
                                            tooltip &&
                                            id !== currentTooltipId
                                          ) {
                                            tooltip.style.display = "none";
                                          }
                                        });

                                        e.currentTarget.style.display = "block";
                                        setActiveTooltip(currentTooltipId);
                                      }}
                                      onMouseLeave={(e) => {
                                        // Hide immediately when leaving the tooltip itself
                                        e.currentTarget.style.display = "none";
                                        setActiveTooltip(null);
                                      }}
                                    >
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "-8px",
                                          left: "50%",
                                          transform: "translateX(-50%)",
                                          width: "16px",
                                          height: "8px",
                                          overflow: "hidden",
                                        }}
                                      >
                                        <div
                                          className="bg-white border"
                                          style={{
                                            position: "absolute",
                                            top: "0",
                                            left: "0",
                                            width: "16px",
                                            height: "16px",
                                            transform: "rotate(45deg)",
                                            boxShadow:
                                              "-2px -2px 2px rgba(0,0,0,0.1)",
                                            borderRight: "none",
                                            borderBottom: "none",
                                          }}
                                        ></div>
                                      </div>
                                      <div className="text-center mb-3">
                                        <img
                                          src={cell.imagePreview}
                                          alt="Preview"
                                          className="img-fluid rounded"
                                          style={{
                                            maxHeight: "100px",
                                            objectFit: "contain",
                                          }}
                                        />
                                      </div>
                                      <div className="d-flex justify-content-center gap-2">
                                        <Button
                                          variant="primary"
                                          size="sm"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            triggerFileInput(
                                              rowIndex,
                                              colIndex,
                                            );
                                          }}
                                          title="Change Image"
                                        >
                                          <Icon
                                            icon="solar:gallery-edit-bold"
                                            width="16"
                                            height="16"
                                          />
                                        </Button>
                                        <Button
                                          variant="danger"
                                          size="sm"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setTableData((prevData) => {
                                              const updatedData = [...prevData];
                                              const imageCell = updatedData[
                                                rowIndex
                                              ].data.find(
                                                (c) => c.id === "image",
                                              );
                                              if (imageCell) {
                                                imageCell.value = "";
                                                imageCell.imageFile = null;
                                                imageCell.imagePreview = null;
                                              }
                                              return updatedData;
                                            });
                                          }}
                                          title="Remove Image"
                                        >
                                          <Icon
                                            icon="solar:trash-bin-trash-bold"
                                            width="16"
                                            height="16"
                                          />
                                        </Button>
                                        <Button
                                          variant="primary"
                                          size="sm"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            openImageModal(cell.imagePreview);
                                          }}
                                          title="View Image"
                                        >
                                          <Icon
                                            icon="solar:eye-bold"
                                            width="16"
                                            height="16"
                                          />
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={() =>
                                      triggerFileInput(rowIndex, colIndex)
                                    }
                                    title="Upload Image"
                                  >
                                    <Icon
                                      icon="solar:gallery-add-bold"
                                      width="16"
                                      height="16"
                                    />
                                  </Button>
                                )}
                              </div>
                            ) : getColumnType(colIndex) === "lsWt" ? (
                              <div className="d-flex align-items-center position-relative">
                                <input
                                  ref={(el) =>
                                    (inputRefs.current[
                                      `${rowIndex}-${colIndex}`
                                    ] = el)
                                  }
                                  type="text"
                                  value={cell.value}
                                  onChange={(e) => {
                                    // Only allow changes if there are no Other Amount entries
                                    if (!hasOtherAmountEntries) {
                                      const value = e.target.value;
                                      if (
                                        value === "" ||
                                        /^\d*\.?\d*$/.test(value)
                                      ) {
                                        handleInputChange(
                                          rowIndex,
                                          colIndex,
                                          value,
                                        );
                                      }
                                    }
                                  }}
                                  className="form-control border-0 rounded-0"
                                  style={{
                                    fontSize: "0.85rem",
                                    padding: "0.4rem 0.5rem",
                                    backgroundColor: "transparent",
                                    width: "100%",
                                    transition: "background-color 0.2s",
                                    cursor: hasOtherAmountEntries
                                      ? "not-allowed"
                                      : "text",
                                  }}
                                  onFocus={(e) => {
                                    if (!hasOtherAmountEntries) {
                                      handleFocus(rowIndex, colIndex);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                  readOnly={hasOtherAmountEntries}
                                  title={
                                    hasOtherAmountEntries
                                      ? "This value is calculated from Other Amount entries"
                                      : ""
                                  }
                                />
                              </div>
                            ) : getColumnType(colIndex) === "othAmt" ? (
                              <div className="d-flex align-items-center position-relative">
                                <input
                                  ref={(el) =>
                                    (inputRefs.current[
                                      `${rowIndex}-${colIndex}`
                                    ] = el)
                                  }
                                  type="text"
                                  value={cell.value}
                                  onChange={(e) => {
                                    // Only allow changes if there are no entries
                                    if (!cell.otherAmountEntries?.length) {
                                      const value = e.target.value;
                                      if (
                                        value === "" ||
                                        /^\d*\.?\d*$/.test(value)
                                      ) {
                                        handleInputChange(
                                          rowIndex,
                                          colIndex,
                                          value,
                                        );
                                      }
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    handleKeyDown(
                                      e,
                                      rowIndex,
                                      colIndex,
                                      getColumnType(colIndex),
                                    );
                                    handleOtherAmountInteraction(rowIndex, e);
                                  }}
                                  onDoubleClick={(e) =>
                                    handleOtherAmountInteraction(rowIndex, e)
                                  }
                                  className="form-control border-0 rounded-0"
                                  style={{
                                    fontSize: "0.85rem",
                                    padding: "0.4rem 0.5rem",
                                    backgroundColor: "transparent",
                                    width: "100%",
                                    transition: "background-color 0.2s",
                                    cursor: "pointer",
                                  }}
                                  onFocus={() =>
                                    handleFocus(rowIndex, colIndex)
                                  }
                                  onBlur={(e) =>
                                    (e.target.style.backgroundColor =
                                      "transparent")
                                  }
                                  title={
                                    cell.otherAmountEntries?.length > 0
                                      ? "Double-click or press Enter twice to edit details"
                                      : "Enter amount directly or double-click/press Enter twice for details"
                                  }
                                />

                                {cell.otherAmountEntries?.length > 0 && (
                                  <div className="position-relative">
                                    <Button
                                      variant="link"
                                      className="p-0 px-1 text-primary"
                                      style={{
                                        fontSize: "1rem",
                                        position: "absolute",
                                        right: "5px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        zIndex: 1,
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        const tooltipId = `oth-amt-tooltip-${rowIndex}`;
                                        const tooltip =
                                          tooltipRefs.current[tooltipId];

                                        if (tooltip) {
                                          // If tooltip is already visible, hide it
                                          if (
                                            tooltip.style.display === "block"
                                          ) {
                                            tooltip.style.display = "none";
                                            setActiveTooltip(null);

                                            // Clear any existing timeout
                                            if (tooltipTimeoutRef.current) {
                                              clearTimeout(
                                                tooltipTimeoutRef.current,
                                              );
                                              tooltipTimeoutRef.current = null;
                                            }
                                            return;
                                          }

                                          // Hide any other visible tooltips first
                                          Object.entries(
                                            tooltipRefs.current,
                                          ).forEach(([id, t]) => {
                                            if (t && id !== tooltipId) {
                                              t.style.display = "none";
                                            }
                                          });

                                          // Position and show tooltip
                                          positionTooltip(
                                            e.currentTarget,
                                            tooltip,
                                          );

                                          // Set this as the active tooltip
                                          setActiveTooltip(tooltipId);

                                          // Set timeout to hide after 4 seconds
                                          if (tooltipTimeoutRef.current) {
                                            clearTimeout(
                                              tooltipTimeoutRef.current,
                                            );
                                          }

                                          tooltipTimeoutRef.current =
                                            setTimeout(() => {
                                              if (tooltip) {
                                                tooltip.style.display = "none";
                                                setActiveTooltip(null);
                                                tooltipTimeoutRef.current =
                                                  null;
                                              }
                                            }, 4000);
                                        }
                                      }}
                                      onMouseEnter={(e) => {
                                        // Don't show on hover if already showing from a click
                                        if (tooltipTimeoutRef.current) return;

                                        const tooltipId = `oth-amt-tooltip-${rowIndex}`;
                                        const tooltip =
                                          tooltipRefs.current[tooltipId];

                                        if (tooltip) {
                                          // Hide any other visible tooltips first
                                          Object.entries(
                                            tooltipRefs.current,
                                          ).forEach(([id, t]) => {
                                            if (t && id !== tooltipId) {
                                              t.style.display = "none";
                                            }
                                          });

                                          // Position and show tooltip
                                          positionTooltip(
                                            e.currentTarget,
                                            tooltip,
                                          );

                                          // Set this as the active tooltip
                                          setActiveTooltip(tooltipId);
                                        }
                                      }}
                                      onMouseLeave={() => {
                                        // Only hide if not in clicked mode
                                        if (tooltipTimeoutRef.current) return;

                                        const tooltipId = `oth-amt-tooltip-${rowIndex}`;
                                        const tooltip =
                                          tooltipRefs.current[tooltipId];

                                        if (
                                          tooltip &&
                                          activeTooltip === tooltipId
                                        ) {
                                          // Use setTimeout to allow moving to the tooltip
                                          setTimeout(() => {
                                            // Only hide if we're not hovering over the tooltip itself
                                            if (
                                              activeTooltip === tooltipId &&
                                              !tooltip.matches(":hover") &&
                                              !tooltipTimeoutRef.current
                                            ) {
                                              tooltip.style.display = "none";
                                              setActiveTooltip(null);
                                            }
                                          }, 100);
                                        }
                                      }}
                                    >
                                      <Icon icon="solar:info-circle-bold" />
                                    </Button>

                                    {/* Other Amount Details Tooltip */}
                                    <div
                                      ref={(el) =>
                                        (tooltipRefs.current[
                                          `oth-amt-tooltip-${rowIndex}`
                                        ] = el)
                                      }
                                      className="shadow-lg rounded p-2 bg-white tooltip-container"
                                      style={{
                                        display: "none",
                                        width: "auto",
                                        maxWidth: "250px",
                                        zIndex: 9999,
                                        position: "fixed",
                                      }}
                                      onMouseEnter={() => {
                                        // Do nothing when hovering tooltip
                                        // This prevents the tooltip from disappearing
                                      }}
                                      onMouseLeave={(e) => {
                                        // Only hide if not in clicked mode
                                        if (tooltipTimeoutRef.current) return;

                                        const tooltipId = `oth-amt-tooltip-${rowIndex}`;
                                        if (activeTooltip === tooltipId) {
                                          e.currentTarget.style.display =
                                            "none";
                                          setActiveTooltip(null);
                                        }
                                      }}
                                    >
                                      <div
                                        className="tooltip-arrow"
                                        style={{
                                          position: "absolute",
                                          width: "12px",
                                          height: "12px",
                                          backgroundColor: "white",
                                          border: "1px solid rgba(0,0,0,0.1)",
                                          transform: "rotate(45deg)",
                                          borderRight: "none",
                                          borderBottom: "none",
                                          boxShadow:
                                            "-2px -2px 2px rgba(0,0,0,0.1)",
                                        }}
                                      ></div>
                                      <div
                                        className="other-amount-details"
                                        style={{
                                          maxHeight: "200px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {cell.otherAmountEntries.map(
                                          (entry, idx) => (
                                            <div
                                              key={idx}
                                              className="d-flex justify-content-between py-1"
                                              style={{
                                                borderBottom:
                                                  idx !==
                                                  cell.otherAmountEntries
                                                    .length -
                                                    1
                                                    ? "1px solid #eee"
                                                    : "none",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontSize: "0.85rem",
                                                  flex: "1",
                                                  marginRight: "20px",
                                                }}
                                              >
                                                {entry.chargeType}
                                              </span>
                                              <span
                                                style={{
                                                  fontSize: "0.85rem",
                                                  minWidth: "80px",
                                                  textAlign: "right",
                                                }}
                                              >
                                                ₹{" "}
                                                {Number(entry.amount).toFixed(
                                                  2,
                                                )}
                                              </span>
                                            </div>
                                          ),
                                        )}
                                        <div className="mt-2 pt-2 border-top">
                                          <div className="d-flex justify-content-between">
                                            <strong className="text-dark">
                                              Total
                                            </strong>
                                            <strong className="text-dark">
                                              ₹{" "}
                                              {cell.otherAmountEntries
                                                .reduce(
                                                  (sum, entry) =>
                                                    sum + Number(entry.amount),
                                                  0,
                                                )
                                                .toFixed(2)}
                                            </strong>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            ) : getColumnType(colIndex) === "lsWt" ? (
                              <div className="d-flex align-items-center position-relative">
                                <input
                                  ref={(el) =>
                                    (inputRefs.current[
                                      `${rowIndex}-${colIndex}`
                                    ] = el)
                                  }
                                  type="text"
                                  value={cell.value}
                                  onChange={(e) => {
                                    // Only allow changes if there are no Other Amount entries
                                    if (!hasOtherAmountEntries) {
                                      const value = e.target.value;
                                      if (
                                        value === "" ||
                                        /^\d*\.?\d*$/.test(value)
                                      ) {
                                        handleInputChange(
                                          rowIndex,
                                          colIndex,
                                          value,
                                        );
                                      }
                                    }
                                  }}
                                  className="form-control border-0 rounded-0"
                                  style={{
                                    fontSize: "0.85rem",
                                    padding: "0.4rem 0.5rem",
                                    backgroundColor: "transparent",
                                    width: "100%",
                                    transition: "background-color 0.2s",
                                    cursor: hasOtherAmountEntries
                                      ? "not-allowed"
                                      : "text",
                                  }}
                                  onFocus={(e) => {
                                    if (!hasOtherAmountEntries) {
                                      handleFocus(rowIndex, colIndex);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.backgroundColor =
                                      "transparent";
                                  }}
                                  readOnly={hasOtherAmountEntries}
                                  title={
                                    hasOtherAmountEntries
                                      ? "This value is calculated from Other Amount entries"
                                      : ""
                                  }
                                />
                              </div>
                            ) : getColumnType(colIndex) === "totalAmt" ? (
                              <input
                                ref={(el) =>
                                  (inputRefs.current[
                                    `${rowIndex}-${colIndex}`
                                  ] = el)
                                }
                                type="text"
                                value={cell.value}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (
                                    value === "" ||
                                    /^\d*\.?\d*$/.test(value)
                                  ) {
                                    handleInputChange(
                                      rowIndex,
                                      colIndex,
                                      value,
                                    );
                                  }
                                }}
                                onKeyDown={(e) =>
                                  handleTotalAmountInteraction(rowIndex, e)
                                }
                                onDoubleClick={(e) =>
                                  handleTotalAmountInteraction(rowIndex, e)
                                }
                                className="form-control border-0 rounded-0"
                                style={{
                                  fontSize: "0.85rem",
                                  padding: "0.4rem 0.5rem",
                                  backgroundColor: "transparent",
                                  width: "100%",
                                  transition: "background-color 0.2s",
                                  cursor: "pointer",
                                }}
                                onFocus={() => handleFocus(rowIndex, colIndex)}
                                onBlur={(e) => {
                                  e.target.style.backgroundColor =
                                    "transparent";
                                  const raw = parseFloat(cell.value);
                                  if (
                                    cell.value !== "" &&
                                    !Number.isNaN(raw)
                                  ) {
                                    const rounded = roundLineTotalAmount(raw);
                                    if (rounded !== String(cell.value)) {
                                      handleInputChange(
                                        rowIndex,
                                        colIndex,
                                        rounded,
                                      );
                                    }
                                  }
                                }}
                                title="Double-click or press Enter twice to open GST settlement"
                              />
                            ) : (
                              <input
                                ref={(el) =>
                                  (inputRefs.current[
                                    `${rowIndex}-${colIndex}`
                                  ] = el)
                                }
                                type="text"
                                value={cell.value}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const columnType = COLUMNS[colIndex].id;

                                  // Special handling for design field - allow alphanumeric
                                  if (columnType === "design") {
                                    handleInputChange(
                                      rowIndex,
                                      colIndex,
                                      value,
                                    );
                                  }
                                  // For numeric fields only allow numbers and decimal
                                  else if (
                                    value === "" ||
                                    /^\d*\.?\d*$/.test(value)
                                  ) {
                                    handleInputChange(
                                      rowIndex,
                                      colIndex,
                                      value,
                                    );
                                  }
                                }}
                                // disabled={COLUMNS[colIndex].id === "grWt"}
                                className="form-control border-0 rounded-0"
                                style={{
                                  fontSize: "0.85rem",
                                  padding: "0.4rem 0.5rem",
                                  backgroundColor: "transparent",
                                  width: "100%",
                                  transition: "background-color 0.2s",
                                  cursor: "text", // Change cursor to indicate it's editable
                                }}
                                onFocus={() => handleFocus(rowIndex, colIndex)}
                                onBlur={(e) => {
                                  e.target.style.backgroundColor =
                                    "transparent";
                                }}
                              />
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                  {/* Add Totals Row */}
                  <tr style={{ backgroundColor: "#f8f9fa" }}>
                    {/* No. */}
                    <td className="p-0" style={{ width: COLUMNS[0]?.width }}>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          Total
                        </span>
                      </div>
                    </td>
                    <td className="p-0"></td> {/* Tag No */}
                    <td className="p-0"></td> {/* Product Group */}
                    <td className="p-0"></td> {/* Design */}
                    <td className="p-0"></td> {/* Size */}
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      {/* Pcs */}
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableData.reduce((sum, row) => {
                            const pcs = parseFloat(
                              row.data.find((cell) => cell.id === "pcs")
                                ?.value || 0,
                            );
                            return sum + (isNaN(pcs) ? 0 : pcs);
                          }, 0)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      {/* GWt */}
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const gwt = parseFloat(
                                row.data.find((cell) => cell.id === "grWt")
                                  ?.value || 0,
                              );
                              return sum + (isNaN(gwt) ? 0 : gwt);
                            }, 0)
                            .toFixed(2)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      {/* LWt */}
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const lwt = parseFloat(
                                row.data.find((cell) => cell.id === "lsWt")
                                  ?.value || 0,
                              );
                              return sum + (isNaN(lwt) ? 0 : lwt);
                            }, 0)
                            .toFixed(2)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      {/* NWt */}
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const nwt = parseFloat(
                                row.data.find((cell) => cell.id === "netWt")
                                  ?.value || 0,
                              );
                              return sum + (isNaN(nwt) ? 0 : nwt);
                            }, 0)
                            .toFixed(2)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0"></td> {/* ItRateOn */}
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      {/* ItRate */}
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {/* Average item rate - not sum */}
                          {tableData.length > 0
                            ? (
                                tableData.reduce((sum, row) => {
                                  const itRate = parseFloat(
                                    row.data.find(
                                      (cell) => cell.id === "itRate",
                                    )?.value || 0,
                                  );
                                  return sum + (isNaN(itRate) ? 0 : itRate);
                                }, 0) / tableData.length
                              ).toFixed(2)
                            : "0.00"}
                        </span>
                      </div>
                    </td>
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      {/* ItAmt */}
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const itAmt = parseFloat(
                                row.data.find((cell) => cell.id === "itAmt")
                                  ?.value || 0,
                              );
                              return sum + (isNaN(itAmt) ? 0 : itAmt);
                            }, 0)
                            .toFixed(2)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0"></td> {/* Lbr Type */}
                    <td className="p-0"></td> {/* Lbr % */}
                    <td className="p-0"></td> {/* Lbr Rate */}
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      {/* Lbr Amt */}
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const lbrAmt = parseFloat(
                                row.data.find((cell) => cell.id === "lbrAmt")
                                  ?.value || 0,
                              );
                              return sum + (isNaN(lbrAmt) ? 0 : lbrAmt);
                            }, 0)
                            .toFixed(2)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      {/* OthAmt */}
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const othAmt = parseFloat(
                                row.data.find((cell) => cell.id === "othAmt")
                                  ?.value || 0,
                              );
                              return sum + (isNaN(othAmt) ? 0 : othAmt);
                            }, 0)
                            .toFixed(2)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      {/* MRP */}
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableData
                            .reduce((sum, row) => {
                              const mrp = parseFloat(
                                row.data.find((cell) => cell.id === "mrp")
                                  ?.value || 0,
                              );
                              return sum + (isNaN(mrp) ? 0 : mrp);
                            }, 0)
                            .toFixed(2)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0"></td> {/* Image */}
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      {/* TotalAmt */}
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {calculateTotal().toFixed(2)}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="text-end mt-3">
              {/* <button className="btn btn-primary" onClick={handleSubmit}>
                Add
              </button> */}
            </div>

            <PaymentSection
              paymentRows={paymentRows}
              onPaymentRowsChange={setPaymentRows}
              paymentTypes={paymentTypes}
              bankAccounts={bankAccounts}
              onOpenUrdFromPaymentRow={openUrdFromPaymentRow}
              payableRows={payableRows}
              onPayableRowsChange={setPayableRows}
              note={note}
              onNoteChange={setNote}
              showDeliverySection
              applyDeliveryToday={applyDeliveryToday}
              onApplyDeliveryTodayChange={setApplyDeliveryToday}
              deliveryProducts={tableData
                .map((row) => {
                  const tagCell = row.data.find((c) => c.id === "tagNo");
                  const tag = (tagCell?.value || "").toString().trim();
                  if (!tag) return null;
                  return { key: tag, label: tag };
                })
                .filter(Boolean)}
              perItemDeliveryToday={perItemDeliveryToday}
              onPerItemDeliveryTodayChange={setPerItemDeliveryToday}
              finalAmount={calculateTotal().toFixed(2)}
              discountType={discountType}
              onDiscountTypeChange={setDiscountType}
              discountValue={discountValue}
              onDiscountValueChange={setDiscountValue}
              discountAmount={calculateDiscountAmount().toFixed(2)}
              gstPercentage={gstPercentage}
              onGstPercentageChange={setGstPercentage}
              gstAmount={calculateGstAmount().total.toFixed(2)}
              roundOffAmount={roundOffAmount}
              onRoundOffChange={handleRoundOffChange}
              grandTotal={calculateGrandTotal()}
              totalPaid={calculatePaymentTotal()}
              payableAmount={calculatePayableAmount()}
              remainingAmount={calculateRemainingAmount()}
              followUpDate={followUpDate}
              onFollowUpDateChange={setFollowUpDate}
              buttonClass={buttonClass}
              cardClass={cardClass}
              buttonTableStyle={buttonTableStyle}
            />

            {/* Submit button at the bottom */}
            <div className="row mt-4">
              <div className="col-12">
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                  <div className="d-flex flex-wrap align-items-center">
                    <div className="form-check me-3 mb-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="printCheckbox"
                      />
                      <label
                        className="form-check-label d-flex align-items-center"
                        htmlFor="printCheckbox"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          >
                            <path d="M17 17h2a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2m10-8V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v4" />
                            <path d="M7 15a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2z" />
                          </g>
                        </svg>
                        <span className="ms-2 d-none d-sm-inline">Print</span>
                      </label>
                    </div>
                    <div className="form-check me-3 mb-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="pdfCheckbox"
                      />
                      <label
                        className="form-check-label d-flex align-items-center"
                        htmlFor="pdfCheckbox"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          >
                            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                            <path d="M5 12V5a2 2 0 0 1 2-2h7l5 5v4M5 18h1.5a1.5 1.5 0 0 0 0-3H5v6m12-3h2m1-3h-3v6m-6-6v6h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2z" />
                          </g>
                        </svg>
                        <span className="ms-2 d-none d-sm-inline">PDF</span>
                      </label>
                    </div>
                    <div className="form-check me-3 mb-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="whatsappCheckbox"
                      />
                      <label
                        className="form-check-label d-flex align-items-center"
                        htmlFor="whatsappCheckbox"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          >
                            <path d="m3 21l1.65-3.8a9 9 0 1 1 3.4 2.9z" />
                            <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0za5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1" />
                          </g>
                        </svg>
                        <span className="ms-2 d-none d-sm-inline">
                          WhatsApp
                        </span>
                      </label>
                    </div>
                    <div className="form-check me-3 mb-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="emailCheckbox"
                      />
                      <label
                        className="form-check-label d-flex align-items-center"
                        htmlFor="emailCheckbox"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          >
                            <path d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                            <path d="m3 7l9 6l9-6" />
                          </g>
                        </svg>
                        <span className="ms-2 d-none d-sm-inline">Email</span>
                      </label>
                    </div>
                  </div>
                  <button
                    className={`btn btn-primary ${buttonClass}`}
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        />
                        Saving...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {renderDropdown()}
      {renderImageModal()}
      <OtherAmountModal
        otherAmountModal={otherAmountModal}
        setOtherAmountModal={setOtherAmountModal}
        cardClass={cardClass}
        otherAmountColumnWidths={otherAmountColumnWidths}
        handleOtherAmountColumnWidthChange={handleOtherAmountColumnWidthChange}
        suggestions={suggestions}
        setSuggestions={setSuggestions}
        getSuggestions={getSuggestions}
        formatAmount={formatAmount}
        calculateAmount={calculateAmount}
        rateOnOptions={rateOnOptions}
        highlightedIndex={highlightedIndex}
        setHighlightedIndex={setHighlightedIndex}
        handleRateOnDropdown={handleRateOnDropdown}
        handleRateOnKeyDown={handleRateOnKeyDown}
        calculateLessWeight={calculateLessWeight}
        formatLessWeight={formatLessWeight}
        calculateTotal={sumOtherAmountEntries}
        buttonClass={buttonClass}
        handleSaveOtherAmountEntries={handleSaveOtherAmountEntries}
        setTableData={setTableData}
      />
      <OldPurchaseModal
        show={urdModalState.isOpen}
        onClose={() => setUrdModalState((prev) => ({ ...prev, isOpen: false }))}
        onSave={handleSaveUrdPurchase}
        initialData={
          urdModalState.row?.urd_data ||
          oldPurchases.find(
            (p) =>
              (urdModalState.row?.id != null && p.paymentRowId === urdModalState.row?.id) ||
              p.pay_mode === urdModalState.payMode,
          ) ||
          null
        }
        payMode={urdModalState.payMode}
        paymentRowId={urdModalState.row?.id}
        masterGoldRate={masterGoldRate}
        masterSilverRate={masterSilverRate}
        showLiveRate={showLiveRate}
      />
      {renderTotalAmountModal()}
      {/* <p>Master Gold Rate: {masterGoldRate}</p>
      <p>Master Silver Rate: {masterSilverRate}</p> */}
      <Toaster position="top-center" />
    </div>
  );
};

export default EditInvoice;
